import cn from "@/utils/cn";

export const PremiumCardMinimize = ({ className = "" }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.325 0.5L13.175 0.5C18.05 0.5 20 2.46681 20 7.38384L20 13.2843C20 18.2013 18.05 20.1681 13.175 20.1681L7.325 20.1681C2.45 20.1681 0.5 18.2013 0.5 13.2843L0.5 7.38384C0.5 2.46681 2.45 0.5 7.325 0.5Z"
        stroke="#EDF2F6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.67285 10.2039H14.7346"
        stroke="white"
        strokeWidth="1.69"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PremiumCardExpand = ({ className = "" }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.325 0.5L13.175 0.5C18.05 0.5 20 2.46681 20 7.38384L20 13.2843C20 18.2013 18.05 20.1681 13.175 20.1681L7.325 20.1681C2.45 20.1681 0.5 18.2013 0.5 13.2843L0.5 7.38384C0.5 2.46681 2.45 0.5 7.325 0.5Z"
        stroke="#EDF2F6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.67285 10.2039H14.7346"
        stroke="white"
        strokeWidth="1.69"
        strokeLinecap="round"
      />
      <path
        d="M10.2031 5.67383V14.7355"
        stroke="white"
        strokeWidth="1.69"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EditDashboardAlertIcon = ({ className = "" }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 0C2.24 0 0 2.23 0 5C0 7.77 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.77 0 5 0Z"
        fill="#FA5A7D"
      />
      <rect
        x="4.00977"
        y="1.99414"
        width="1.98155"
        height="3.92456"
        rx="0.990776"
        fill="white"
      />
      <rect
        x="4.00977"
        y="6.5498"
        width="1.98"
        height="1.98"
        rx="0.99"
        fill="white"
      />
    </svg>
  );
};

export const EditDashboardMinusIcon = ({ className = "" }) => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <ellipse
        cx="16.2316"
        cy="16.2316"
        rx="16.2316"
        ry="16.2316"
        fill="#FA5A7D"
      />
      <rect
        x="24.2461"
        y="14.9736"
        width="2.51637"
        height="16.0298"
        rx="1.25818"
        transform="rotate(90 24.2461 14.9736)"
        fill="white"
      />
    </svg>
  );
};

export const EditDashboardPlusIcon = ({ className = "" }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <ellipse
        cx="14.8327"
        cy="14.8327"
        rx="14.8327"
        ry="14.8327"
        fill="#00E096"
      />
      <rect
        x="13.6816"
        y="7.5083"
        width="2.2995"
        height="14.6483"
        rx="1.14975"
        fill="white"
      />
      <rect
        x="22.1562"
        y="13.6831"
        width="2.2995"
        height="14.6483"
        rx="1.14975"
        transform="rotate(90 22.1562 13.6831)"
        fill="white"
      />
    </svg>
  );
};

export const LeadEngineReset = ({ className = "" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.83305 3.81005C7.48555 3.61505 8.20555 3.48755 9.00055 3.48755C12.593 3.48755 15.503 6.39755 15.503 9.99005C15.503 13.5825 12.593 16.4925 9.00055 16.4925C5.40805 16.4925 2.49805 13.5825 2.49805 9.99005C2.49805 8.65505 2.90305 7.41005 3.59305 6.37505"
        stroke="#444A6D"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.90234 3.99L8.06984 1.5"
        stroke="#444A6D"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.90234 3.98999L8.42984 5.83499"
        stroke="#444A6D"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FormEditorArrowDown = ({ className = "" }) => {
  return (
    <svg
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.77833 5.73167C5.31167 5.73167 4.845 5.55167 4.49167 5.19833L0.145 0.851666C-0.0483333 0.658333 -0.0483333 0.338333 0.145 0.145C0.338333 -0.0483333 0.658333 -0.0483333 0.851667 0.145L5.19833 4.49167C5.51833 4.81167 6.03833 4.81167 6.35833 4.49167L10.705 0.145C10.8983 -0.0483333 11.2183 -0.0483333 11.4117 0.145C11.605 0.338333 11.605 0.658333 11.4117 0.851666L7.065 5.19833C6.71167 5.55167 6.245 5.73167 5.77833 5.73167Z"
        fill="#25282C"
      />
    </svg>
  );
};

export const FormEditorReset = ({ className = "" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.1243 2.85751C5.61367 2.71126 6.15367 2.61563 6.74992 2.61563C9.4443 2.61563 11.6268 4.79813 11.6268 7.49251C11.6268 10.1869 9.4443 12.3694 6.74992 12.3694C4.05555 12.3694 1.87305 10.1869 1.87305 7.49251C1.87305 6.49126 2.1768 5.55751 2.6943 4.78126"
        stroke="#979797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.42578 2.9925L6.05141 1.125"
        stroke="#979797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.42578 2.99249L6.32141 4.37624"
        stroke="#979797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FormEditorPlus = ({ className = "" }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="5.48047"
        width="2.04083"
        height="13.0005"
        rx="1.02041"
        fill="#444A6D"
      />
      <rect
        x="13"
        y="5.47983"
        width="2.04083"
        height="13.0005"
        rx="1.02041"
        transform="rotate(90 13 5.47983)"
        fill="#444A6D"
      />
    </svg>
  );
};

export const FormEditorMinus = ({ className = "" }) => {
  return (
    <svg
      width="13"
      height="3"
      viewBox="0 0 13 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="13"
        width="2.04083"
        height="13.0005"
        rx="1.02041"
        transform="rotate(90 13 0)"
        fill="white"
      />
    </svg>
  );
};

export const FormEditorRightArrow = ({ className = "" }) => {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.291447 12.2652C-0.0971489 11.8766 -0.0971489 11.24 0.291447 10.8515L4.63811 6.50478C4.76285 6.38005 4.76285 6.17663 4.63811 6.05189L0.291447 1.70522C-0.0971488 1.31663 -0.0971488 0.680046 0.291447 0.291451C0.680042 -0.0971441 1.31662 -0.0971441 1.70522 0.291451L6.05189 4.63812C6.50218 5.08841 6.73167 5.68365 6.73167 6.27834C6.73167 6.87303 6.50218 7.46826 6.05189 7.91856L1.70522 12.2652C1.31662 12.6538 0.680042 12.6538 0.291447 12.2652Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FormEditorLeftArrow = ({ className = "" }) => {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.44098 0.291447C6.82957 0.680042 6.82957 1.31662 6.44098 1.70522L2.09431 6.05189C1.96957 6.17662 1.96957 6.38004 2.09431 6.50478L6.44098 10.8514C6.82957 11.24 6.82957 11.8766 6.44098 12.2652C6.05238 12.6538 5.4158 12.6538 5.0272 12.2652L0.680535 7.91855C0.230239 7.46826 0.000755869 6.87302 0.000755862 6.27833C0.000755855 5.68364 0.230239 5.08841 0.680535 4.63811L5.0272 0.291447C5.4158 -0.0971489 6.05238 -0.0971489 6.44098 0.291447Z"
        fill="#444A6D"
      />
    </svg>
  );
};

export const CardHeaderArrowUp = ({ className = "" }) => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.650391 5.70129L5.40881 0.942874C5.81254 0.539145 6.47179 0.554831 6.85586 0.977308L11.1504 5.70129"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CardHeaderArrowDown = ({ className = "" }) => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.1504 0.650024L6.39197 5.40844C5.98824 5.81217 5.32899 5.79649 4.94492 5.37401L0.65039 0.650025"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileSidebarEllipsesIcon = ({ className = "" }) => {
  return (
    <svg
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M-8.74228e-08 16C-3.93402e-08 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14C0.9 14 -1.35505e-07 14.9 -8.74228e-08 16Z"
        fill="currentColor"
      />
      <path
        d="M-8.74228e-08 2C-3.93402e-08 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 -1.35505e-07 2 -8.74228e-08C0.9 -3.93402e-08 -1.35505e-07 0.9 -8.74228e-08 2Z"
        fill="currentColor"
      />
      <path
        d="M-8.74228e-08 9C-3.93402e-08 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7C0.9 7 -1.35505e-07 7.9 -8.74228e-08 9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ProfileSidebarArrowUpIcon = ({ className = "" }) => {
  return (
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2652 6.44024C11.8766 6.82884 11.24 6.82884 10.8514 6.44024L6.50475 2.09358C6.38002 1.96884 6.1766 1.96884 6.05186 2.09358L1.70519 6.44024C1.3166 6.82884 0.680016 6.82884 0.29142 6.44024C-0.0971746 6.05165 -0.0971746 5.41507 0.29142 5.02647L4.63809 0.679802C5.08838 0.229507 5.68362 2.3365e-05 6.27831 2.3365e-05C6.873 2.3365e-05 7.46823 0.229507 7.91853 0.679802L12.2652 5.02647C12.6538 5.41507 12.6538 6.05165 12.2652 6.44024Z"
        fill="#05004E"
      />
    </svg>
  );
};

export const ProfileSidebarArrowDownIcon = ({
  className = "",
}) => {
  return (
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.291447 0.291447C0.680042 -0.0971489 1.31662 -0.0971489 1.70522 0.291447L6.05189 4.63811C6.17662 4.76285 6.38004 4.76285 6.50478 4.63811L10.8514 0.291447C11.24 -0.0971489 11.8766 -0.0971489 12.2652 0.291447C12.6538 0.680042 12.6538 1.31662 12.2652 1.70522L7.91855 6.05189C7.46826 6.50218 6.87302 6.73167 6.27833 6.73167C5.68364 6.73167 5.08841 6.50218 4.63811 6.05189L0.291447 1.70522C-0.0971489 1.31662 -0.0971489 0.680042 0.291447 0.291447Z"
        fill="#05004E"
      />
    </svg>
  );
};

export const DropdownArrowUpIcon = ({ className = "" }) => {
  return (
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2652 6.44024C11.8766 6.82884 11.24 6.82884 10.8514 6.44024L6.50475 2.09358C6.38002 1.96884 6.1766 1.96884 6.05186 2.09358L1.70519 6.44024C1.3166 6.82884 0.680016 6.82884 0.29142 6.44024C-0.0971747 6.05165 -0.0971748 5.41507 0.29142 5.02647L4.63809 0.679803C5.08838 0.229508 5.68362 2.39659e-05 6.27831 2.39139e-05C6.873 2.38619e-05 7.46823 0.229507 7.91853 0.679803L12.2652 5.02647C12.6538 5.41507 12.6538 6.05165 12.2652 6.44024Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DropdownArrowDownIcon = ({ className = "" }) => {
  return (
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.291447 0.291447C0.680042 -0.0971489 1.31662 -0.0971489 1.70522 0.291447L6.05189 4.63811C6.17662 4.76285 6.38004 4.76285 6.50478 4.63811L10.8514 0.291447C11.24 -0.0971489 11.8766 -0.0971489 12.2652 0.291447C12.6538 0.680042 12.6538 1.31662 12.2652 1.70522L7.91855 6.05189C7.46826 6.50218 6.87302 6.73167 6.27833 6.73167C5.68364 6.73167 5.08841 6.50218 4.63811 6.05189L0.291447 1.70522C-0.0971489 1.31662 -0.0971489 0.680042 0.291447 0.291447Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DropdownSaveIcon = ({ className = "" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.3002 0.699951H11.1002C15.1002 0.699951 16.7002 2.29995 16.7002 6.29995V11.1C16.7002 15.1 15.1002 16.7 11.1002 16.7H6.3002C2.3002 16.7 0.700195 15.1 0.700195 11.1V6.29995C0.700195 2.29995 2.3002 0.699951 6.3002 0.699951Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5064 6.83946L7.8397 11.5061C7.77778 11.5682 7.70421 11.6175 7.62322 11.6511C7.54222 11.6847 7.45539 11.702 7.3677 11.702C7.28001 11.702 7.19319 11.6847 7.11219 11.6511C7.0312 11.6175 6.95763 11.5682 6.8957 11.5061L4.8957 9.50613C4.83372 9.44414 4.78455 9.37056 4.75101 9.28957C4.71746 9.20859 4.7002 9.12179 4.7002 9.03413C4.7002 8.94647 4.71746 8.85967 4.75101 8.77868C4.78455 8.6977 4.83372 8.62411 4.8957 8.56213C5.02089 8.43694 5.19067 8.36662 5.3677 8.36662C5.45536 8.36662 5.54216 8.38388 5.62315 8.41743C5.70414 8.45097 5.77772 8.50014 5.8397 8.56213L7.3677 10.0915L11.5624 5.89546C11.6876 5.77028 11.8573 5.69995 12.0344 5.69995C12.2114 5.69995 12.3812 5.77028 12.5064 5.89546C12.6316 6.02064 12.7019 6.19043 12.7019 6.36746C12.7019 6.54449 12.6316 6.71428 12.5064 6.83946Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DropdownRadioUnselectedIcon = ({
  className = "",
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="8" r="7.3" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
};

export const DropdownRadioSelectedIcon = ({ className = "" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <ellipse
        cx="7.99959"
        cy="7.89307"
        rx="4.21053"
        ry="4"
        fill="currentColor"
      />
      <circle cx="8" cy="8" r="7.3" stroke="#336DFF" strokeWidth="1.4" />
    </svg>
  );
};

export const DropdownCreateNewIcon = ({ className = "" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="8" r="7.3" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M8 4.76794V11.4115"
        stroke="currentColor"
        strokeWidth="1.26973"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.67773 8.08972L11.3213 8.08972"
        stroke="currentColor"
        strokeWidth="1.26973"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReorderIcon = ({ className = "" }) => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M-8.74228e-08 16C-3.93402e-08 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14C0.9 14 -1.35505e-07 14.9 -8.74228e-08 16Z"
        fill="currentColor"
      />
      <path
        d="M-8.74228e-08 2C-3.93402e-08 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 -1.35505e-07 2 -8.74228e-08C0.9 -3.93402e-08 -1.35505e-07 0.9 -8.74228e-08 2Z"
        fill="currentColor"
      />
      <path
        d="M-8.74228e-08 9C-3.93402e-08 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7C0.9 7 -1.35505e-07 7.9 -8.74228e-08 9Z"
        fill="currentColor"
      />
      <path
        d="M7.66797 16C7.66797 17.1 8.56797 18 9.66797 18C10.768 18 11.668 17.1 11.668 16C11.668 14.9 10.768 14 9.66797 14C8.56797 14 7.66797 14.9 7.66797 16Z"
        fill="currentColor"
      />
      <path
        d="M7.66797 2C7.66797 3.1 8.56797 4 9.66797 4C10.768 4 11.668 3.1 11.668 2C11.668 0.9 10.768 -1.35505e-07 9.66797 -8.74228e-08C8.56797 -3.93402e-08 7.66797 0.9 7.66797 2Z"
        fill="currentColor"
      />
      <path
        d="M7.66797 9C7.66797 10.1 8.56797 11 9.66797 11C10.768 11 11.668 10.1 11.668 9C11.668 7.9 10.768 7 9.66797 7C8.56797 7 7.66797 7.9 7.66797 9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DropDownEllipse = ({ className = "" }) => {
  return (
    <svg
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M-8.74228e-08 16C-3.93402e-08 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14C0.9 14 -1.35505e-07 14.9 -8.74228e-08 16Z"
        fill="currentColor"
      />
      <path
        d="M-8.74228e-08 2C-3.93402e-08 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 -1.35505e-07 2 -8.74228e-08C0.9 -3.93402e-08 -1.35505e-07 0.9 -8.74228e-08 2Z"
        fill="currentColor"
      />
      <path
        d="M-8.74228e-08 9C-3.93402e-08 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7C0.9 7 -1.35505e-07 7.9 -8.74228e-08 9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GreenProgressSVG = () => (
  <svg
    width="17"
    height="10"
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.32448 8.43924L3.17812 5.54833C4.04137 3.94653 7.08507 5.0464 8.60456 4.64972C10.1241 4.25304 9.98204 0.997255 11.9008 0.997266C13.8195 0.997277 15.8235 0.997266 15.8235 0.997266"
      stroke="#00E096"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const RedProgressSVG = () => {
  return (
    <svg
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5222 9.5741L13.6686 6.43843C12.8053 4.701 9.76161 5.894 8.24212 5.46374C6.72263 5.03347 6.86464 1.50203 4.9459 1.50204C3.02715 1.50205 1.02323 1.50204 1.02323 1.50204"
        stroke="#FA5A7D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const HashSelectedSVG = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 2.4353H11.25C15 2.4353 16.5 3.94823 16.5 7.73056V12.2694C16.5 16.0517 15 17.5646 11.25 17.5646H6.75C3 17.5646 1.5 16.0517 1.5 12.2694V7.73056C1.5 3.94823 3 2.4353 6.75 2.4353Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.18174 6.28247L7.36328 13.6486"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6368 6.28247L9.81836 13.6486"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.52148 8.73779H12.8876"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.1123 11.1934H12.4785"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HashUnselectedSVG = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M6.75 2.4353H11.25C15 2.4353 16.5 3.94823 16.5 7.73056V12.2694C16.5 16.0517 15 17.5646 11.25 17.5646H6.75C3 17.5646 1.5 16.0517 1.5 12.2694V7.73056C1.5 3.94823 3 2.4353 6.75 2.4353Z"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.18076 6.3147L7.36182 13.6852"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6378 6.3147L9.81885 13.6852"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.51953 8.77148H12.89"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.10986 11.2283H12.4803"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const PercentageSelectedSVG = ({
  className,
}: {
  className?: string;
}) => (
  <svg
    className={className}
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 2.4353H11.25C15 2.4353 16.5 3.94823 16.5 7.73056V12.2694C16.5 16.0517 15 17.5646 11.25 17.5646H6.75C3 17.5646 1.5 16.0517 1.5 12.2694V7.73056C1.5 3.94823 3 2.4353 6.75 2.4353Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.42773 12.4736L11.3327 7.52637"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.73501 8.7669C7.24449 8.7669 7.65749 8.35034 7.65749 7.83647C7.65749 7.32259 7.24449 6.90601 6.73501 6.90601C6.22553 6.90601 5.8125 7.32259 5.8125 7.83647C5.8125 8.35034 6.22553 8.7669 6.73501 8.7669Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6403 13.0939C12.1497 13.0939 12.5628 12.6773 12.5628 12.1635C12.5628 11.6496 12.1497 11.233 11.6403 11.233C11.1308 11.233 10.7178 11.6496 10.7178 12.1635C10.7178 12.6773 11.1308 13.0939 11.6403 13.0939Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PercentageUnselectedSVG = ({
  className,
}: {
  className?: string;
}) => (
  <svg
    className={className}
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M6.75 2.4353H11.25C15 2.4353 16.5 3.94823 16.5 7.73056V12.2694C16.5 16.0517 15 17.5646 11.25 17.5646H6.75C3 17.5646 1.5 16.0517 1.5 12.2694V7.73056C1.5 3.94823 3 2.4353 6.75 2.4353Z"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.42773 12.4736L11.3327 7.52637"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.73501 8.7669C7.24449 8.7669 7.65749 8.35034 7.65749 7.83647C7.65749 7.32259 7.24449 6.90601 6.73501 6.90601C6.22553 6.90601 5.8125 7.32259 5.8125 7.83647C5.8125 8.35034 6.22553 8.7669 6.73501 8.7669Z"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6403 13.0938C12.1497 13.0938 12.5628 12.6772 12.5628 12.1633C12.5628 11.6495 12.1497 11.2329 11.6403 11.2329C11.1308 11.2329 10.7178 11.6495 10.7178 12.1633C10.7178 12.6772 11.1308 13.0938 11.6403 13.0938Z"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const EyeIcon = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <path
        opacity="0.8"
        d="M13.6327 10.9999C13.6327 12.7324 12.2327 14.1324 10.5002 14.1324C8.76768 14.1324 7.36768 12.7324 7.36768 10.9999C7.36768 9.26743 8.76768 7.86743 10.5002 7.86743C12.2327 7.86743 13.6327 9.26743 13.6327 10.9999Z"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.8"
        d="M10.4999 18.2361C13.5886 18.2361 16.4674 16.4161 18.4711 13.2661C19.2586 12.0324 19.2586 9.95863 18.4711 8.72488C16.4674 5.57488 13.5886 3.75488 10.4999 3.75488C7.41111 3.75488 4.53236 5.57488 2.52861 8.72488C1.74111 9.95863 1.74111 12.0324 2.52861 13.2661C4.53236 16.4161 7.41111 18.2361 10.4999 18.2361Z"
        stroke="#444A6D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeIconSelected = ({ className }: { className?: string }) => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("size-full", className)}
  >
    <path
      opacity="0.8"
      d="M13.6327 10.9999C13.6327 12.7324 12.2327 14.1324 10.5002 14.1324C8.76768 14.1324 7.36768 12.7324 7.36768 10.9999C7.36768 9.26743 8.76768 7.86743 10.5002 7.86743C12.2327 7.86743 13.6327 9.26743 13.6327 10.9999Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.8"
      d="M10.4999 18.2361C13.5886 18.2361 16.4674 16.4161 18.4711 13.2661C19.2586 12.0324 19.2586 9.95863 18.4711 8.72488C16.4674 5.57488 13.5886 3.75488 10.4999 3.75488C7.41111 3.75488 4.53236 5.57488 2.52861 8.72488C1.74111 9.95863 1.74111 12.0324 2.52861 13.2661C4.53236 16.4161 7.41111 18.2361 10.4999 18.2361Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmailIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <path
        d="M13.1665 15.4167H4.83317C1.7915 15.4167 0.0415039 13.6667 0.0415039 10.625V4.79167C0.0415039 1.75 1.7915 0 4.83317 0H13.1665C16.2082 0 17.9582 1.75 17.9582 4.79167V10.625C17.9582 13.6667 16.2082 15.4167 13.1665 15.4167ZM4.83317 1.25C2.44984 1.25 1.2915 2.40833 1.2915 4.79167V10.625C1.2915 13.0083 2.44984 14.1667 4.83317 14.1667H13.1665C15.5498 14.1667 16.7082 13.0083 16.7082 10.625V4.79167C16.7082 2.40833 15.5498 1.25 13.1665 1.25H4.83317Z"
        fill="#444A6D"
      />
      <path
        d="M8.99949 8.43322C8.29949 8.43322 7.59116 8.21656 7.04949 7.77489L4.44116 5.69156C4.17449 5.4749 4.12449 5.08323 4.34116 4.81656C4.55783 4.54989 4.9495 4.4999 5.21616 4.71656L7.82449 6.7999C8.45782 7.30823 9.53282 7.30823 10.1662 6.7999L12.7745 4.71656C13.0412 4.4999 13.4412 4.54156 13.6495 4.81656C13.8662 5.08323 13.8245 5.48323 13.5495 5.69156L10.9412 7.77489C10.4078 8.21656 9.69949 8.43322 8.99949 8.43322Z"
        fill="#444A6D"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <path
        d="M6.6665 4.79175C6.32484 4.79175 6.0415 4.50841 6.0415 4.16675V1.66675C6.0415 1.32508 6.32484 1.04175 6.6665 1.04175C7.00817 1.04175 7.2915 1.32508 7.2915 1.66675V4.16675C7.2915 4.50841 7.00817 4.79175 6.6665 4.79175Z"
        fill="#444A6D"
      />
      <path
        d="M13.3335 4.79175C12.9918 4.79175 12.7085 4.50841 12.7085 4.16675V1.66675C12.7085 1.32508 12.9918 1.04175 13.3335 1.04175C13.6752 1.04175 13.9585 1.32508 13.9585 1.66675V4.16675C13.9585 4.50841 13.6752 4.79175 13.3335 4.79175Z"
        fill="#444A6D"
      />
      <path
        d="M7.08333 12.0834C6.975 12.0834 6.86667 12.0584 6.76667 12.0168C6.65833 11.9751 6.575 11.9168 6.49167 11.8418C6.34167 11.6834 6.25 11.4751 6.25 11.2501C6.25 11.1418 6.275 11.0334 6.31667 10.9334C6.35833 10.8334 6.41667 10.7418 6.49167 10.6584C6.575 10.5834 6.65833 10.5251 6.76667 10.4834C7.06667 10.3584 7.44167 10.4251 7.675 10.6584C7.825 10.8168 7.91667 11.0334 7.91667 11.2501C7.91667 11.3001 7.90833 11.3584 7.9 11.4168C7.89167 11.4668 7.875 11.5168 7.85 11.5668C7.83333 11.6168 7.80833 11.6668 7.775 11.7168C7.75 11.7584 7.70833 11.8001 7.675 11.8418C7.51667 11.9918 7.3 12.0834 7.08333 12.0834Z"
        fill="#444A6D"
      />
      <path
        d="M9.99984 12.0832C9.8915 12.0832 9.78317 12.0582 9.68317 12.0166C9.57484 11.9749 9.4915 11.9166 9.40817 11.8416C9.25817 11.6832 9.1665 11.4749 9.1665 11.2499C9.1665 11.1416 9.19151 11.0332 9.23317 10.9332C9.27484 10.8332 9.33317 10.7416 9.40817 10.6582C9.4915 10.5832 9.57484 10.5249 9.68317 10.4832C9.98317 10.3499 10.3582 10.4249 10.5915 10.6582C10.7415 10.8166 10.8332 11.0332 10.8332 11.2499C10.8332 11.2999 10.8248 11.3582 10.8165 11.4166C10.8082 11.4666 10.7915 11.5166 10.7665 11.5666C10.7498 11.6166 10.7248 11.6666 10.6915 11.7166C10.6665 11.7582 10.6248 11.7999 10.5915 11.8416C10.4332 11.9916 10.2165 12.0832 9.99984 12.0832Z"
        fill="#444A6D"
      />
      <path
        d="M12.9168 12.0832C12.8085 12.0832 12.7002 12.0582 12.6002 12.0166C12.4918 11.9749 12.4085 11.9166 12.3252 11.8416C12.2918 11.7999 12.2585 11.7582 12.2252 11.7166C12.1918 11.6666 12.1668 11.6166 12.1502 11.5666C12.1252 11.5166 12.1085 11.4666 12.1002 11.4166C12.0918 11.3582 12.0835 11.2999 12.0835 11.2499C12.0835 11.0332 12.1752 10.8166 12.3252 10.6582C12.4085 10.5832 12.4918 10.5249 12.6002 10.4832C12.9085 10.3499 13.2752 10.4249 13.5085 10.6582C13.6585 10.8166 13.7502 11.0332 13.7502 11.2499C13.7502 11.2999 13.7418 11.3582 13.7335 11.4166C13.7252 11.4666 13.7085 11.5166 13.6835 11.5666C13.6668 11.6166 13.6418 11.6666 13.6085 11.7166C13.5835 11.7582 13.5418 11.7999 13.5085 11.8416C13.3502 11.9916 13.1335 12.0832 12.9168 12.0832Z"
        fill="#444A6D"
      />
      <path
        d="M7.08333 15C6.975 15 6.86667 14.975 6.76667 14.9333C6.66667 14.8917 6.575 14.8333 6.49167 14.7583C6.34167 14.6 6.25 14.3833 6.25 14.1667C6.25 14.0583 6.275 13.95 6.31667 13.85C6.35833 13.7417 6.41667 13.65 6.49167 13.575C6.8 13.2667 7.36667 13.2667 7.675 13.575C7.825 13.7333 7.91667 13.95 7.91667 14.1667C7.91667 14.3833 7.825 14.6 7.675 14.7583C7.51667 14.9083 7.3 15 7.08333 15Z"
        fill="#444A6D"
      />
      <path
        d="M9.99984 15C9.78317 15 9.5665 14.9083 9.40817 14.7583C9.25817 14.6 9.1665 14.3833 9.1665 14.1667C9.1665 14.0583 9.19151 13.95 9.23317 13.85C9.27484 13.7417 9.33317 13.65 9.40817 13.575C9.7165 13.2667 10.2832 13.2667 10.5915 13.575C10.6665 13.65 10.7248 13.7417 10.7665 13.85C10.8082 13.95 10.8332 14.0583 10.8332 14.1667C10.8332 14.3833 10.7415 14.6 10.5915 14.7583C10.4332 14.9083 10.2165 15 9.99984 15Z"
        fill="#444A6D"
      />
      <path
        d="M12.9168 14.9999C12.7002 14.9999 12.4835 14.9083 12.3252 14.7583C12.2502 14.6833 12.1918 14.5916 12.1502 14.4833C12.1085 14.3833 12.0835 14.2749 12.0835 14.1666C12.0835 14.0583 12.1085 13.9499 12.1502 13.8499C12.1918 13.7416 12.2502 13.6499 12.3252 13.5749C12.5168 13.3833 12.8085 13.2916 13.0752 13.3499C13.1335 13.3583 13.1835 13.3749 13.2335 13.3999C13.2835 13.4166 13.3335 13.4416 13.3835 13.4749C13.4252 13.4999 13.4668 13.5416 13.5085 13.5749C13.6585 13.7333 13.7502 13.9499 13.7502 14.1666C13.7502 14.3833 13.6585 14.5999 13.5085 14.7583C13.3502 14.9083 13.1335 14.9999 12.9168 14.9999Z"
        fill="#444A6D"
      />
      <path
        d="M17.0832 8.19995H2.9165C2.57484 8.19995 2.2915 7.91662 2.2915 7.57495C2.2915 7.23328 2.57484 6.94995 2.9165 6.94995H17.0832C17.4248 6.94995 17.7082 7.23328 17.7082 7.57495C17.7082 7.91662 17.4248 8.19995 17.0832 8.19995Z"
        fill="#444A6D"
      />
      <path
        d="M13.3333 18.9584H6.66667C3.625 18.9584 1.875 17.2084 1.875 14.1667V7.08341C1.875 4.04175 3.625 2.29175 6.66667 2.29175H13.3333C16.375 2.29175 18.125 4.04175 18.125 7.08341V14.1667C18.125 17.2084 16.375 18.9584 13.3333 18.9584ZM6.66667 3.54175C4.28333 3.54175 3.125 4.70008 3.125 7.08341V14.1667C3.125 16.5501 4.28333 17.7084 6.66667 17.7084H13.3333C15.7167 17.7084 16.875 16.5501 16.875 14.1667V7.08341C16.875 4.70008 15.7167 3.54175 13.3333 3.54175H6.66667Z"
        fill="#444A6D"
      />
    </svg>
  );
};

export const EmailIconSelected = ({ className }: { className?: string }) => (
  <svg
    className={cn("size-full", className)}
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1667 15.4167H4.83341C1.79175 15.4167 0.041748 13.6667 0.041748 10.625V4.79167C0.041748 1.75 1.79175 0 4.83341 0H13.1667C16.2084 0 17.9584 1.75 17.9584 4.79167V10.625C17.9584 13.6667 16.2084 15.4167 13.1667 15.4167ZM4.83341 1.25C2.45008 1.25 1.29175 2.40833 1.29175 4.79167V10.625C1.29175 13.0083 2.45008 14.1667 4.83341 14.1667H13.1667C15.5501 14.1667 16.7084 13.0083 16.7084 10.625V4.79167C16.7084 2.40833 15.5501 1.25 13.1667 1.25H4.83341Z"
      fill="currentColor"
    />
    <path
      d="M8.99998 8.43347C8.29998 8.43347 7.59165 8.21681 7.04998 7.77514L4.44164 5.69181C4.17498 5.47514 4.12498 5.08347 4.34165 4.8168C4.55831 4.55014 4.94998 4.50014 5.21665 4.71681L7.82497 6.80014C8.45831 7.30847 9.53331 7.30847 10.1666 6.80014L12.775 4.71681C13.0416 4.50014 13.4416 4.5418 13.65 4.8168C13.8666 5.08347 13.825 5.48347 13.55 5.69181L10.9416 7.77514C10.4083 8.21681 9.69998 8.43347 8.99998 8.43347Z"
      fill="currentColor"
    />
  </svg>
);

export const CalendarIconSelected = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("size-full", className)}
  >
    <path
      d="M6.66675 4.7915C6.32508 4.7915 6.04175 4.50817 6.04175 4.1665V1.6665C6.04175 1.32484 6.32508 1.0415 6.66675 1.0415C7.00841 1.0415 7.29175 1.32484 7.29175 1.6665V4.1665C7.29175 4.50817 7.00841 4.7915 6.66675 4.7915Z"
      fill="currentColor"
    />
    <path
      d="M13.3333 4.7915C12.9916 4.7915 12.7083 4.50817 12.7083 4.1665V1.6665C12.7083 1.32484 12.9916 1.0415 13.3333 1.0415C13.6749 1.0415 13.9583 1.32484 13.9583 1.6665V4.1665C13.9583 4.50817 13.6749 4.7915 13.3333 4.7915Z"
      fill="currentColor"
    />
    <path
      d="M7.08333 12.0834C6.975 12.0834 6.86667 12.0584 6.76667 12.0168C6.65833 11.9751 6.575 11.9168 6.49167 11.8418C6.34167 11.6834 6.25 11.4751 6.25 11.2501C6.25 11.1418 6.275 11.0334 6.31667 10.9334C6.35833 10.8334 6.41667 10.7418 6.49167 10.6584C6.575 10.5834 6.65833 10.5251 6.76667 10.4834C7.06667 10.3584 7.44167 10.4251 7.675 10.6584C7.825 10.8168 7.91667 11.0334 7.91667 11.2501C7.91667 11.3001 7.90833 11.3584 7.9 11.4168C7.89167 11.4668 7.875 11.5168 7.85 11.5668C7.83333 11.6168 7.80833 11.6668 7.775 11.7168C7.75 11.7584 7.70833 11.8001 7.675 11.8418C7.51667 11.9918 7.3 12.0834 7.08333 12.0834Z"
      fill="currentColor"
    />
    <path
      d="M10.0001 12.0832C9.89175 12.0832 9.78341 12.0582 9.68341 12.0166C9.57508 11.9749 9.49175 11.9166 9.40842 11.8416C9.25842 11.6832 9.16675 11.4749 9.16675 11.2499C9.16675 11.1416 9.19175 11.0332 9.23342 10.9332C9.27508 10.8332 9.33342 10.7416 9.40842 10.6582C9.49175 10.5832 9.57508 10.5249 9.68341 10.4832C9.98341 10.3499 10.3584 10.4249 10.5917 10.6582C10.7417 10.8166 10.8334 11.0332 10.8334 11.2499C10.8334 11.2999 10.8251 11.3582 10.8167 11.4166C10.8084 11.4666 10.7917 11.5166 10.7667 11.5666C10.7501 11.6166 10.7251 11.6666 10.6917 11.7166C10.6667 11.7582 10.6251 11.7999 10.5917 11.8416C10.4334 11.9916 10.2167 12.0832 10.0001 12.0832Z"
      fill="currentColor"
    />
    <path
      d="M12.9166 12.0832C12.8083 12.0832 12.6999 12.0582 12.5999 12.0166C12.4916 11.9749 12.4083 11.9166 12.3249 11.8416C12.2916 11.7999 12.2583 11.7582 12.2249 11.7166C12.1916 11.6666 12.1666 11.6166 12.1499 11.5666C12.1249 11.5166 12.1083 11.4666 12.0999 11.4166C12.0916 11.3582 12.0833 11.2999 12.0833 11.2499C12.0833 11.0332 12.1749 10.8166 12.3249 10.6582C12.4083 10.5832 12.4916 10.5249 12.5999 10.4832C12.9083 10.3499 13.2749 10.4249 13.5083 10.6582C13.6583 10.8166 13.7499 11.0332 13.7499 11.2499C13.7499 11.2999 13.7416 11.3582 13.7333 11.4166C13.7249 11.4666 13.7083 11.5166 13.6833 11.5666C13.6666 11.6166 13.6416 11.6666 13.6083 11.7166C13.5833 11.7582 13.5416 11.7999 13.5083 11.8416C13.3499 11.9916 13.1333 12.0832 12.9166 12.0832Z"
      fill="currentColor"
    />
    <path
      d="M7.08333 15C6.975 15 6.86667 14.975 6.76667 14.9333C6.66667 14.8917 6.575 14.8333 6.49167 14.7583C6.34167 14.6 6.25 14.3833 6.25 14.1667C6.25 14.0583 6.275 13.95 6.31667 13.85C6.35833 13.7417 6.41667 13.65 6.49167 13.575C6.8 13.2667 7.36667 13.2667 7.675 13.575C7.825 13.7333 7.91667 13.95 7.91667 14.1667C7.91667 14.3833 7.825 14.6 7.675 14.7583C7.51667 14.9083 7.3 15 7.08333 15Z"
      fill="currentColor"
    />
    <path
      d="M10.0001 15C9.78341 15 9.56675 14.9083 9.40842 14.7583C9.25842 14.6 9.16675 14.3833 9.16675 14.1667C9.16675 14.0583 9.19175 13.95 9.23342 13.85C9.27508 13.7417 9.33342 13.65 9.40842 13.575C9.71675 13.2667 10.2834 13.2667 10.5917 13.575C10.6667 13.65 10.7251 13.7417 10.7667 13.85C10.8084 13.95 10.8334 14.0583 10.8334 14.1667C10.8334 14.3833 10.7417 14.6 10.5917 14.7583C10.4334 14.9083 10.2167 15 10.0001 15Z"
      fill="currentColor"
    />
    <path
      d="M12.9166 14.9999C12.6999 14.9999 12.4833 14.9083 12.3249 14.7583C12.2499 14.6833 12.1916 14.5916 12.1499 14.4833C12.1083 14.3833 12.0833 14.2749 12.0833 14.1666C12.0833 14.0583 12.1083 13.9499 12.1499 13.8499C12.1916 13.7416 12.2499 13.6499 12.3249 13.5749C12.5166 13.3833 12.8083 13.2916 13.0749 13.3499C13.1333 13.3583 13.1833 13.3749 13.2333 13.3999C13.2833 13.4166 13.3333 13.4416 13.3833 13.4749C13.4249 13.4999 13.4666 13.5416 13.5083 13.5749C13.6583 13.7333 13.7499 13.9499 13.7499 14.1666C13.7499 14.3833 13.6583 14.5999 13.5083 14.7583C13.3499 14.9083 13.1333 14.9999 12.9166 14.9999Z"
      fill="currentColor"
    />
    <path
      d="M17.0834 8.2002H2.91675C2.57508 8.2002 2.29175 7.91686 2.29175 7.5752C2.29175 7.23353 2.57508 6.9502 2.91675 6.9502H17.0834C17.4251 6.9502 17.7084 7.23353 17.7084 7.5752C17.7084 7.91686 17.4251 8.2002 17.0834 8.2002Z"
      fill="currentColor"
    />
    <path
      d="M13.3333 18.9582H6.66667C3.625 18.9582 1.875 17.2082 1.875 14.1665V7.08317C1.875 4.0415 3.625 2.2915 6.66667 2.2915H13.3333C16.375 2.2915 18.125 4.0415 18.125 7.08317V14.1665C18.125 17.2082 16.375 18.9582 13.3333 18.9582ZM6.66667 3.5415C4.28333 3.5415 3.125 4.69984 3.125 7.08317V14.1665C3.125 16.5498 4.28333 17.7082 6.66667 17.7082H13.3333C15.7167 17.7082 16.875 16.5498 16.875 14.1665V7.08317C16.875 4.69984 15.7167 3.5415 13.3333 3.5415H6.66667Z"
      fill="currentColor"
    />
  </svg>
);

export const WarningRedIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0C2.24 0 0 2.23 0 5C0 7.77 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.77 0 5 0ZM4.00923 2.98458C4.00923 2.43739 4.45282 1.9938 5.00001 1.9938C5.5472 1.9938 5.99078 2.43739 5.99078 2.98458V4.92759C5.99078 5.47478 5.5472 5.91837 5.00001 5.91837C4.45282 5.91837 4.00923 5.47478 4.00923 4.92759V2.98458ZM5 6.55007C4.45324 6.55007 4.01 6.99331 4.01 7.54007C4.01 8.08684 4.45324 8.53008 5 8.53008C5.54676 8.53008 5.99 8.08684 5.99 7.54007C5.99 6.99331 5.54676 6.55007 5 6.55007Z"
        fill="#FA5A7D"
      />
    </svg>
  );
};

export const WarningYellowIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C7.76 10 10 7.77 10 5C10 2.23 7.76 1.95827e-07 5 4.37114e-07C2.24 6.78401e-07 -6.78401e-07 2.24 -4.37114e-07 5C-1.95827e-07 7.76 2.23 10 5 10ZM5.99077 7.01542C5.99077 7.56261 5.54718 8.0062 4.99999 8.0062C4.4528 8.0062 4.00922 7.56261 4.00922 7.01542L4.00922 5.07241C4.00922 4.52522 4.4528 4.08164 4.99999 4.08163C5.54718 4.08163 5.99077 4.52522 5.99077 5.07241L5.99077 7.01542ZM5 3.44993C5.54676 3.44993 5.99 3.00669 5.99 2.45993C5.99 1.91316 5.54676 1.46993 5 1.46993C4.45324 1.46993 4.01 1.91316 4.01 2.45993C4.01 3.00669 4.45324 3.44993 5 3.44993Z"
        fill="#FFA800"
      />
    </svg>
  );
};

export const OpenEmailIcon = () => {
  return (
    <svg
      width="24"
      height="27"
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 20.1137C1 17.3198 3.24 15.0706 6 15.0706C8.77 15.0706 11 17.3299 11 20.1137C11 22.8975 8.76 25.1568 6 25.1568C3.24 25.1568 1 22.9075 1 20.1137ZM4 20.1137C4 18.9961 4.896 18.0964 6 18.0964C7.108 18.0964 8 19.0001 8 20.1137C8 21.2272 7.104 22.1309 6 22.1309C4.896 22.1309 4 21.2312 4 20.1137Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9996 0.50708C10.0082 0.50708 5.44505 4.22063 3.75933 5.86704C2.64791 6.66231 2 8.01808 2 10.0273V13.1944C2 13.9307 2.75 14.3947 3.42 14.1022C4.52 13.618 5.77 13.4365 7.08 13.6483C9.7 14.082 11.84 16.1698 12.37 18.7923C12.52 19.5588 12.54 20.3052 12.44 21.0213C12.36 21.6164 12.84 22.1409 13.43 22.1409H17C20 22.1409 22 20.6279 22 17.0978V10.0273C22 8.0163 21.351 6.65991 20.2377 5.86493C18.5503 4.21746 13.9901 0.50708 11.9996 0.50708ZM7 7.41463C6.44772 7.41463 6 7.86235 6 8.41463C6 8.96692 6.44771 9.41463 7 9.41463H17C17.5523 9.41463 18 8.96692 18 8.41463C18 7.86235 17.5523 7.41463 17 7.41463H7Z"
        fill="white"
      />
    </svg>
  );
};

export const EmailOverviewIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 18.8695C1 16.0756 3.24 13.8264 6 13.8264C8.77 13.8264 11 16.0857 11 18.8695C11 21.6533 8.76 23.9126 6 23.9126C3.24 23.9126 1 21.6634 1 18.8695ZM4.38982 17.5788L6.78057 16.7774C7.85284 16.4168 8.4353 17.0071 8.08053 18.089L7.28361 20.4985C6.7488 22.1199 5.86981 22.1199 5.335 20.4985L5.09936 19.7826L4.38982 19.5448C2.78274 19.0052 2.78274 18.1211 4.38982 17.5788Z"
        fill="white"
      />
      <path
        d="M17 3.74023H7C4 3.74023 2 5.25317 2 8.78334V11.9504C2 12.6867 2.75 13.1507 3.42 12.8582C4.52 12.374 5.77 12.1925 7.08 12.4043C9.7 12.838 11.84 14.9258 12.37 17.5483C12.52 18.3148 12.54 19.0612 12.44 19.7773C12.36 20.3724 12.84 20.8969 13.43 20.8969H17C20 20.8969 22 19.3839 22 15.8538V8.78334C22 5.25317 20 3.74023 17 3.74023ZM17.47 9.37842L14.34 11.9C13.68 12.4345 12.84 12.6968 12 12.6968C11.16 12.6968 10.31 12.4345 9.66 11.9L6.53 9.37842C6.21 9.11618 6.16 8.63205 6.41 8.30929C6.67 7.98653 7.14 7.92601 7.46 8.18825L10.59 10.7098C11.35 11.3251 12.64 11.3251 13.4 10.7098L16.53 8.18825C16.85 7.92601 17.33 7.97644 17.58 8.30929C17.84 8.63205 17.79 9.11618 17.47 9.37842Z"
        fill="white"
      />
    </svg>
  );
};

export const EAELogo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5493 5.82454C24.5493 5.82454 24.5493 5.78545 24.5537 5.76373C24.5537 5.77242 24.5537 5.78545 24.5493 5.79414V5.82454Z"
        fill="#99A7E0"
      />
      <path
        d="M2.43213 5.79418C2.43213 5.79418 2.43213 5.78115 2.43213 5.77246C2.43213 5.78983 2.43213 5.80286 2.43647 5.82024V5.78983L2.43213 5.79418Z"
        fill="#99A7E0"
      />
      <path
        d="M13.4905 13.5081L10.1895 11.2582L13.4948 13.5428L17.3084 10.9064L13.4948 13.5081H13.4905Z"
        fill="#C8CCFC"
      />
      <path
        d="M24.532 5.9158L17.3088 10.9064L24.532 5.98529C24.5407 5.93317 24.5407 5.88105 24.5494 5.82893V5.79852C24.5407 5.83761 24.5407 5.8767 24.532 5.9158Z"
        fill="#FDFDFD"
      />
      <path
        d="M10.1895 11.2582L2.4495 5.9158C2.44082 5.8767 2.44082 5.83761 2.43213 5.79852V5.82893C2.44082 5.88105 2.44082 5.93317 2.4495 5.98529L10.1895 11.2626V11.2582Z"
        fill="#FDFDFD"
      />
      <path
        d="M10.1895 11.2582L13.4905 13.5082H13.4949L17.3084 10.9021L24.5316 5.91146C24.5403 5.87237 24.5403 5.83328 24.549 5.79419H2.43213C2.44082 5.83328 2.44082 5.87237 2.4495 5.91146L10.1895 11.2582Z"
        fill="#FDFDFD"
      />
      <path
        d="M24.5537 5.76374C24.5537 5.76374 24.5537 5.76374 24.5493 5.7594V5.79849C24.5493 5.79849 24.5493 5.77677 24.5537 5.76809V5.76374Z"
        fill="#2B3640"
      />
      <path
        d="M24.5492 21.1961V21.2351C26.0867 19.0417 26.9902 16.3748 26.9902 13.4951C26.9902 10.6154 26.0911 7.96157 24.5622 5.77681C24.5622 5.77681 24.5578 5.77247 24.5535 5.76813C24.5535 5.78984 24.5535 5.80722 24.5492 5.82894C24.5492 5.82894 24.5492 5.855 24.5448 5.87237L24.5231 5.99833L17.313 10.9151L13.4994 13.5516L10.1941 11.2669L2.5192 6.02873L2.43233 5.81591C2.43233 5.81591 2.43233 5.78984 2.42799 5.77247C2.42799 5.77247 2.42364 5.78116 2.4193 5.7855C0.89475 7.9746 0 10.6284 0 13.4951C0 16.3618 0.899093 19.0287 2.43233 21.2178V21.1917L13.4821 13.5472H13.4907L24.5492 21.0353V21.1917V21.1961Z"
        fill="#61A1FF"
      />
      <path
        d="M24.4664 5.64214C22.0167 2.22819 18.0164 0 13.4949 0C13.4949 0 13.4949 0 13.4905 0C8.97336 0 4.97739 2.22385 2.52768 5.63345C2.49294 5.67689 2.46253 5.72466 2.43213 5.7681V5.79416H24.549V5.75507C24.5229 5.71598 24.4968 5.67689 24.4664 5.64214Z"
        fill="#61A1FF"
      />
      <path
        d="M13.4905 13.5428H13.4819L2.43213 21.196V21.2221C2.46253 21.2698 2.49728 21.3133 2.52768 21.3567C4.97739 24.7663 8.96902 26.9902 13.4862 26.9902C13.4862 26.9902 13.4862 26.9902 13.4905 26.9902C18.0121 26.9902 22.0124 24.762 24.4621 21.348C24.4882 21.3089 24.5186 21.2698 24.5446 21.2351V21.0396L13.4862 13.5472L13.4905 13.5428Z"
        fill="#336DFF"
      />
    </svg>
  );
};

export const InputErrorIcon = ({ className = "" }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 0C2.24 0 0 2.23 0 5C0 7.77 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.77 0 5 0Z"
        fill="#FA5A7D"
      />
      <rect
        x="4.00977"
        y="1.99377"
        width="1.98155"
        height="3.92456"
        rx="0.990776"
        fill="white"
      />
      <rect
        x="4.00977"
        y="6.55005"
        width="1.98"
        height="1.98"
        rx="0.99"
        fill="white"
      />
    </svg>
  );
};

export const ReportBuilderModalImage = () => {
  return (
    <svg
      width="281"
      height="257"
      viewBox="0 0 281 257"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="74.5"
        width="279"
        height="182"
        rx="15.5"
        fill="white"
        stroke="#61A1FF"
      />
      <mask
        id="mask0_10323_19592"
        maskUnits="userSpaceOnUse"
        x="0"
        y="74"
        width="281"
        height="183"
      >
        <rect
          x="1"
          y="74.5"
          width="279"
          height="182"
          rx="15.5"
          fill="white"
          stroke="white"
        />
      </mask>
      <g mask="url(#mask0_10323_19592)">
        <rect x="0.5" y="135" width="280" height="60" fill="#EDF2F6" />
        <rect x="0.5" y="195.045" width="280" height="1" fill="#EDF2F6" />
        <rect x="0.5" y="134" width="280" height="1" fill="#EDF2F6" />
        <path
          d="M50.016 102.084C50.016 102.78 49.776 103.36 49.296 103.824C48.824 104.28 48.1 104.508 47.124 104.508H45.516V108H44.424V99.636H47.124C48.068 99.636 48.784 99.864 49.272 100.32C49.768 100.776 50.016 101.364 50.016 102.084ZM47.124 103.608C47.732 103.608 48.18 103.476 48.468 103.212C48.756 102.948 48.9 102.572 48.9 102.084C48.9 101.052 48.308 100.536 47.124 100.536H45.516V103.608H47.124ZM57.3732 104.46C57.3732 104.668 57.3612 104.888 57.3372 105.12H52.0812C52.1212 105.768 52.3412 106.276 52.7412 106.644C53.1492 107.004 53.6412 107.184 54.2172 107.184C54.6892 107.184 55.0812 107.076 55.3932 106.86C55.7132 106.636 55.9372 106.34 56.0652 105.972H57.2412C57.0652 106.604 56.7132 107.12 56.1852 107.52C55.6572 107.912 55.0012 108.108 54.2172 108.108C53.5932 108.108 53.0332 107.968 52.5372 107.688C52.0492 107.408 51.6652 107.012 51.3852 106.5C51.1052 105.98 50.9652 105.38 50.9652 104.7C50.9652 104.02 51.1012 103.424 51.3732 102.912C51.6452 102.4 52.0252 102.008 52.5132 101.736C53.0092 101.456 53.5772 101.316 54.2172 101.316C54.8412 101.316 55.3932 101.452 55.8732 101.724C56.3532 101.996 56.7212 102.372 56.9772 102.852C57.2412 103.324 57.3732 103.86 57.3732 104.46ZM56.2452 104.232C56.2452 103.816 56.1532 103.46 55.9692 103.164C55.7852 102.86 55.5332 102.632 55.2132 102.48C54.9012 102.32 54.5532 102.24 54.1692 102.24C53.6172 102.24 53.1452 102.416 52.7532 102.768C52.3692 103.12 52.1492 103.608 52.0932 104.232H56.2452ZM59.9066 102.492C60.0986 102.116 60.3706 101.824 60.7226 101.616C61.0826 101.408 61.5186 101.304 62.0306 101.304V102.432H61.7426C60.5186 102.432 59.9066 103.096 59.9066 104.424V108H58.8146V101.424H59.9066V102.492ZM65.9672 102.324H64.5872V108H63.4952V102.324H62.6432V101.424H63.4952V100.956C63.4952 100.22 63.6832 99.684 64.0592 99.348C64.4432 99.004 65.0552 98.832 65.8952 98.832V99.744C65.4152 99.744 65.0752 99.84 64.8752 100.032C64.6832 100.216 64.5872 100.524 64.5872 100.956V101.424H65.9672V102.324ZM70.1084 108.108C69.4924 108.108 68.9324 107.968 68.4284 107.688C67.9324 107.408 67.5404 107.012 67.2524 106.5C66.9724 105.98 66.8324 105.38 66.8324 104.7C66.8324 104.028 66.9764 103.436 67.2644 102.924C67.5604 102.404 67.9604 102.008 68.4644 101.736C68.9684 101.456 69.5324 101.316 70.1564 101.316C70.7804 101.316 71.3444 101.456 71.8484 101.736C72.3524 102.008 72.7484 102.4 73.0364 102.912C73.3324 103.424 73.4804 104.02 73.4804 104.7C73.4804 105.38 73.3284 105.98 73.0244 106.5C72.7284 107.012 72.3244 107.408 71.8124 107.688C71.3004 107.968 70.7324 108.108 70.1084 108.108ZM70.1084 107.148C70.5004 107.148 70.8684 107.056 71.2124 106.872C71.5564 106.688 71.8324 106.412 72.0404 106.044C72.2564 105.676 72.3644 105.228 72.3644 104.7C72.3644 104.172 72.2604 103.724 72.0524 103.356C71.8444 102.988 71.5724 102.716 71.2364 102.54C70.9004 102.356 70.5364 102.264 70.1444 102.264C69.7444 102.264 69.3764 102.356 69.0404 102.54C68.7124 102.716 68.4484 102.988 68.2484 103.356C68.0484 103.724 67.9484 104.172 67.9484 104.7C67.9484 105.236 68.0444 105.688 68.2364 106.056C68.4364 106.424 68.7004 106.7 69.0284 106.884C69.3564 107.06 69.7164 107.148 70.1084 107.148ZM76.0082 102.492C76.2002 102.116 76.4722 101.824 76.8242 101.616C77.1842 101.408 77.6202 101.304 78.1322 101.304V102.432H77.8442C76.6202 102.432 76.0082 103.096 76.0082 104.424V108H74.9162V101.424H76.0082V102.492ZM87.3008 101.304C87.8128 101.304 88.2688 101.412 88.6688 101.628C89.0688 101.836 89.3848 102.152 89.6168 102.576C89.8488 103 89.9648 103.516 89.9648 104.124V108H88.8848V104.28C88.8848 103.624 88.7208 103.124 88.3928 102.78C88.0728 102.428 87.6368 102.252 87.0848 102.252C86.5168 102.252 86.0648 102.436 85.7288 102.804C85.3928 103.164 85.2248 103.688 85.2248 104.376V108H84.1448V104.28C84.1448 103.624 83.9808 103.124 83.6528 102.78C83.3328 102.428 82.8968 102.252 82.3448 102.252C81.7768 102.252 81.3248 102.436 80.9888 102.804C80.6528 103.164 80.4848 103.688 80.4848 104.376V108H79.3928V101.424H80.4848V102.372C80.7008 102.028 80.9888 101.764 81.3488 101.58C81.7168 101.396 82.1208 101.304 82.5608 101.304C83.1128 101.304 83.6008 101.428 84.0248 101.676C84.4488 101.924 84.7648 102.288 84.9728 102.768C85.1568 102.304 85.4608 101.944 85.8848 101.688C86.3088 101.432 86.7808 101.304 87.3008 101.304ZM91.348 104.688C91.348 104.016 91.484 103.428 91.756 102.924C92.028 102.412 92.4 102.016 92.872 101.736C93.352 101.456 93.884 101.316 94.468 101.316C95.044 101.316 95.544 101.44 95.968 101.688C96.392 101.936 96.708 102.248 96.916 102.624V101.424H98.02V108H96.916V106.776C96.7 107.16 96.376 107.48 95.944 107.736C95.52 107.984 95.024 108.108 94.456 108.108C93.872 108.108 93.344 107.964 92.872 107.676C92.4 107.388 92.028 106.984 91.756 106.464C91.484 105.944 91.348 105.352 91.348 104.688ZM96.916 104.7C96.916 104.204 96.816 103.772 96.616 103.404C96.416 103.036 96.144 102.756 95.8 102.564C95.464 102.364 95.092 102.264 94.684 102.264C94.276 102.264 93.904 102.36 93.568 102.552C93.232 102.744 92.964 103.024 92.764 103.392C92.564 103.76 92.464 104.192 92.464 104.688C92.464 105.192 92.564 105.632 92.764 106.008C92.964 106.376 93.232 106.66 93.568 106.86C93.904 107.052 94.276 107.148 94.684 107.148C95.092 107.148 95.464 107.052 95.8 106.86C96.144 106.66 96.416 106.376 96.616 106.008C96.816 105.632 96.916 105.196 96.916 104.7ZM103.069 101.304C103.869 101.304 104.517 101.548 105.013 102.036C105.509 102.516 105.757 103.212 105.757 104.124V108H104.677V104.28C104.677 103.624 104.513 103.124 104.185 102.78C103.857 102.428 103.409 102.252 102.841 102.252C102.265 102.252 101.805 102.432 101.461 102.792C101.125 103.152 100.957 103.676 100.957 104.364V108H99.8654V101.424H100.957V102.36C101.173 102.024 101.465 101.764 101.833 101.58C102.209 101.396 102.621 101.304 103.069 101.304ZM107.133 104.7C107.133 104.02 107.269 103.428 107.541 102.924C107.813 102.412 108.189 102.016 108.669 101.736C109.157 101.456 109.713 101.316 110.337 101.316C111.145 101.316 111.809 101.512 112.329 101.904C112.857 102.296 113.205 102.84 113.373 103.536H112.197C112.085 103.136 111.865 102.82 111.537 102.588C111.217 102.356 110.817 102.24 110.337 102.24C109.713 102.24 109.209 102.456 108.825 102.888C108.441 103.312 108.249 103.916 108.249 104.7C108.249 105.492 108.441 106.104 108.825 106.536C109.209 106.968 109.713 107.184 110.337 107.184C110.817 107.184 111.217 107.072 111.537 106.848C111.857 106.624 112.077 106.304 112.197 105.888H113.373C113.197 106.56 112.845 107.1 112.317 107.508C111.789 107.908 111.129 108.108 110.337 108.108C109.713 108.108 109.157 107.968 108.669 107.688C108.189 107.408 107.813 107.012 107.541 106.5C107.269 105.988 107.133 105.388 107.133 104.7ZM120.83 104.46C120.83 104.668 120.818 104.888 120.794 105.12H115.538C115.578 105.768 115.798 106.276 116.198 106.644C116.606 107.004 117.098 107.184 117.674 107.184C118.146 107.184 118.538 107.076 118.85 106.86C119.17 106.636 119.394 106.34 119.522 105.972H120.698C120.522 106.604 120.17 107.12 119.642 107.52C119.114 107.912 118.458 108.108 117.674 108.108C117.05 108.108 116.49 107.968 115.994 107.688C115.506 107.408 115.122 107.012 114.842 106.5C114.562 105.98 114.422 105.38 114.422 104.7C114.422 104.02 114.558 103.424 114.83 102.912C115.102 102.4 115.482 102.008 115.97 101.736C116.466 101.456 117.034 101.316 117.674 101.316C118.298 101.316 118.85 101.452 119.33 101.724C119.81 101.996 120.178 102.372 120.434 102.852C120.698 103.324 120.83 103.86 120.83 104.46ZM119.702 104.232C119.702 103.816 119.61 103.46 119.426 103.164C119.242 102.86 118.99 102.632 118.67 102.48C118.358 102.32 118.01 102.24 117.626 102.24C117.074 102.24 116.602 102.416 116.21 102.768C115.826 103.12 115.606 103.608 115.55 104.232H119.702ZM130.619 99.636V100.524H128.339V108H127.247V100.524H124.955V99.636H130.619ZM137.963 104.46C137.963 104.668 137.951 104.888 137.927 105.12H132.671C132.711 105.768 132.931 106.276 133.331 106.644C133.739 107.004 134.231 107.184 134.807 107.184C135.279 107.184 135.671 107.076 135.983 106.86C136.303 106.636 136.527 106.34 136.655 105.972H137.831C137.655 106.604 137.303 107.12 136.775 107.52C136.247 107.912 135.591 108.108 134.807 108.108C134.183 108.108 133.623 107.968 133.127 107.688C132.639 107.408 132.255 107.012 131.975 106.5C131.695 105.98 131.555 105.38 131.555 104.7C131.555 104.02 131.691 103.424 131.963 102.912C132.235 102.4 132.615 102.008 133.103 101.736C133.599 101.456 134.167 101.316 134.807 101.316C135.431 101.316 135.983 101.452 136.463 101.724C136.943 101.996 137.311 102.372 137.567 102.852C137.831 103.324 137.963 103.86 137.963 104.46ZM136.835 104.232C136.835 103.816 136.743 103.46 136.559 103.164C136.375 102.86 136.123 102.632 135.803 102.48C135.491 102.32 135.143 102.24 134.759 102.24C134.207 102.24 133.735 102.416 133.343 102.768C132.959 103.12 132.739 103.608 132.683 104.232H136.835ZM147.312 101.304C147.824 101.304 148.28 101.412 148.68 101.628C149.08 101.836 149.396 102.152 149.628 102.576C149.86 103 149.976 103.516 149.976 104.124V108H148.896V104.28C148.896 103.624 148.732 103.124 148.404 102.78C148.084 102.428 147.648 102.252 147.096 102.252C146.528 102.252 146.076 102.436 145.74 102.804C145.404 103.164 145.236 103.688 145.236 104.376V108H144.156V104.28C144.156 103.624 143.992 103.124 143.664 102.78C143.344 102.428 142.908 102.252 142.356 102.252C141.788 102.252 141.336 102.436 141 102.804C140.664 103.164 140.496 103.688 140.496 104.376V108H139.404V101.424H140.496V102.372C140.712 102.028 141 101.764 141.36 101.58C141.728 101.396 142.132 101.304 142.572 101.304C143.124 101.304 143.612 101.428 144.036 101.676C144.46 101.924 144.776 102.288 144.984 102.768C145.168 102.304 145.472 101.944 145.896 101.688C146.32 101.432 146.792 101.304 147.312 101.304ZM152.86 102.636C153.076 102.26 153.396 101.948 153.82 101.7C154.252 101.444 154.752 101.316 155.32 101.316C155.904 101.316 156.432 101.456 156.904 101.736C157.384 102.016 157.76 102.412 158.032 102.924C158.304 103.428 158.44 104.016 158.44 104.688C158.44 105.352 158.304 105.944 158.032 106.464C157.76 106.984 157.384 107.388 156.904 107.676C156.432 107.964 155.904 108.108 155.32 108.108C154.76 108.108 154.264 107.984 153.832 107.736C153.408 107.48 153.084 107.164 152.86 106.788V111.12H151.768V101.424H152.86V102.636ZM157.324 104.688C157.324 104.192 157.224 103.76 157.024 103.392C156.824 103.024 156.552 102.744 156.208 102.552C155.872 102.36 155.5 102.264 155.092 102.264C154.692 102.264 154.32 102.364 153.976 102.564C153.64 102.756 153.368 103.04 153.16 103.416C152.96 103.784 152.86 104.212 152.86 104.7C152.86 105.196 152.96 105.632 153.16 106.008C153.368 106.376 153.64 106.66 153.976 106.86C154.32 107.052 154.692 107.148 155.092 107.148C155.5 107.148 155.872 107.052 156.208 106.86C156.552 106.66 156.824 106.376 157.024 106.008C157.224 105.632 157.324 105.192 157.324 104.688ZM160.969 99.12V108H159.877V99.12H160.969ZM162.422 104.688C162.422 104.016 162.558 103.428 162.83 102.924C163.102 102.412 163.474 102.016 163.946 101.736C164.426 101.456 164.958 101.316 165.542 101.316C166.118 101.316 166.618 101.44 167.042 101.688C167.466 101.936 167.782 102.248 167.99 102.624V101.424H169.094V108H167.99V106.776C167.774 107.16 167.45 107.48 167.018 107.736C166.594 107.984 166.098 108.108 165.53 108.108C164.946 108.108 164.418 107.964 163.946 107.676C163.474 107.388 163.102 106.984 162.83 106.464C162.558 105.944 162.422 105.352 162.422 104.688ZM167.99 104.7C167.99 104.204 167.89 103.772 167.69 103.404C167.49 103.036 167.218 102.756 166.874 102.564C166.538 102.364 166.166 102.264 165.758 102.264C165.35 102.264 164.978 102.36 164.642 102.552C164.306 102.744 164.038 103.024 163.838 103.392C163.638 103.76 163.538 104.192 163.538 104.688C163.538 105.192 163.638 105.632 163.838 106.008C164.038 106.376 164.306 106.66 164.642 106.86C164.978 107.052 165.35 107.148 165.758 107.148C166.166 107.148 166.538 107.052 166.874 106.86C167.218 106.66 167.49 106.376 167.69 106.008C167.89 105.632 167.99 105.196 167.99 104.7ZM172.272 102.324V106.2C172.272 106.52 172.34 106.748 172.476 106.884C172.612 107.012 172.848 107.076 173.184 107.076H173.988V108H173.004C172.396 108 171.94 107.86 171.636 107.58C171.332 107.3 171.18 106.84 171.18 106.2V102.324H170.328V101.424H171.18V99.768H172.272V101.424H173.988V102.324H172.272ZM181.311 104.46C181.311 104.668 181.299 104.888 181.275 105.12H176.019C176.059 105.768 176.279 106.276 176.679 106.644C177.087 107.004 177.579 107.184 178.155 107.184C178.627 107.184 179.019 107.076 179.331 106.86C179.651 106.636 179.875 106.34 180.003 105.972H181.179C181.003 106.604 180.651 107.12 180.123 107.52C179.595 107.912 178.939 108.108 178.155 108.108C177.531 108.108 176.971 107.968 176.475 107.688C175.987 107.408 175.603 107.012 175.323 106.5C175.043 105.98 174.903 105.38 174.903 104.7C174.903 104.02 175.039 103.424 175.311 102.912C175.583 102.4 175.963 102.008 176.451 101.736C176.947 101.456 177.515 101.316 178.155 101.316C178.779 101.316 179.331 101.452 179.811 101.724C180.291 101.996 180.659 102.372 180.915 102.852C181.179 103.324 181.311 103.86 181.311 104.46ZM180.183 104.232C180.183 103.816 180.091 103.46 179.907 103.164C179.723 102.86 179.471 102.632 179.151 102.48C178.839 102.32 178.491 102.24 178.107 102.24C177.555 102.24 177.083 102.416 176.691 102.768C176.307 103.12 176.087 103.608 176.031 104.232H180.183Z"
          fill="#96A5B8"
        />
        <path
          d="M44.016 164.812C44.016 163.996 44.2 163.264 44.568 162.616C44.936 161.96 45.436 161.448 46.068 161.08C46.708 160.712 47.416 160.528 48.192 160.528C49.104 160.528 49.9 160.748 50.58 161.188C51.26 161.628 51.756 162.252 52.068 163.06H50.76C50.528 162.556 50.192 162.168 49.752 161.896C49.32 161.624 48.8 161.488 48.192 161.488C47.608 161.488 47.084 161.624 46.62 161.896C46.156 162.168 45.792 162.556 45.528 163.06C45.264 163.556 45.132 164.14 45.132 164.812C45.132 165.476 45.264 166.06 45.528 166.564C45.792 167.06 46.156 167.444 46.62 167.716C47.084 167.988 47.608 168.124 48.192 168.124C48.8 168.124 49.32 167.992 49.752 167.728C50.192 167.456 50.528 167.068 50.76 166.564H52.068C51.756 167.364 51.26 167.984 50.58 168.424C49.9 168.856 49.104 169.072 48.192 169.072C47.416 169.072 46.708 168.892 46.068 168.532C45.436 168.164 44.936 167.656 44.568 167.008C44.2 166.36 44.016 165.628 44.016 164.812ZM53.2855 165.688C53.2855 165.016 53.4215 164.428 53.6935 163.924C53.9655 163.412 54.3375 163.016 54.8095 162.736C55.2895 162.456 55.8215 162.316 56.4055 162.316C56.9815 162.316 57.4815 162.44 57.9055 162.688C58.3295 162.936 58.6455 163.248 58.8535 163.624V162.424H59.9575V169H58.8535V167.776C58.6375 168.16 58.3135 168.48 57.8815 168.736C57.4575 168.984 56.9615 169.108 56.3935 169.108C55.8095 169.108 55.2815 168.964 54.8095 168.676C54.3375 168.388 53.9655 167.984 53.6935 167.464C53.4215 166.944 53.2855 166.352 53.2855 165.688ZM58.8535 165.7C58.8535 165.204 58.7535 164.772 58.5535 164.404C58.3535 164.036 58.0815 163.756 57.7375 163.564C57.4015 163.364 57.0295 163.264 56.6215 163.264C56.2135 163.264 55.8415 163.36 55.5055 163.552C55.1695 163.744 54.9015 164.024 54.7015 164.392C54.5015 164.76 54.4015 165.192 54.4015 165.688C54.4015 166.192 54.5015 166.632 54.7015 167.008C54.9015 167.376 55.1695 167.66 55.5055 167.86C55.8415 168.052 56.2135 168.148 56.6215 168.148C57.0295 168.148 57.4015 168.052 57.7375 167.86C58.0815 167.66 58.3535 167.376 58.5535 167.008C58.7535 166.632 58.8535 166.196 58.8535 165.7ZM69.7109 162.304C70.2229 162.304 70.6789 162.412 71.0789 162.628C71.4789 162.836 71.7949 163.152 72.0269 163.576C72.2589 164 72.3749 164.516 72.3749 165.124V169H71.2949V165.28C71.2949 164.624 71.1309 164.124 70.8029 163.78C70.4829 163.428 70.0469 163.252 69.4949 163.252C68.9269 163.252 68.4749 163.436 68.1389 163.804C67.8029 164.164 67.6349 164.688 67.6349 165.376V169H66.5549V165.28C66.5549 164.624 66.3909 164.124 66.0629 163.78C65.7429 163.428 65.3069 163.252 64.7549 163.252C64.1869 163.252 63.7349 163.436 63.3989 163.804C63.0629 164.164 62.8949 164.688 62.8949 165.376V169H61.8029V162.424H62.8949V163.372C63.1109 163.028 63.3989 162.764 63.7589 162.58C64.1269 162.396 64.5309 162.304 64.9709 162.304C65.5229 162.304 66.0109 162.428 66.4349 162.676C66.8589 162.924 67.1749 163.288 67.3829 163.768C67.5669 163.304 67.8709 162.944 68.2949 162.688C68.7189 162.432 69.1909 162.304 69.7109 162.304ZM75.2582 163.636C75.4742 163.26 75.7942 162.948 76.2182 162.7C76.6502 162.444 77.1502 162.316 77.7182 162.316C78.3022 162.316 78.8302 162.456 79.3022 162.736C79.7822 163.016 80.1582 163.412 80.4302 163.924C80.7022 164.428 80.8382 165.016 80.8382 165.688C80.8382 166.352 80.7022 166.944 80.4302 167.464C80.1582 167.984 79.7822 168.388 79.3022 168.676C78.8302 168.964 78.3022 169.108 77.7182 169.108C77.1582 169.108 76.6622 168.984 76.2302 168.736C75.8062 168.48 75.4822 168.164 75.2582 167.788V172.12H74.1662V162.424H75.2582V163.636ZM79.7222 165.688C79.7222 165.192 79.6222 164.76 79.4222 164.392C79.2222 164.024 78.9502 163.744 78.6062 163.552C78.2702 163.36 77.8982 163.264 77.4902 163.264C77.0902 163.264 76.7182 163.364 76.3742 163.564C76.0382 163.756 75.7662 164.04 75.5582 164.416C75.3582 164.784 75.2582 165.212 75.2582 165.7C75.2582 166.196 75.3582 166.632 75.5582 167.008C75.7662 167.376 76.0382 167.66 76.3742 167.86C76.7182 168.052 77.0902 168.148 77.4902 168.148C77.8982 168.148 78.2702 168.052 78.6062 167.86C78.9502 167.66 79.2222 167.376 79.4222 167.008C79.6222 166.632 79.7222 166.192 79.7222 165.688ZM81.8676 165.688C81.8676 165.016 82.0036 164.428 82.2756 163.924C82.5476 163.412 82.9196 163.016 83.3916 162.736C83.8716 162.456 84.4036 162.316 84.9876 162.316C85.5636 162.316 86.0636 162.44 86.4876 162.688C86.9116 162.936 87.2276 163.248 87.4356 163.624V162.424H88.5396V169H87.4356V167.776C87.2196 168.16 86.8956 168.48 86.4636 168.736C86.0396 168.984 85.5436 169.108 84.9756 169.108C84.3916 169.108 83.8636 168.964 83.3916 168.676C82.9196 168.388 82.5476 167.984 82.2756 167.464C82.0036 166.944 81.8676 166.352 81.8676 165.688ZM87.4356 165.7C87.4356 165.204 87.3356 164.772 87.1356 164.404C86.9356 164.036 86.6636 163.756 86.3196 163.564C85.9836 163.364 85.6116 163.264 85.2036 163.264C84.7956 163.264 84.4236 163.36 84.0876 163.552C83.7516 163.744 83.4836 164.024 83.2836 164.392C83.0836 164.76 82.9836 165.192 82.9836 165.688C82.9836 166.192 83.0836 166.632 83.2836 167.008C83.4836 167.376 83.7516 167.66 84.0876 167.86C84.4236 168.052 84.7956 168.148 85.2036 168.148C85.6116 168.148 85.9836 168.052 86.3196 167.86C86.6636 167.66 86.9356 167.376 87.1356 167.008C87.3356 166.632 87.4356 166.196 87.4356 165.7ZM90.9489 161.356C90.7409 161.356 90.5649 161.284 90.4209 161.14C90.2769 160.996 90.2049 160.82 90.2049 160.612C90.2049 160.404 90.2769 160.228 90.4209 160.084C90.5649 159.94 90.7409 159.868 90.9489 159.868C91.1489 159.868 91.3169 159.94 91.4529 160.084C91.5969 160.228 91.6689 160.404 91.6689 160.612C91.6689 160.82 91.5969 160.996 91.4529 161.14C91.3169 161.284 91.1489 161.356 90.9489 161.356ZM91.4769 162.424V169H90.3849V162.424H91.4769ZM96.0501 162.316C96.6181 162.316 97.1141 162.44 97.5381 162.688C97.9701 162.936 98.2901 163.248 98.4981 163.624V162.424H99.6021V169.144C99.6021 169.744 99.4741 170.276 99.2181 170.74C98.9621 171.212 98.5941 171.58 98.1141 171.844C97.6421 172.108 97.0901 172.24 96.4581 172.24C95.5941 172.24 94.8741 172.036 94.2981 171.628C93.7221 171.22 93.3821 170.664 93.2781 169.96H94.3581C94.4781 170.36 94.7261 170.68 95.1021 170.92C95.4781 171.168 95.9301 171.292 96.4581 171.292C97.0581 171.292 97.5461 171.104 97.9221 170.728C98.3061 170.352 98.4981 169.824 98.4981 169.144V167.764C98.2821 168.148 97.9621 168.468 97.5381 168.724C97.1141 168.98 96.6181 169.108 96.0501 169.108C95.4661 169.108 94.9341 168.964 94.4541 168.676C93.9821 168.388 93.6101 167.984 93.3381 167.464C93.0661 166.944 92.9301 166.352 92.9301 165.688C92.9301 165.016 93.0661 164.428 93.3381 163.924C93.6101 163.412 93.9821 163.016 94.4541 162.736C94.9341 162.456 95.4661 162.316 96.0501 162.316ZM98.4981 165.7C98.4981 165.204 98.3981 164.772 98.1981 164.404C97.9981 164.036 97.7261 163.756 97.3821 163.564C97.0461 163.364 96.6741 163.264 96.2661 163.264C95.8581 163.264 95.4861 163.36 95.1501 163.552C94.8141 163.744 94.5461 164.024 94.3461 164.392C94.1461 164.76 94.0461 165.192 94.0461 165.688C94.0461 166.192 94.1461 166.632 94.3461 167.008C94.5461 167.376 94.8141 167.66 95.1501 167.86C95.4861 168.052 95.8581 168.148 96.2661 168.148C96.6741 168.148 97.0461 168.052 97.3821 167.86C97.7261 167.66 97.9981 167.376 98.1981 167.008C98.3981 166.632 98.4981 166.196 98.4981 165.7ZM104.651 162.304C105.451 162.304 106.099 162.548 106.595 163.036C107.091 163.516 107.339 164.212 107.339 165.124V169H106.259V165.28C106.259 164.624 106.095 164.124 105.767 163.78C105.439 163.428 104.991 163.252 104.423 163.252C103.847 163.252 103.387 163.432 103.043 163.792C102.707 164.152 102.539 164.676 102.539 165.364V169H101.447V162.424H102.539V163.36C102.755 163.024 103.047 162.764 103.415 162.58C103.791 162.396 104.203 162.304 104.651 162.304ZM117.47 160.636V161.524H115.19V169H114.098V161.524H111.806V160.636H117.47ZM124.815 165.46C124.815 165.668 124.803 165.888 124.779 166.12H119.523C119.563 166.768 119.783 167.276 120.183 167.644C120.591 168.004 121.083 168.184 121.659 168.184C122.131 168.184 122.523 168.076 122.835 167.86C123.155 167.636 123.379 167.34 123.507 166.972H124.683C124.507 167.604 124.155 168.12 123.627 168.52C123.099 168.912 122.443 169.108 121.659 169.108C121.035 169.108 120.475 168.968 119.979 168.688C119.491 168.408 119.107 168.012 118.827 167.5C118.547 166.98 118.407 166.38 118.407 165.7C118.407 165.02 118.543 164.424 118.815 163.912C119.087 163.4 119.467 163.008 119.955 162.736C120.451 162.456 121.019 162.316 121.659 162.316C122.283 162.316 122.835 162.452 123.315 162.724C123.795 162.996 124.163 163.372 124.419 163.852C124.683 164.324 124.815 164.86 124.815 165.46ZM123.687 165.232C123.687 164.816 123.595 164.46 123.411 164.164C123.227 163.86 122.975 163.632 122.655 163.48C122.343 163.32 121.995 163.24 121.611 163.24C121.059 163.24 120.587 163.416 120.195 163.768C119.811 164.12 119.591 164.608 119.535 165.232H123.687ZM134.164 162.304C134.676 162.304 135.132 162.412 135.532 162.628C135.932 162.836 136.248 163.152 136.48 163.576C136.712 164 136.828 164.516 136.828 165.124V169H135.748V165.28C135.748 164.624 135.584 164.124 135.256 163.78C134.936 163.428 134.5 163.252 133.948 163.252C133.38 163.252 132.928 163.436 132.592 163.804C132.256 164.164 132.088 164.688 132.088 165.376V169H131.008V165.28C131.008 164.624 130.844 164.124 130.516 163.78C130.196 163.428 129.76 163.252 129.208 163.252C128.64 163.252 128.188 163.436 127.852 163.804C127.516 164.164 127.348 164.688 127.348 165.376V169H126.256V162.424H127.348V163.372C127.564 163.028 127.852 162.764 128.212 162.58C128.58 162.396 128.984 162.304 129.424 162.304C129.976 162.304 130.464 162.428 130.888 162.676C131.312 162.924 131.628 163.288 131.836 163.768C132.02 163.304 132.324 162.944 132.748 162.688C133.172 162.432 133.644 162.304 134.164 162.304ZM139.711 163.636C139.927 163.26 140.247 162.948 140.671 162.7C141.103 162.444 141.603 162.316 142.171 162.316C142.755 162.316 143.283 162.456 143.755 162.736C144.235 163.016 144.611 163.412 144.883 163.924C145.155 164.428 145.291 165.016 145.291 165.688C145.291 166.352 145.155 166.944 144.883 167.464C144.611 167.984 144.235 168.388 143.755 168.676C143.283 168.964 142.755 169.108 142.171 169.108C141.611 169.108 141.115 168.984 140.683 168.736C140.259 168.48 139.935 168.164 139.711 167.788V172.12H138.619V162.424H139.711V163.636ZM144.175 165.688C144.175 165.192 144.075 164.76 143.875 164.392C143.675 164.024 143.403 163.744 143.059 163.552C142.723 163.36 142.351 163.264 141.943 163.264C141.543 163.264 141.171 163.364 140.827 163.564C140.491 163.756 140.219 164.04 140.011 164.416C139.811 164.784 139.711 165.212 139.711 165.7C139.711 166.196 139.811 166.632 140.011 167.008C140.219 167.376 140.491 167.66 140.827 167.86C141.171 168.052 141.543 168.148 141.943 168.148C142.351 168.148 142.723 168.052 143.059 167.86C143.403 167.66 143.675 167.376 143.875 167.008C144.075 166.632 144.175 166.192 144.175 165.688ZM147.821 160.12V169H146.729V160.12H147.821ZM149.274 165.688C149.274 165.016 149.41 164.428 149.682 163.924C149.954 163.412 150.326 163.016 150.798 162.736C151.278 162.456 151.81 162.316 152.394 162.316C152.97 162.316 153.47 162.44 153.894 162.688C154.318 162.936 154.634 163.248 154.842 163.624V162.424H155.946V169H154.842V167.776C154.626 168.16 154.302 168.48 153.87 168.736C153.446 168.984 152.95 169.108 152.382 169.108C151.798 169.108 151.27 168.964 150.798 168.676C150.326 168.388 149.954 167.984 149.682 167.464C149.41 166.944 149.274 166.352 149.274 165.688ZM154.842 165.7C154.842 165.204 154.742 164.772 154.542 164.404C154.342 164.036 154.07 163.756 153.726 163.564C153.39 163.364 153.018 163.264 152.61 163.264C152.202 163.264 151.83 163.36 151.494 163.552C151.158 163.744 150.89 164.024 150.69 164.392C150.49 164.76 150.39 165.192 150.39 165.688C150.39 166.192 150.49 166.632 150.69 167.008C150.89 167.376 151.158 167.66 151.494 167.86C151.83 168.052 152.202 168.148 152.61 168.148C153.018 168.148 153.39 168.052 153.726 167.86C154.07 167.66 154.342 167.376 154.542 167.008C154.742 166.632 154.842 166.196 154.842 165.7ZM159.123 163.324V167.2C159.123 167.52 159.191 167.748 159.327 167.884C159.463 168.012 159.699 168.076 160.035 168.076H160.839V169H159.855C159.247 169 158.791 168.86 158.487 168.58C158.183 168.3 158.031 167.84 158.031 167.2V163.324H157.179V162.424H158.031V160.768H159.123V162.424H160.839V163.324H159.123ZM168.162 165.46C168.162 165.668 168.15 165.888 168.126 166.12H162.87C162.91 166.768 163.13 167.276 163.53 167.644C163.938 168.004 164.43 168.184 165.006 168.184C165.478 168.184 165.87 168.076 166.182 167.86C166.502 167.636 166.726 167.34 166.854 166.972H168.03C167.854 167.604 167.502 168.12 166.974 168.52C166.446 168.912 165.79 169.108 165.006 169.108C164.382 169.108 163.822 168.968 163.326 168.688C162.838 168.408 162.454 168.012 162.174 167.5C161.894 166.98 161.754 166.38 161.754 165.7C161.754 165.02 161.89 164.424 162.162 163.912C162.434 163.4 162.814 163.008 163.302 162.736C163.798 162.456 164.366 162.316 165.006 162.316C165.63 162.316 166.182 162.452 166.662 162.724C167.142 162.996 167.51 163.372 167.766 163.852C168.03 164.324 168.162 164.86 168.162 165.46ZM167.034 165.232C167.034 164.816 166.942 164.46 166.758 164.164C166.574 163.86 166.322 163.632 166.002 163.48C165.69 163.32 165.342 163.24 164.958 163.24C164.406 163.24 163.934 163.416 163.542 163.768C163.158 164.12 162.938 164.608 162.882 165.232H167.034Z"
          fill="#336DFF"
        />
        <path
          d="M44.016 225.812C44.016 224.996 44.2 224.264 44.568 223.616C44.936 222.96 45.436 222.448 46.068 222.08C46.708 221.712 47.416 221.528 48.192 221.528C49.104 221.528 49.9 221.748 50.58 222.188C51.26 222.628 51.756 223.252 52.068 224.06H50.76C50.528 223.556 50.192 223.168 49.752 222.896C49.32 222.624 48.8 222.488 48.192 222.488C47.608 222.488 47.084 222.624 46.62 222.896C46.156 223.168 45.792 223.556 45.528 224.06C45.264 224.556 45.132 225.14 45.132 225.812C45.132 226.476 45.264 227.06 45.528 227.564C45.792 228.06 46.156 228.444 46.62 228.716C47.084 228.988 47.608 229.124 48.192 229.124C48.8 229.124 49.32 228.992 49.752 228.728C50.192 228.456 50.528 228.068 50.76 227.564H52.068C51.756 228.364 51.26 228.984 50.58 229.424C49.9 229.856 49.104 230.072 48.192 230.072C47.416 230.072 46.708 229.892 46.068 229.532C45.436 229.164 44.936 228.656 44.568 228.008C44.2 227.36 44.016 226.628 44.016 225.812ZM59.5255 223.424V230H58.4335V229.028C58.2255 229.364 57.9335 229.628 57.5575 229.82C57.1895 230.004 56.7815 230.096 56.3335 230.096C55.8215 230.096 55.3615 229.992 54.9535 229.784C54.5455 229.568 54.2215 229.248 53.9815 228.824C53.7495 228.4 53.6335 227.884 53.6335 227.276V223.424H54.7135V227.132C54.7135 227.78 54.8775 228.28 55.2055 228.632C55.5335 228.976 55.9815 229.148 56.5495 229.148C57.1335 229.148 57.5935 228.968 57.9295 228.608C58.2655 228.248 58.4335 227.724 58.4335 227.036V223.424H59.5255ZM63.6973 230.108C63.1933 230.108 62.7413 230.024 62.3413 229.856C61.9413 229.68 61.6253 229.44 61.3933 229.136C61.1613 228.824 61.0333 228.468 61.0093 228.068H62.1373C62.1693 228.396 62.3213 228.664 62.5933 228.872C62.8733 229.08 63.2373 229.184 63.6853 229.184C64.1013 229.184 64.4293 229.092 64.6693 228.908C64.9093 228.724 65.0293 228.492 65.0293 228.212C65.0293 227.924 64.9013 227.712 64.6453 227.576C64.3893 227.432 63.9933 227.292 63.4573 227.156C62.9693 227.028 62.5693 226.9 62.2573 226.772C61.9533 226.636 61.6893 226.44 61.4653 226.184C61.2493 225.92 61.1413 225.576 61.1413 225.152C61.1413 224.816 61.2413 224.508 61.4413 224.228C61.6413 223.948 61.9253 223.728 62.2933 223.568C62.6613 223.4 63.0813 223.316 63.5533 223.316C64.2813 223.316 64.8693 223.5 65.3173 223.868C65.7653 224.236 66.0053 224.74 66.0373 225.38H64.9453C64.9213 225.036 64.7813 224.76 64.5253 224.552C64.2773 224.344 63.9413 224.24 63.5173 224.24C63.1253 224.24 62.8133 224.324 62.5813 224.492C62.3493 224.66 62.2333 224.88 62.2333 225.152C62.2333 225.368 62.3013 225.548 62.4373 225.692C62.5813 225.828 62.7573 225.94 62.9653 226.028C63.1813 226.108 63.4773 226.2 63.8533 226.304C64.3253 226.432 64.7093 226.56 65.0053 226.688C65.3013 226.808 65.5533 226.992 65.7613 227.24C65.9773 227.488 66.0893 227.812 66.0973 228.212C66.0973 228.572 65.9973 228.896 65.7973 229.184C65.5973 229.472 65.3133 229.7 64.9453 229.868C64.5853 230.028 64.1693 230.108 63.6973 230.108ZM68.9708 224.324V228.2C68.9708 228.52 69.0388 228.748 69.1748 228.884C69.3108 229.012 69.5468 229.076 69.8828 229.076H70.6868V230H69.7028C69.0948 230 68.6388 229.86 68.3348 229.58C68.0308 229.3 67.8788 228.84 67.8788 228.2V224.324H67.0268V223.424H67.8788V221.768H68.9708V223.424H70.6868V224.324H68.9708ZM74.8779 230.108C74.2619 230.108 73.7019 229.968 73.1979 229.688C72.7019 229.408 72.3099 229.012 72.0219 228.5C71.7419 227.98 71.6019 227.38 71.6019 226.7C71.6019 226.028 71.7459 225.436 72.0339 224.924C72.3299 224.404 72.7299 224.008 73.2339 223.736C73.7379 223.456 74.3019 223.316 74.9259 223.316C75.5499 223.316 76.1139 223.456 76.6179 223.736C77.1219 224.008 77.5179 224.4 77.8059 224.912C78.1019 225.424 78.2499 226.02 78.2499 226.7C78.2499 227.38 78.0979 227.98 77.7939 228.5C77.4979 229.012 77.0939 229.408 76.5819 229.688C76.0699 229.968 75.5019 230.108 74.8779 230.108ZM74.8779 229.148C75.2699 229.148 75.6379 229.056 75.9819 228.872C76.3259 228.688 76.6019 228.412 76.8099 228.044C77.0259 227.676 77.1339 227.228 77.1339 226.7C77.1339 226.172 77.0299 225.724 76.8219 225.356C76.6139 224.988 76.3419 224.716 76.0059 224.54C75.6699 224.356 75.3059 224.264 74.9139 224.264C74.5139 224.264 74.1459 224.356 73.8099 224.54C73.4819 224.716 73.2179 224.988 73.0179 225.356C72.8179 225.724 72.7179 226.172 72.7179 226.7C72.7179 227.236 72.8139 227.688 73.0059 228.056C73.2059 228.424 73.4699 228.7 73.7979 228.884C74.1259 229.06 74.4859 229.148 74.8779 229.148ZM87.5937 223.304C88.1057 223.304 88.5617 223.412 88.9617 223.628C89.3617 223.836 89.6777 224.152 89.9097 224.576C90.1417 225 90.2577 225.516 90.2577 226.124V230H89.1777V226.28C89.1777 225.624 89.0137 225.124 88.6857 224.78C88.3657 224.428 87.9297 224.252 87.3777 224.252C86.8097 224.252 86.3577 224.436 86.0217 224.804C85.6857 225.164 85.5177 225.688 85.5177 226.376V230H84.4377V226.28C84.4377 225.624 84.2737 225.124 83.9457 224.78C83.6257 224.428 83.1897 224.252 82.6377 224.252C82.0697 224.252 81.6177 224.436 81.2817 224.804C80.9457 225.164 80.7777 225.688 80.7777 226.376V230H79.6857V223.424H80.7777V224.372C80.9937 224.028 81.2817 223.764 81.6417 223.58C82.0097 223.396 82.4137 223.304 82.8537 223.304C83.4057 223.304 83.8937 223.428 84.3177 223.676C84.7417 223.924 85.0577 224.288 85.2657 224.768C85.4497 224.304 85.7537 223.944 86.1777 223.688C86.6017 223.432 87.0737 223.304 87.5937 223.304ZM97.8522 221.636C98.7642 221.636 99.5522 221.808 100.216 222.152C100.888 222.488 101.4 222.972 101.752 223.604C102.112 224.236 102.292 224.98 102.292 225.836C102.292 226.692 102.112 227.436 101.752 228.068C101.4 228.692 100.888 229.172 100.216 229.508C99.5522 229.836 98.7642 230 97.8522 230H95.2482V221.636H97.8522ZM97.8522 229.1C98.9322 229.1 99.7562 228.816 100.324 228.248C100.892 227.672 101.176 226.868 101.176 225.836C101.176 224.796 100.888 223.984 100.312 223.4C99.7442 222.816 98.9242 222.524 97.8522 222.524H96.3402V229.1H97.8522ZM103.325 226.688C103.325 226.016 103.461 225.428 103.733 224.924C104.005 224.412 104.377 224.016 104.849 223.736C105.329 223.456 105.861 223.316 106.445 223.316C107.021 223.316 107.521 223.44 107.945 223.688C108.369 223.936 108.685 224.248 108.893 224.624V223.424H109.997V230H108.893V228.776C108.677 229.16 108.353 229.48 107.921 229.736C107.497 229.984 107.001 230.108 106.433 230.108C105.849 230.108 105.321 229.964 104.849 229.676C104.377 229.388 104.005 228.984 103.733 228.464C103.461 227.944 103.325 227.352 103.325 226.688ZM108.893 226.7C108.893 226.204 108.793 225.772 108.593 225.404C108.393 225.036 108.121 224.756 107.777 224.564C107.441 224.364 107.069 224.264 106.661 224.264C106.253 224.264 105.881 224.36 105.545 224.552C105.209 224.744 104.941 225.024 104.741 225.392C104.541 225.76 104.441 226.192 104.441 226.688C104.441 227.192 104.541 227.632 104.741 228.008C104.941 228.376 105.209 228.66 105.545 228.86C105.881 229.052 106.253 229.148 106.661 229.148C107.069 229.148 107.441 229.052 107.777 228.86C108.121 228.66 108.393 228.376 108.593 228.008C108.793 227.632 108.893 227.196 108.893 226.7ZM114.17 230.108C113.666 230.108 113.214 230.024 112.814 229.856C112.414 229.68 112.098 229.44 111.866 229.136C111.634 228.824 111.506 228.468 111.482 228.068H112.61C112.642 228.396 112.794 228.664 113.066 228.872C113.346 229.08 113.71 229.184 114.158 229.184C114.574 229.184 114.902 229.092 115.142 228.908C115.382 228.724 115.502 228.492 115.502 228.212C115.502 227.924 115.374 227.712 115.118 227.576C114.862 227.432 114.466 227.292 113.93 227.156C113.442 227.028 113.042 226.9 112.73 226.772C112.426 226.636 112.162 226.44 111.938 226.184C111.722 225.92 111.614 225.576 111.614 225.152C111.614 224.816 111.714 224.508 111.914 224.228C112.114 223.948 112.398 223.728 112.766 223.568C113.134 223.4 113.554 223.316 114.026 223.316C114.754 223.316 115.342 223.5 115.79 223.868C116.238 224.236 116.478 224.74 116.51 225.38H115.418C115.394 225.036 115.254 224.76 114.998 224.552C114.75 224.344 114.414 224.24 113.99 224.24C113.598 224.24 113.286 224.324 113.054 224.492C112.822 224.66 112.706 224.88 112.706 225.152C112.706 225.368 112.774 225.548 112.91 225.692C113.054 225.828 113.23 225.94 113.438 226.028C113.654 226.108 113.95 226.2 114.326 226.304C114.798 226.432 115.182 226.56 115.478 226.688C115.774 226.808 116.026 226.992 116.234 227.24C116.45 227.488 116.562 227.812 116.57 228.212C116.57 228.572 116.47 228.896 116.27 229.184C116.07 229.472 115.786 229.7 115.418 229.868C115.058 230.028 114.642 230.108 114.17 230.108ZM121.376 223.304C121.872 223.304 122.32 223.412 122.72 223.628C123.12 223.836 123.432 224.152 123.656 224.576C123.888 225 124.004 225.516 124.004 226.124V230H122.924V226.28C122.924 225.624 122.76 225.124 122.432 224.78C122.104 224.428 121.656 224.252 121.088 224.252C120.512 224.252 120.052 224.432 119.708 224.792C119.372 225.152 119.204 225.676 119.204 226.364V230H118.112V221.12H119.204V224.36C119.42 224.024 119.716 223.764 120.092 223.58C120.476 223.396 120.904 223.304 121.376 223.304ZM126.879 224.648C127.103 224.256 127.431 223.936 127.863 223.688C128.295 223.44 128.787 223.316 129.339 223.316C129.931 223.316 130.463 223.456 130.935 223.736C131.407 224.016 131.779 224.412 132.051 224.924C132.323 225.428 132.459 226.016 132.459 226.688C132.459 227.352 132.323 227.944 132.051 228.464C131.779 228.984 131.403 229.388 130.923 229.676C130.451 229.964 129.923 230.108 129.339 230.108C128.771 230.108 128.271 229.984 127.839 229.736C127.415 229.488 127.095 229.172 126.879 228.788V230H125.787V221.12H126.879V224.648ZM131.343 226.688C131.343 226.192 131.243 225.76 131.043 225.392C130.843 225.024 130.571 224.744 130.227 224.552C129.891 224.36 129.519 224.264 129.111 224.264C128.711 224.264 128.339 224.364 127.995 224.564C127.659 224.756 127.387 225.04 127.179 225.416C126.979 225.784 126.879 226.212 126.879 226.7C126.879 227.196 126.979 227.632 127.179 228.008C127.387 228.376 127.659 228.66 127.995 228.86C128.339 229.052 128.711 229.148 129.111 229.148C129.519 229.148 129.891 229.052 130.227 228.86C130.571 228.66 130.843 228.376 131.043 228.008C131.243 227.632 131.343 227.192 131.343 226.688ZM136.765 230.108C136.149 230.108 135.589 229.968 135.085 229.688C134.589 229.408 134.197 229.012 133.909 228.5C133.629 227.98 133.489 227.38 133.489 226.7C133.489 226.028 133.633 225.436 133.921 224.924C134.217 224.404 134.617 224.008 135.121 223.736C135.625 223.456 136.189 223.316 136.813 223.316C137.437 223.316 138.001 223.456 138.505 223.736C139.009 224.008 139.405 224.4 139.693 224.912C139.989 225.424 140.137 226.02 140.137 226.7C140.137 227.38 139.985 227.98 139.681 228.5C139.385 229.012 138.981 229.408 138.469 229.688C137.957 229.968 137.389 230.108 136.765 230.108ZM136.765 229.148C137.157 229.148 137.525 229.056 137.869 228.872C138.213 228.688 138.489 228.412 138.697 228.044C138.913 227.676 139.021 227.228 139.021 226.7C139.021 226.172 138.917 225.724 138.709 225.356C138.501 224.988 138.229 224.716 137.893 224.54C137.557 224.356 137.193 224.264 136.801 224.264C136.401 224.264 136.033 224.356 135.697 224.54C135.369 224.716 135.105 224.988 134.905 225.356C134.705 225.724 134.605 226.172 134.605 226.7C134.605 227.236 134.701 227.688 134.893 228.056C135.093 228.424 135.357 228.7 135.685 228.884C136.013 229.06 136.373 229.148 136.765 229.148ZM141.164 226.688C141.164 226.016 141.3 225.428 141.572 224.924C141.844 224.412 142.216 224.016 142.688 223.736C143.168 223.456 143.7 223.316 144.284 223.316C144.86 223.316 145.36 223.44 145.784 223.688C146.208 223.936 146.524 224.248 146.732 224.624V223.424H147.836V230H146.732V228.776C146.516 229.16 146.192 229.48 145.76 229.736C145.336 229.984 144.84 230.108 144.272 230.108C143.688 230.108 143.16 229.964 142.688 229.676C142.216 229.388 141.844 228.984 141.572 228.464C141.3 227.944 141.164 227.352 141.164 226.688ZM146.732 226.7C146.732 226.204 146.632 225.772 146.432 225.404C146.232 225.036 145.96 224.756 145.616 224.564C145.28 224.364 144.908 224.264 144.5 224.264C144.092 224.264 143.72 224.36 143.384 224.552C143.048 224.744 142.78 225.024 142.58 225.392C142.38 225.76 142.28 226.192 142.28 226.688C142.28 227.192 142.38 227.632 142.58 228.008C142.78 228.376 143.048 228.66 143.384 228.86C143.72 229.052 144.092 229.148 144.5 229.148C144.908 229.148 145.28 229.052 145.616 228.86C145.96 228.66 146.232 228.376 146.432 228.008C146.632 227.632 146.732 227.196 146.732 226.7ZM150.774 224.492C150.966 224.116 151.238 223.824 151.59 223.616C151.95 223.408 152.386 223.304 152.898 223.304V224.432H152.61C151.386 224.432 150.774 225.096 150.774 226.424V230H149.682V223.424H150.774V224.492ZM153.75 226.688C153.75 226.016 153.886 225.428 154.158 224.924C154.43 224.412 154.802 224.016 155.274 223.736C155.754 223.456 156.29 223.316 156.882 223.316C157.394 223.316 157.87 223.436 158.31 223.676C158.75 223.908 159.086 224.216 159.318 224.6V221.12H160.422V230H159.318V228.764C159.102 229.156 158.782 229.48 158.358 229.736C157.934 229.984 157.438 230.108 156.87 230.108C156.286 230.108 155.754 229.964 155.274 229.676C154.802 229.388 154.43 228.984 154.158 228.464C153.886 227.944 153.75 227.352 153.75 226.688ZM159.318 226.7C159.318 226.204 159.218 225.772 159.018 225.404C158.818 225.036 158.546 224.756 158.202 224.564C157.866 224.364 157.494 224.264 157.086 224.264C156.678 224.264 156.306 224.36 155.97 224.552C155.634 224.744 155.366 225.024 155.166 225.392C154.966 225.76 154.866 226.192 154.866 226.688C154.866 227.192 154.966 227.632 155.166 228.008C155.366 228.376 155.634 228.66 155.97 228.86C156.306 229.052 156.678 229.148 157.086 229.148C157.494 229.148 157.866 229.052 158.202 228.86C158.546 228.66 158.818 228.376 159.018 228.008C159.218 227.632 159.318 227.196 159.318 226.7ZM165.155 229.124C166.171 228.308 166.967 227.64 167.543 227.12C168.119 226.592 168.603 226.044 168.995 225.476C169.395 224.9 169.595 224.336 169.595 223.784C169.595 223.264 169.467 222.856 169.211 222.56C168.963 222.256 168.559 222.104 167.999 222.104C167.455 222.104 167.031 222.276 166.727 222.62C166.431 222.956 166.271 223.408 166.247 223.976H165.191C165.223 223.08 165.495 222.388 166.007 221.9C166.519 221.412 167.179 221.168 167.987 221.168C168.811 221.168 169.463 221.396 169.943 221.852C170.431 222.308 170.675 222.936 170.675 223.736C170.675 224.4 170.475 225.048 170.075 225.68C169.683 226.304 169.235 226.856 168.731 227.336C168.227 227.808 167.583 228.36 166.799 228.992H170.927V229.904H165.155V229.124Z"
          fill="#96A5B8"
        />
        <path d="M0.5 73.6453H280.5" stroke="#96A5B8" strokeDasharray="2 2" />
        <g filter="url(#filter0_d_10323_19592)">
          <rect
            x="1"
            y="74.5"
            width="279"
            height="182"
            rx="15.5"
            stroke="#61A1FF"
          />
        </g>
      </g>
      <rect x="1" y="0.5" width="279" height="59" rx="15.5" fill="#F9FAFB" />
      <rect x="1" y="0.5" width="279" height="59" rx="15.5" stroke="#61A1FF" />
      <path
        d="M30.3919 21.8458L30.7631 27.3658L30.9473 30.1402C30.9493 30.4255 30.994 30.709 31.0803 30.9814C31.3028 31.5102 31.8383 31.8462 32.4208 31.8227L41.2971 31.242C41.6815 31.2358 42.0527 31.3795 42.3289 31.6418C42.5592 31.8603 42.7079 32.1462 42.7548 32.4536L42.7705 32.6403C42.4032 37.7266 38.6676 41.969 33.5919 43.064C28.5161 44.1591 23.3111 41.8458 20.8029 37.3799C20.0799 36.0824 19.6282 34.6564 19.4745 33.1854C19.4103 32.7499 19.382 32.31 19.39 31.87C19.382 26.417 23.2653 21.7027 28.7011 20.5661C29.3553 20.4643 29.9967 20.8106 30.2591 21.4074C30.3269 21.5456 30.3717 21.6937 30.3919 21.8458Z"
        fill="#336DFF"
      />
      <path
        d="M46.0554 27.083L46.0461 27.1265L46.0191 27.1897L46.0229 27.3632C46.009 27.5929 45.9202 27.814 45.7674 27.9926C45.6081 28.1786 45.3905 28.3053 45.1509 28.3545L45.0047 28.3745L34.7637 29.0381C34.423 29.0717 34.0838 28.9618 33.8306 28.736C33.6194 28.5476 33.4845 28.2934 33.4463 28.0196L32.759 17.7934C32.747 17.7588 32.747 17.7213 32.759 17.6867C32.7683 17.4049 32.8925 17.1384 33.1035 16.9469C33.3145 16.7555 33.595 16.6549 33.8821 16.6677C39.9619 16.8224 45.0718 21.1943 46.0554 27.083Z"
        fill="#61A1FF"
      />
      <path
        d="M65.9187 36.112C65.172 36.112 64.5 35.984 63.9027 35.728C63.3054 35.4613 62.836 35.088 62.4947 34.608C62.1534 34.128 61.9827 33.568 61.9827 32.928H63.9347C63.9774 33.408 64.164 33.8027 64.4947 34.112C64.836 34.4213 65.3107 34.576 65.9187 34.576C66.548 34.576 67.0387 34.4267 67.3907 34.128C67.7427 33.8187 67.9187 33.424 67.9187 32.944C67.9187 32.5707 67.8067 32.2667 67.5827 32.032C67.3694 31.7973 67.0974 31.616 66.7667 31.488C66.4467 31.36 65.9987 31.2213 65.4227 31.072C64.6974 30.88 64.1054 30.688 63.6467 30.496C63.1987 30.2933 62.8147 29.984 62.4947 29.568C62.1747 29.152 62.0147 28.5973 62.0147 27.904C62.0147 27.264 62.1747 26.704 62.4947 26.224C62.8147 25.744 63.2627 25.376 63.8387 25.12C64.4147 24.864 65.0814 24.736 65.8387 24.736C66.916 24.736 67.796 25.008 68.4787 25.552C69.172 26.0853 69.556 26.8213 69.6307 27.76H67.6147C67.5827 27.3547 67.3907 27.008 67.0387 26.72C66.6867 26.432 66.2227 26.288 65.6467 26.288C65.124 26.288 64.6974 26.4213 64.3667 26.688C64.036 26.9547 63.8707 27.3387 63.8707 27.84C63.8707 28.1813 63.972 28.464 64.1747 28.688C64.388 28.9013 64.6547 29.072 64.9747 29.2C65.2947 29.328 65.732 29.4667 66.2867 29.616C67.0227 29.8187 67.62 30.0213 68.0787 30.224C68.548 30.4267 68.9427 30.7413 69.2627 31.168C69.5934 31.584 69.7587 32.144 69.7587 32.848C69.7587 33.4133 69.604 33.9467 69.2947 34.448C68.996 34.9493 68.5534 35.3547 67.9667 35.664C67.3907 35.9627 66.708 36.112 65.9187 36.112ZM79.9909 31.376C79.9909 31.7067 79.9696 32.0053 79.9269 32.272H73.1909C73.2443 32.976 73.5056 33.5413 73.9749 33.968C74.4443 34.3947 75.0203 34.608 75.7029 34.608C76.6843 34.608 77.3776 34.1973 77.7829 33.376H79.7509C79.4843 34.1867 78.9989 34.8533 78.2949 35.376C77.6016 35.888 76.7376 36.144 75.7029 36.144C74.8603 36.144 74.1029 35.9573 73.4309 35.584C72.7696 35.2 72.2469 34.6667 71.8629 33.984C71.4896 33.2907 71.3029 32.4907 71.3029 31.584C71.3029 30.6773 71.4843 29.8827 71.8469 29.2C72.2203 28.5067 72.7376 27.9733 73.3989 27.6C74.0709 27.2267 74.8389 27.04 75.7029 27.04C76.5349 27.04 77.2763 27.2213 77.9269 27.584C78.5776 27.9467 79.0843 28.4587 79.4469 29.12C79.8096 29.7707 79.9909 30.5227 79.9909 31.376ZM78.0869 30.8C78.0763 30.128 77.8363 29.5893 77.3669 29.184C76.8976 28.7787 76.3163 28.576 75.6229 28.576C74.9936 28.576 74.4549 28.7787 74.0069 29.184C73.5589 29.5787 73.2923 30.1173 73.2069 30.8H78.0869ZM83.6099 24.16V36H81.7859V24.16H83.6099ZM94.0847 31.376C94.0847 31.7067 94.0634 32.0053 94.0207 32.272H87.2847C87.338 32.976 87.5994 33.5413 88.0687 33.968C88.538 34.3947 89.114 34.608 89.7967 34.608C90.778 34.608 91.4714 34.1973 91.8767 33.376H93.8447C93.578 34.1867 93.0927 34.8533 92.3887 35.376C91.6954 35.888 90.8314 36.144 89.7967 36.144C88.954 36.144 88.1967 35.9573 87.5247 35.584C86.8634 35.2 86.3407 34.6667 85.9567 33.984C85.5834 33.2907 85.3967 32.4907 85.3967 31.584C85.3967 30.6773 85.578 29.8827 85.9407 29.2C86.314 28.5067 86.8314 27.9733 87.4927 27.6C88.1647 27.2267 88.9327 27.04 89.7967 27.04C90.6287 27.04 91.37 27.2213 92.0207 27.584C92.6714 27.9467 93.178 28.4587 93.5407 29.12C93.9034 29.7707 94.0847 30.5227 94.0847 31.376ZM92.1807 30.8C92.17 30.128 91.93 29.5893 91.4607 29.184C90.9914 28.7787 90.41 28.576 89.7167 28.576C89.0874 28.576 88.5487 28.7787 88.1007 29.184C87.6527 29.5787 87.386 30.1173 87.3007 30.8H92.1807ZM95.2717 31.584C95.2717 30.6773 95.453 29.8827 95.8157 29.2C96.189 28.5067 96.701 27.9733 97.3517 27.6C98.0024 27.2267 98.749 27.04 99.5917 27.04C100.658 27.04 101.538 27.296 102.232 27.808C102.936 28.3093 103.41 29.0293 103.656 29.968H101.688C101.528 29.5307 101.272 29.1893 100.92 28.944C100.568 28.6987 100.125 28.576 99.5917 28.576C98.845 28.576 98.2477 28.8427 97.7997 29.376C97.3624 29.8987 97.1437 30.6347 97.1437 31.584C97.1437 32.5333 97.3624 33.2747 97.7997 33.808C98.2477 34.3413 98.845 34.608 99.5917 34.608C100.648 34.608 101.346 34.144 101.688 33.216H103.656C103.4 34.112 102.92 34.8267 102.216 35.36C101.512 35.8827 100.637 36.144 99.5917 36.144C98.749 36.144 98.0024 35.9573 97.3517 35.584C96.701 35.2 96.189 34.6667 95.8157 33.984C95.453 33.2907 95.2717 32.4907 95.2717 31.584ZM107.601 28.672V33.552C107.601 33.8827 107.676 34.1227 107.825 34.272C107.985 34.4107 108.252 34.48 108.625 34.48H109.745V36H108.305C107.484 36 106.855 35.808 106.417 35.424C105.98 35.04 105.761 34.416 105.761 33.552V28.672H104.721V27.184H105.761V24.992H107.601V27.184H109.745V28.672H107.601ZM119.507 31.376C119.507 31.7067 119.485 32.0053 119.443 32.272H112.707C112.76 32.976 113.021 33.5413 113.491 33.968C113.96 34.3947 114.536 34.608 115.219 34.608C116.2 34.608 116.893 34.1973 117.299 33.376H119.267C119 34.1867 118.515 34.8533 117.811 35.376C117.117 35.888 116.253 36.144 115.219 36.144C114.376 36.144 113.619 35.9573 112.947 35.584C112.285 35.2 111.763 34.6667 111.379 33.984C111.005 33.2907 110.819 32.4907 110.819 31.584C110.819 30.6773 111 29.8827 111.363 29.2C111.736 28.5067 112.253 27.9733 112.915 27.6C113.587 27.2267 114.355 27.04 115.219 27.04C116.051 27.04 116.792 27.2213 117.443 27.584C118.093 27.9467 118.6 28.4587 118.963 29.12C119.325 29.7707 119.507 30.5227 119.507 31.376ZM117.603 30.8C117.592 30.128 117.352 29.5893 116.883 29.184C116.413 28.7787 115.832 28.576 115.139 28.576C114.509 28.576 113.971 28.7787 113.523 29.184C113.075 29.5787 112.808 30.1173 112.723 30.8H117.603ZM120.694 31.552C120.694 30.6667 120.875 29.8827 121.238 29.2C121.611 28.5173 122.112 27.9893 122.742 27.616C123.382 27.232 124.091 27.04 124.87 27.04C125.446 27.04 126.011 27.168 126.566 27.424C127.131 27.6693 127.579 28 127.91 28.416V24.16H129.75V36H127.91V34.672C127.611 35.0987 127.195 35.4507 126.662 35.728C126.139 36.0053 125.536 36.144 124.854 36.144C124.086 36.144 123.382 35.952 122.742 35.568C122.112 35.1733 121.611 34.6293 121.238 33.936C120.875 33.232 120.694 32.4373 120.694 31.552ZM127.91 31.584C127.91 30.976 127.782 30.448 127.526 30C127.28 29.552 126.955 29.2107 126.55 28.976C126.144 28.7413 125.707 28.624 125.238 28.624C124.768 28.624 124.331 28.7413 123.926 28.976C123.52 29.2 123.19 29.536 122.934 29.984C122.688 30.4213 122.566 30.944 122.566 31.552C122.566 32.16 122.688 32.6933 122.934 33.152C123.19 33.6107 123.52 33.9627 123.926 34.208C124.342 34.4427 124.779 34.56 125.238 34.56C125.707 34.56 126.144 34.4427 126.55 34.208C126.955 33.9733 127.28 33.632 127.526 33.184C127.782 32.7253 127.91 32.192 127.91 31.584ZM139.934 24.88C141.118 24.88 142.152 25.1093 143.038 25.568C143.934 26.016 144.622 26.6667 145.102 27.52C145.592 28.3627 145.838 29.3493 145.838 30.48C145.838 31.6107 145.592 32.592 145.102 33.424C144.622 34.256 143.934 34.896 143.038 35.344C142.152 35.7813 141.118 36 139.934 36H136.302V24.88H139.934ZM139.934 34.512C141.235 34.512 142.232 34.16 142.926 33.456C143.619 32.752 143.966 31.76 143.966 30.48C143.966 29.1893 143.619 28.1813 142.926 27.456C142.232 26.7307 141.235 26.368 139.934 26.368H138.126V34.512H139.934ZM147.037 31.552C147.037 30.6667 147.219 29.8827 147.581 29.2C147.955 28.5173 148.456 27.9893 149.085 27.616C149.725 27.232 150.429 27.04 151.197 27.04C151.891 27.04 152.493 27.1787 153.005 27.456C153.528 27.7227 153.944 28.0587 154.253 28.464V27.184H156.093V36H154.253V34.688C153.944 35.104 153.523 35.4507 152.989 35.728C152.456 36.0053 151.848 36.144 151.165 36.144C150.408 36.144 149.715 35.952 149.085 35.568C148.456 35.1733 147.955 34.6293 147.581 33.936C147.219 33.232 147.037 32.4373 147.037 31.552ZM154.253 31.584C154.253 30.976 154.125 30.448 153.869 30C153.624 29.552 153.299 29.2107 152.893 28.976C152.488 28.7413 152.051 28.624 151.581 28.624C151.112 28.624 150.675 28.7413 150.269 28.976C149.864 29.2 149.533 29.536 149.277 29.984C149.032 30.4213 148.909 30.944 148.909 31.552C148.909 32.16 149.032 32.6933 149.277 33.152C149.533 33.6107 149.864 33.9627 150.269 34.208C150.685 34.4427 151.123 34.56 151.581 34.56C152.051 34.56 152.488 34.4427 152.893 34.208C153.299 33.9733 153.624 33.632 153.869 33.184C154.125 32.7253 154.253 32.192 154.253 31.584ZM161.689 36.144C160.996 36.144 160.372 36.0213 159.817 35.776C159.273 35.52 158.841 35.1787 158.521 34.752C158.201 34.3147 158.03 33.8293 158.009 33.296H159.897C159.929 33.6693 160.105 33.984 160.425 34.24C160.756 34.4853 161.166 34.608 161.657 34.608C162.169 34.608 162.564 34.512 162.841 34.32C163.129 34.1173 163.273 33.8613 163.273 33.552C163.273 33.2213 163.113 32.976 162.793 32.816C162.484 32.656 161.988 32.48 161.305 32.288C160.644 32.1067 160.105 31.9307 159.689 31.76C159.273 31.5893 158.91 31.328 158.601 30.976C158.302 30.624 158.153 30.16 158.153 29.584C158.153 29.1147 158.292 28.688 158.569 28.304C158.846 27.9093 159.241 27.6 159.753 27.376C160.276 27.152 160.873 27.04 161.545 27.04C162.548 27.04 163.353 27.296 163.961 27.808C164.58 28.3093 164.91 28.9973 164.953 29.872H163.129C163.097 29.4773 162.937 29.1627 162.649 28.928C162.361 28.6933 161.972 28.576 161.481 28.576C161.001 28.576 160.633 28.6667 160.377 28.848C160.121 29.0293 159.993 29.2693 159.993 29.568C159.993 29.8027 160.078 30 160.249 30.16C160.42 30.32 160.628 30.448 160.873 30.544C161.118 30.6293 161.481 30.7413 161.961 30.88C162.601 31.0507 163.124 31.2267 163.529 31.408C163.945 31.5787 164.302 31.8347 164.601 32.176C164.9 32.5173 165.054 32.9707 165.065 33.536C165.065 34.0373 164.926 34.4853 164.649 34.88C164.372 35.2747 163.977 35.584 163.465 35.808C162.964 36.032 162.372 36.144 161.689 36.144ZM171.596 27.04C172.268 27.04 172.865 27.184 173.388 27.472C173.921 27.76 174.337 28.1867 174.636 28.752C174.945 29.3173 175.1 30 175.1 30.8V36H173.292V31.072C173.292 30.2827 173.095 29.68 172.7 29.264C172.305 28.8373 171.767 28.624 171.084 28.624C170.401 28.624 169.857 28.8373 169.452 29.264C169.057 29.68 168.86 30.2827 168.86 31.072V36H167.036V24.16H168.86V28.208C169.169 27.8347 169.559 27.5467 170.028 27.344C170.508 27.1413 171.031 27.04 171.596 27.04ZM179.251 28.496C179.56 28.0693 179.981 27.7227 180.515 27.456C181.059 27.1787 181.661 27.04 182.323 27.04C183.101 27.04 183.805 27.2267 184.435 27.6C185.064 27.9733 185.56 28.5067 185.923 29.2C186.285 29.8827 186.467 30.6667 186.467 31.552C186.467 32.4373 186.285 33.232 185.923 33.936C185.56 34.6293 185.059 35.1733 184.419 35.568C183.789 35.952 183.091 36.144 182.323 36.144C181.64 36.144 181.032 36.0107 180.499 35.744C179.976 35.4773 179.56 35.136 179.251 34.72V36H177.427V24.16H179.251V28.496ZM184.611 31.552C184.611 30.944 184.483 30.4213 184.227 29.984C183.981 29.536 183.651 29.2 183.235 28.976C182.829 28.7413 182.392 28.624 181.923 28.624C181.464 28.624 181.027 28.7413 180.611 28.976C180.205 29.2107 179.875 29.552 179.619 30C179.373 30.448 179.251 30.976 179.251 31.584C179.251 32.192 179.373 32.7253 179.619 33.184C179.875 33.632 180.205 33.9733 180.611 34.208C181.027 34.4427 181.464 34.56 181.923 34.56C182.392 34.56 182.829 34.4427 183.235 34.208C183.651 33.9627 183.981 33.6107 184.227 33.152C184.483 32.6933 184.611 32.16 184.611 31.552ZM192.094 36.144C191.262 36.144 190.51 35.9573 189.838 35.584C189.166 35.2 188.638 34.6667 188.254 33.984C187.87 33.2907 187.678 32.4907 187.678 31.584C187.678 30.688 187.876 29.8933 188.27 29.2C188.665 28.5067 189.204 27.9733 189.886 27.6C190.569 27.2267 191.332 27.04 192.174 27.04C193.017 27.04 193.78 27.2267 194.462 27.6C195.145 27.9733 195.684 28.5067 196.078 29.2C196.473 29.8933 196.67 30.688 196.67 31.584C196.67 32.48 196.468 33.2747 196.062 33.968C195.657 34.6613 195.102 35.2 194.398 35.584C193.705 35.9573 192.937 36.144 192.094 36.144ZM192.094 34.56C192.564 34.56 193.001 34.448 193.406 34.224C193.822 34 194.158 33.664 194.414 33.216C194.67 32.768 194.798 32.224 194.798 31.584C194.798 30.944 194.676 30.4053 194.43 29.968C194.185 29.52 193.86 29.184 193.454 28.96C193.049 28.736 192.612 28.624 192.142 28.624C191.673 28.624 191.236 28.736 190.83 28.96C190.436 29.184 190.121 29.52 189.886 29.968C189.652 30.4053 189.534 30.944 189.534 31.584C189.534 32.5333 189.774 33.2693 190.254 33.792C190.745 34.304 191.358 34.56 192.094 34.56ZM197.865 31.552C197.865 30.6667 198.047 29.8827 198.409 29.2C198.783 28.5173 199.284 27.9893 199.913 27.616C200.553 27.232 201.257 27.04 202.025 27.04C202.719 27.04 203.321 27.1787 203.833 27.456C204.356 27.7227 204.772 28.0587 205.081 28.464V27.184H206.921V36H205.081V34.688C204.772 35.104 204.351 35.4507 203.817 35.728C203.284 36.0053 202.676 36.144 201.993 36.144C201.236 36.144 200.543 35.952 199.913 35.568C199.284 35.1733 198.783 34.6293 198.409 33.936C198.047 33.232 197.865 32.4373 197.865 31.552ZM205.081 31.584C205.081 30.976 204.953 30.448 204.697 30C204.452 29.552 204.127 29.2107 203.721 28.976C203.316 28.7413 202.879 28.624 202.409 28.624C201.94 28.624 201.503 28.7413 201.097 28.976C200.692 29.2 200.361 29.536 200.105 29.984C199.86 30.4213 199.737 30.944 199.737 31.552C199.737 32.16 199.86 32.6933 200.105 33.152C200.361 33.6107 200.692 33.9627 201.097 34.208C201.513 34.4427 201.951 34.56 202.409 34.56C202.879 34.56 203.316 34.4427 203.721 34.208C204.127 33.9733 204.452 33.632 204.697 33.184C204.953 32.7253 205.081 32.192 205.081 31.584ZM211.141 28.464C211.408 28.016 211.76 27.6693 212.197 27.424C212.645 27.168 213.173 27.04 213.781 27.04V28.928H213.317C212.603 28.928 212.059 29.1093 211.685 29.472C211.323 29.8347 211.141 30.464 211.141 31.36V36H209.317V27.184H211.141V28.464ZM214.85 31.552C214.85 30.6667 215.031 29.8827 215.394 29.2C215.767 28.5173 216.268 27.9893 216.898 27.616C217.538 27.232 218.247 27.04 219.026 27.04C219.602 27.04 220.167 27.168 220.722 27.424C221.287 27.6693 221.735 28 222.066 28.416V24.16H223.906V36H222.066V34.672C221.767 35.0987 221.351 35.4507 220.818 35.728C220.295 36.0053 219.692 36.144 219.01 36.144C218.242 36.144 217.538 35.952 216.898 35.568C216.268 35.1733 215.767 34.6293 215.394 33.936C215.031 33.232 214.85 32.4373 214.85 31.552ZM222.066 31.584C222.066 30.976 221.938 30.448 221.682 30C221.436 29.552 221.111 29.2107 220.706 28.976C220.3 28.7413 219.863 28.624 219.394 28.624C218.924 28.624 218.487 28.7413 218.082 28.976C217.676 29.2 217.346 29.536 217.09 29.984C216.844 30.4213 216.722 30.944 216.722 31.552C216.722 32.16 216.844 32.6933 217.09 33.152C217.346 33.6107 217.676 33.9627 218.082 34.208C218.498 34.4427 218.935 34.56 219.394 34.56C219.863 34.56 220.3 34.4427 220.706 34.208C221.111 33.9733 221.436 33.632 221.682 33.184C221.938 32.7253 222.066 32.192 222.066 31.584ZM229.502 36.144C228.808 36.144 228.184 36.0213 227.63 35.776C227.086 35.52 226.654 35.1787 226.334 34.752C226.014 34.3147 225.843 33.8293 225.822 33.296H227.71C227.742 33.6693 227.918 33.984 228.238 34.24C228.568 34.4853 228.979 34.608 229.47 34.608C229.982 34.608 230.376 34.512 230.654 34.32C230.942 34.1173 231.086 33.8613 231.086 33.552C231.086 33.2213 230.926 32.976 230.606 32.816C230.296 32.656 229.8 32.48 229.118 32.288C228.456 32.1067 227.918 31.9307 227.502 31.76C227.086 31.5893 226.723 31.328 226.414 30.976C226.115 30.624 225.966 30.16 225.966 29.584C225.966 29.1147 226.104 28.688 226.382 28.304C226.659 27.9093 227.054 27.6 227.566 27.376C228.088 27.152 228.686 27.04 229.358 27.04C230.36 27.04 231.166 27.296 231.774 27.808C232.392 28.3093 232.723 28.9973 232.766 29.872H230.942C230.91 29.4773 230.75 29.1627 230.462 28.928C230.174 28.6933 229.784 28.576 229.294 28.576C228.814 28.576 228.446 28.6667 228.19 28.848C227.934 29.0293 227.806 29.2693 227.806 29.568C227.806 29.8027 227.891 30 228.062 30.16C228.232 30.32 228.44 30.448 228.686 30.544C228.931 30.6293 229.294 30.7413 229.774 30.88C230.414 31.0507 230.936 31.2267 231.342 31.408C231.758 31.5787 232.115 31.8347 232.414 32.176C232.712 32.5173 232.867 32.9707 232.878 33.536C232.878 34.0373 232.739 34.4853 232.462 34.88C232.184 35.2747 231.79 35.584 231.278 35.808C230.776 36.032 230.184 36.144 229.502 36.144Z"
        fill="#05004E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.32 33.0744C260.931 33.463 260.295 33.463 259.906 33.0744L255.559 28.7277C255.435 28.603 255.231 28.603 255.107 28.7277L250.76 33.0744C250.371 33.463 249.735 33.463 249.346 33.0744C248.958 32.6858 248.958 32.0492 249.346 31.6606L253.693 27.3139C254.143 26.8636 254.738 26.6342 255.333 26.6342C255.928 26.6342 256.523 26.8636 256.973 27.3139L261.32 31.6606C261.708 32.0492 261.708 32.6858 261.32 33.0744Z"
        fill="#336DFF"
      />
      <g opacity="0.8">
        <path
          d="M254.582 96.9226H253.082C249.332 96.9226 247.832 98.4226 247.832 102.173V106.673C247.832 110.423 249.332 111.923 253.082 111.923H257.582C261.332 111.923 262.832 110.423 262.832 106.673V105.173"
          stroke="#96A5B8"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M258.362 97.6876L252.452 103.598C252.227 103.823 252.002 104.265 251.957 104.588L251.635 106.845C251.515 107.663 252.092 108.233 252.91 108.12L255.167 107.798C255.482 107.753 255.925 107.528 256.157 107.303L262.067 101.393C263.087 100.373 263.567 99.1876 262.067 97.6876C260.567 96.1876 259.382 96.6676 258.362 97.6876Z"
          stroke="#96A5B8"
          strokeWidth="1.125"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M257.514 98.5351C258.016 100.328 259.419 101.73 261.219 102.24"
          stroke="#96A5B8"
          strokeWidth="1.125"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g opacity="0.8">
        <path
          d="M254.582 219.005H253.082C249.332 219.005 247.832 220.505 247.832 224.255V228.755C247.832 232.505 249.332 234.005 253.082 234.005H257.582C261.332 234.005 262.832 232.505 262.832 228.755V227.255"
          stroke="#96A5B8"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M258.362 219.77L252.452 225.68C252.227 225.905 252.002 226.347 251.957 226.67L251.635 228.927C251.515 229.745 252.092 230.315 252.91 230.202L255.167 229.88C255.482 229.835 255.925 229.61 256.157 229.385L262.067 223.475C263.087 222.455 263.567 221.27 262.067 219.77C260.567 218.27 259.382 218.75 258.362 219.77Z"
          stroke="#96A5B8"
          strokeWidth="1.125"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M257.514 220.617C258.016 222.41 259.419 223.812 261.219 224.322"
          stroke="#96A5B8"
          strokeWidth="1.125"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M254.582 156.42H253.082C249.332 156.42 247.832 157.92 247.832 161.67V166.17C247.832 169.92 249.332 171.42 253.082 171.42H257.582C261.332 171.42 262.832 169.92 262.832 166.17V164.67"
        stroke="#336DFF"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M258.362 157.185L252.452 163.095C252.227 163.32 252.002 163.763 251.957 164.085L251.635 166.343C251.515 167.16 252.092 167.73 252.91 167.618L255.167 167.295C255.482 167.25 255.925 167.025 256.157 166.8L262.067 160.89C263.087 159.87 263.567 158.685 262.067 157.185C260.567 155.685 259.382 156.165 258.362 157.185Z"
        stroke="#336DFF"
        strokeWidth="1.125"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M257.514 158.033C258.016 159.825 259.419 161.228 261.219 161.738"
        stroke="#336DFF"
        strokeWidth="1.125"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#filter1_d_10323_19592)">
        <path
          d="M179.755 154.975C179.071 154.975 178.516 155.422 178.516 155.973V157.73L177.226 152.237C177.198 152.114 177.159 151.994 177.09 151.889C176.921 151.635 176.517 151.188 175.827 151.327C174.944 151.504 174.952 152.362 174.957 152.48C174.958 152.489 174.959 152.497 174.959 152.506C174.99 152.834 175.054 153.87 175.339 155.419C175.629 156.989 176.115 158.492 176.115 159.635L174.664 158.197C174.178 157.714 173.547 157.268 172.89 157.459C172.719 157.509 172.552 157.594 172.412 157.73C172.21 157.929 172.111 158.186 172.067 158.43C171.973 158.944 172.222 159.437 172.514 159.868C173.116 160.756 174.185 162.337 174.778 163.24C175.392 164.177 176.157 164.781 176.539 165.047C176.686 165.149 176.781 165.315 176.781 165.494V166.452C176.781 166.59 176.892 166.701 177.029 166.701H180.499C180.499 166.701 180.713 165.204 181.47 165.204C182.228 165.204 182.482 166.701 182.482 166.701H183.969C184.106 166.701 184.217 166.59 184.217 166.452V164.618C184.217 164.349 184.289 164.084 184.426 163.852L185.267 162.432C185.588 161.89 185.776 161.279 185.817 160.649L185.91 159.216L185.952 158.012L185.92 157.262C185.914 157.106 185.896 156.949 185.829 156.809C185.714 156.569 185.46 156.218 184.954 156.218C184.662 156.218 184.45 156.3 184.3 156.401C184.019 156.591 183.95 156.956 183.905 157.294L183.847 157.73L183.723 156.55C183.7 156.33 183.653 156.107 183.517 155.933C183.338 155.703 183.006 155.419 182.456 155.419C181.992 155.419 181.663 155.621 181.45 155.822C181.209 156.05 181.134 156.389 181.115 156.721L181.057 157.73L180.995 155.973C180.995 155.422 180.44 154.975 179.755 154.975Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M177.337 151.722C177.146 151.434 176.639 150.857 175.769 151.032C175.218 151.143 174.927 151.479 174.787 151.807C174.653 152.118 174.657 152.415 174.661 152.493L174.677 152.684C174.713 153.121 174.794 154.098 175.047 155.473C175.148 156.022 175.274 156.567 175.394 157.084C175.447 157.313 175.498 157.536 175.546 157.751C175.633 158.146 175.707 158.515 175.755 158.857L174.874 157.983C174.62 157.731 174.314 157.474 173.972 157.306C173.627 157.136 173.228 157.049 172.808 157.171C172.601 157.231 172.387 157.337 172.205 157.515C171.945 157.771 171.826 158.094 171.775 158.376C171.658 159.015 171.972 159.598 172.269 160.036C172.871 160.924 173.939 162.504 174.53 163.405C175.173 164.384 175.97 165.014 176.371 165.293C176.445 165.345 176.484 165.423 176.484 165.493V166.451C176.484 166.754 176.728 167 177.029 167H180.499C180.647 167 180.773 166.891 180.794 166.743L180.794 166.741L180.796 166.731C180.797 166.722 180.8 166.708 180.803 166.689C180.81 166.652 180.82 166.599 180.835 166.534C180.865 166.402 180.911 166.231 180.978 166.063C181.045 165.892 181.127 165.742 181.22 165.639C181.309 165.54 181.391 165.503 181.471 165.503C181.552 165.503 181.637 165.541 181.731 165.642C181.828 165.746 181.914 165.898 181.987 166.069C182.058 166.238 182.109 166.41 182.143 166.541C182.159 166.606 182.171 166.66 182.179 166.697C182.183 166.716 182.185 166.73 182.187 166.739L182.189 166.749L182.189 166.751C182.214 166.895 182.338 167 182.482 167H183.97C184.271 167 184.515 166.754 184.515 166.451V164.618C184.515 164.402 184.573 164.19 184.683 164.005L185.523 162.584C185.868 162.001 186.071 161.345 186.115 160.668L186.208 159.235L186.208 159.226L186.25 158.022C186.25 158.014 186.25 158.007 186.25 157.999L186.218 157.249C186.211 157.084 186.192 156.876 186.097 156.678C185.962 156.396 185.629 155.918 184.954 155.918C184.603 155.918 184.334 156.017 184.135 156.152C184.078 156.191 184.028 156.233 183.983 156.279C183.947 156.102 183.88 155.913 183.752 155.747C183.535 155.469 183.124 155.119 182.456 155.119C181.898 155.119 181.5 155.364 181.247 155.603L181.236 155.614C181.046 155.04 180.411 154.675 179.756 154.675C179.132 154.675 178.527 155.006 178.306 155.533L177.516 152.167C177.485 152.032 177.436 151.871 177.337 151.722ZM180.255 166.401L180.255 166.4C180.289 166.25 180.343 166.047 180.425 165.841C180.505 165.638 180.619 165.414 180.78 165.236C180.943 165.055 181.173 164.904 181.471 164.904C181.768 164.904 181.999 165.054 182.166 165.233C182.33 165.41 182.449 165.632 182.534 165.835C182.621 166.04 182.681 166.243 182.719 166.393L182.721 166.401H183.92V164.618C183.92 164.294 184.007 163.976 184.171 163.698L185.012 162.278C185.309 161.776 185.483 161.211 185.521 160.629L185.614 159.201L185.655 158.013L185.624 157.274C185.617 157.127 185.601 157.021 185.561 156.938C185.467 156.741 185.291 156.517 184.954 156.517C184.721 156.517 184.568 156.581 184.466 156.649C184.394 156.698 184.338 156.776 184.294 156.896C184.248 157.019 184.223 157.165 184.201 157.333L184.143 157.769C184.123 157.92 183.995 158.031 183.844 158.029C183.693 158.027 183.568 157.912 183.552 157.761L183.428 156.581C183.406 156.373 183.365 156.222 183.283 156.117C183.142 155.936 182.889 155.717 182.456 155.717C182.087 155.717 181.827 155.876 181.654 156.039C181.499 156.186 181.43 156.426 181.412 156.738L181.355 157.747C181.346 157.907 181.213 158.031 181.054 158.029C180.896 158.027 180.766 157.9 180.76 157.74L180.698 155.983L180.698 155.977L180.698 155.972C180.698 155.645 180.341 155.274 179.756 155.274C179.17 155.274 178.814 155.645 178.814 155.972V157.73C178.814 157.882 178.701 158.009 178.551 158.027C178.401 158.045 178.262 157.946 178.227 157.799L176.937 152.305C176.912 152.195 176.883 152.115 176.843 152.055C176.697 151.835 176.396 151.517 175.886 151.62C175.554 151.686 175.408 151.869 175.333 152.044C175.251 152.235 175.253 152.426 175.255 152.466L175.256 152.478C175.26 152.519 175.264 152.57 175.269 152.632C175.306 153.07 175.385 154.02 175.632 155.363C175.731 155.899 175.852 156.422 175.97 156.932C175.985 156.998 176 157.063 176.015 157.128C176.053 157.294 176.09 157.458 176.126 157.622C176.284 158.337 176.413 159.027 176.413 159.634C176.413 159.755 176.341 159.864 176.23 159.911C176.12 159.957 175.992 159.932 175.907 159.848L174.456 158.409C174.223 158.178 173.97 157.971 173.711 157.844C173.455 157.718 173.211 157.677 172.973 157.746C172.838 157.786 172.718 157.849 172.621 157.944C172.477 158.085 172.398 158.277 172.36 158.484C172.29 158.871 172.473 159.275 172.76 159.699C173.362 160.586 174.433 162.169 175.026 163.075C175.612 163.968 176.344 164.546 176.709 164.8C176.927 164.952 177.079 165.206 177.079 165.493V166.401H180.255Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M182.637 163.92L182.637 159.9L183.342 159.9L183.342 163.92L182.637 163.92Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M180.615 163.92L180.615 159.9L181.32 159.9L181.32 163.92L180.615 163.92Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M178.6 163.92L178.6 159.9L179.305 159.9L179.305 163.92L178.6 163.92Z"
          fill="black"
        />
      </g>
      <path
        d="M24.1 157.5H28.9C32.9 157.5 34.5 159.1 34.5 163.1V167.9C34.5 171.9 32.9 173.5 28.9 173.5H24.1C20.1 173.5 18.5 171.9 18.5 167.9V163.1C18.5 159.1 20.1 157.5 24.1 157.5Z"
        fill="#F9FAFB"
        stroke="#336DFF"
        strokeWidth="1.41451"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1 95.9226H28.9C32.9 95.9226 34.5 97.5226 34.5 101.523V106.323C34.5 110.323 32.9 111.923 28.9 111.923H24.1C20.1 111.923 18.5 110.323 18.5 106.323V101.523C18.5 97.5226 20.1 95.9226 24.1 95.9226Z"
        fill="#F9FAFB"
        stroke="#EDF2F6"
        strokeWidth="1.41451"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1 217.505H28.9C32.9 217.505 34.5 219.105 34.5 223.105V227.905C34.5 231.905 32.9 233.505 28.9 233.505H24.1C20.1 233.505 18.5 231.905 18.5 227.905V223.105C18.5 219.105 20.1 217.505 24.1 217.505Z"
        fill="#F9FAFB"
        stroke="#EDF2F6"
        strokeWidth="1.41451"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_10323_19592"
          x="-4.5"
          y="71"
          width="290"
          height="193"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.556863 0 0 0 0 0.556863 0 0 0 0 0.576471 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10323_19592"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10323_19592"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_10323_19592"
          x="165.8"
          y="146.5"
          width="27"
          height="27"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.2" dy="1" />
          <feGaussianBlur stdDeviation="0.75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10323_19592"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10323_19592"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const DashboardEditIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.6875 1.875H5.5625C2.75 1.875 1.625 3 1.625 5.8125V9.1875C1.625 12 2.75 13.125 5.5625 13.125H8.9375C11.75 13.125 12.875 12 12.875 9.1875V8.0625"
        stroke="#336DFF"
        strokeWidth="0.84375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.52231 2.44877L5.08981 6.88127C4.92106 7.05002 4.75231 7.38189 4.71856 7.62377L4.47668 9.31689C4.38668 9.93002 4.81981 10.3575 5.43293 10.2731L7.12606 10.0313C7.36231 9.99752 7.69419 9.82877 7.86856 9.66002L12.3011 5.22752C13.0661 4.46252 13.4261 3.57377 12.3011 2.44877C11.1761 1.32377 10.2873 1.68377 9.52231 2.44877Z"
        stroke="#336DFF"
        strokeWidth="0.84375"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.88672 3.08435C9.26359 4.42873 10.3155 5.4806 11.6655 5.8631"
        stroke="#336DFF"
        strokeWidth="0.84375"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DashboardDropdownActiveIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2356 4.24866L12.2286 12.6372C12.2114 12.9246 12.2366 13.2131 12.3035 13.4932C12.488 14.0408 12.9945 14.4157 13.5716 14.4319L22.3801 14.4546C22.7603 14.4746 23.1174 14.6447 23.3728 14.9276C23.5857 15.1634 23.7134 15.4614 23.7391 15.7742L23.7422 15.9632C23.0384 21.0588 19.0634 25.0743 13.9753 25.8296C8.88708 26.5848 3.89972 23.8997 1.72092 19.232C1.09346 17.8762 0.742795 16.4097 0.689528 14.9181C0.655281 14.4753 0.65683 14.0305 0.694153 13.5881C1.05173 8.09759 5.20425 3.61696 10.6509 2.84463C11.3041 2.78682 11.9146 3.17939 12.1338 3.79819C12.1916 3.94199 12.2259 4.09408 12.2356 4.24866Z"
        fill="currentColor"
      />
      <path
        d="M26.5799 10.7865L26.5683 10.8274L26.5391 10.886L26.5316 11.0519C26.504 11.2704 26.4067 11.4757 26.2522 11.6364C26.091 11.8037 25.8791 11.9105 25.6514 11.942L25.5132 11.9516L15.8742 11.9207C15.5529 11.9307 15.242 11.8038 15.0191 11.5717C14.8331 11.3781 14.7228 11.1266 14.7045 10.8626L14.7104 1.05294C14.7014 1.01915 14.7037 0.983361 14.7172 0.951112C14.7438 0.682548 14.8771 0.436177 15.0871 0.267026C15.2969 0.0978676 15.5662 0.0200453 15.8344 0.0509213C21.5219 0.593148 26.0324 5.09954 26.5799 10.7865Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DashboardDropdownIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0139 4.24854L12.0069 12.6371C11.9897 12.9245 12.0149 13.2129 12.0819 13.4931C12.2663 14.0407 12.7728 14.4156 13.3499 14.4318L22.1584 14.4545C22.5386 14.4745 22.8957 14.6446 23.1511 14.9275C23.364 15.1633 23.4917 15.4613 23.5175 15.774L23.5205 15.963C22.8167 21.0586 18.8417 25.0742 13.7536 25.8294C8.6654 26.5847 3.67804 23.8996 1.49924 19.2319C0.871782 17.8761 0.521115 16.4096 0.467848 14.918C0.433601 14.4752 0.43515 14.0304 0.472474 13.588C0.830055 8.09747 4.98257 3.61684 10.4292 2.84451C11.0824 2.78669 11.6929 3.17927 11.9121 3.79807C11.9699 3.94187 12.0042 4.09396 12.0139 4.24854Z"
        fill="currentColor"
      />
      <path
        d="M26.3582 10.7864L26.3467 10.8273L26.3174 10.8859L26.3099 11.0518C26.2823 11.2703 26.185 11.4756 26.0305 11.6363C25.8693 11.8036 25.6574 11.9104 25.4297 11.9418L25.2915 11.9515L15.6526 11.9206C15.3312 11.9306 15.0203 11.8037 14.7974 11.5715C14.6115 11.3779 14.5012 11.1265 14.4828 10.8625L14.4887 1.05282C14.4797 1.01903 14.4821 0.983239 14.4955 0.95099C14.5222 0.682426 14.6554 0.436055 14.8654 0.266904C15.0752 0.0977456 15.3445 0.0199232 15.6127 0.0507992C21.3002 0.593026 25.8107 5.09942 26.3582 10.7864Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ImageThumbnailIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 32.75C26.4706 32.75 30.5 28.7206 30.5 23.75C30.5 18.7794 26.4706 14.75 21.5 14.75C16.5294 14.75 12.5 18.7794 12.5 23.75C12.5 28.7206 16.5294 32.75 21.5 32.75Z"
        fill="#ECECEC"
      />
      <path
        d="M55.1315 0.75H22.8685C8.8545 0.75 0.5 9.1045 0.5 23.1185V55.3815C0.5 59.578 1.2315 63.2355 2.656 66.3155C5.967 73.6305 13.051 77.75 22.8685 77.75H55.1315C69.1455 77.75 77.5 69.3955 77.5 55.3815V46.565V23.1185C77.5 9.1045 69.1455 0.75 55.1315 0.75ZM71.2245 41.175C68.2215 38.5955 63.3705 38.5955 60.3675 41.175L44.3515 54.9195C41.3485 57.499 36.4975 57.499 33.4945 54.9195L32.1855 53.8415C29.452 51.4545 25.1015 51.2235 22.0215 53.3025L7.6225 62.966C6.7755 60.81 6.275 58.3075 6.275 55.3815V23.1185C6.275 12.2615 12.0115 6.525 22.8685 6.525H55.1315C65.9885 6.525 71.725 12.2615 71.725 23.1185V41.5985L71.2245 41.175Z"
        fill="#ECECEC"
      />
    </svg>
  );
};

export const FadedBgCircleBottom = ({ className }: { className?: string }) => {
  return (
    <svg
      width="146"
      height="116"
      viewBox="0 0 146 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <ellipse
        cx="123.321"
        cy="121"
        rx="123.321"
        ry="121"
        transform="matrix(1 0 0 -1 -100.898 242)"
        fill="url(#paint0_linear_8308_699)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8308_699"
          x1="281.943"
          y1="273.654"
          x2="175.305"
          y2="142.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const FadedBgCircleTop = ({ className }: { className?: string }) => {
  return (
    <svg
      width="313"
      height="138"
      viewBox="0 0 313 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <ellipse
        cx="155.934"
        cy="151.5"
        rx="155.934"
        ry="151.5"
        transform="matrix(1 0 0 -1 0.988281 138)"
        fill="url(#paint0_linear_8308_700)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8308_700"
          x1="-49.4688"
          y1="-54.5922"
          x2="150.815"
          y2="124.571"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LocationIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
        stroke="#336DFF"
        strokeWidth="1.25"
      />
      <path
        d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
        stroke="#336DFF"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const MessageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.1667 17.5832H5.83341C3.33341 17.5832 1.66675 16.3332 1.66675 13.4165V7.58317C1.66675 4.6665 3.33341 3.4165 5.83341 3.4165H14.1667C16.6667 3.4165 18.3334 4.6665 18.3334 7.58317V13.4165C18.3334 16.3332 16.6667 17.5832 14.1667 17.5832Z"
        stroke="#336DFF"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 8L11.5582 10.0833C10.6999 10.7667 9.29158 10.7667 8.43325 10.0833L5.83325 8"
        stroke="#336DFF"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickBilling = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.60586 0H10.4059C14.4059 0 16.0059 1.6 16.0059 5.6V10.4C16.0059 14.4 14.4059 16 10.4059 16H5.60586C1.60586 16 0.00585938 14.4 0.00585938 10.4V5.6C0.00585938 1.6 1.60586 0 5.60586 0Z"
        fill="#336DFF"
      />
      <path
        d="M11.812 6.13951L7.14537 10.8062C7.08344 10.8683 7.00987 10.9175 6.92888 10.9511C6.84789 10.9847 6.76106 11.002 6.67337 11.002C6.58568 11.002 6.49885 10.9847 6.41786 10.9511C6.33686 10.9175 6.2633 10.8683 6.20137 10.8062L4.20137 8.80618C4.13938 8.74419 4.09022 8.67061 4.05667 8.58962C4.02312 8.50863 4.00586 8.42183 4.00586 8.33418C4.00586 8.24652 4.02312 8.15972 4.05667 8.07873C4.09022 7.99775 4.13938 7.92416 4.20137 7.86218C4.32655 7.73699 4.49633 7.66667 4.67337 7.66667C4.76103 7.66667 4.84783 7.68393 4.92881 7.71748C5.0098 7.75102 5.08338 7.80019 5.14537 7.86218L6.67337 9.39151L10.868 5.19551C10.9932 5.07033 11.163 5 11.34 5C11.5171 5 11.6869 5.07033 11.812 5.19551C11.9372 5.32069 12.0075 5.49047 12.0075 5.66751C12.0075 5.84454 11.9372 6.01433 11.812 6.13951Z"
        fill="white"
      />
    </svg>
  );
};

export const CTABackground = ({ className }: { className?: string }) => {
  return (
    <svg
      width="309"
      height="200"
      viewBox="0 0 309 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.07 627.266L78.9145 55.2385L38.3484 60.7662L66.7077 638.193L135.07 627.266Z"
        fill="#0E9AFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.76 65.1875L15.8848 272.347L-10.0272 272.188L-7.362 67.3971L18.76 65.1875Z"
        fill="#FF947A"
      />
      <path
        d="M-211.934 93.8537L266.587 -1.10449L264.463 -11.9085L-214.058 83.0497L-211.934 93.8537Z"
        fill="#FFF4DE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-76.496 41.7677L239.168 -14.5895L236.789 -52.6459L-82.1717 -1.88943L-76.496 41.7677Z"
        fill="#F3E8FF"
      />
      <path d="M89 55.5L157.914 601.72" stroke="#0E9AFF" strokeWidth="2" />
      <path
        d="M308.702 9.2449L187.182 29.5871"
        stroke="#0E9AFF"
        strokeWidth="1.3"
      />
    </svg>
  );
};

export const FloatingChatIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="37.5" cy="37.5" r="37" fill="#336DFF" stroke="#ECECEC" />
      <path
        d="M17.1797 42.3035C18.3818 46.7898 21.0384 50.5226 24.5165 53.106C29.206 56.6982 35.4984 58.1234 41.6803 56.467C41.6803 56.467 46 58 48.5 59C51 60 51.9265 58.7898 51.9936 57.0061L52.2309 49.4781C55.9982 44.7109 57.5138 38.2843 55.8167 31.9508C54.0388 25.3157 49.1714 20.3569 43.1841 18.2439C39.4721 16.8949 35.3804 16.6579 31.306 17.7496C20.6281 20.6108 14.3108 31.5969 17.1797 42.3035Z"
        fill="white"
      />
    </svg>
  );
};

export const HeroBackgroundImageLeft = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="434"
      height="608"
      viewBox="0 0 434 608"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_2398_2983"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="434"
        height="608"
      >
        <rect
          x="433.162"
          y="607.026"
          width="433.162"
          height="607.026"
          transform="rotate(180 433.162 607.026)"
          fill="#61A1FF"
        />
      </mask>
      <g mask="url(#mask0_2398_2983)">
        <path
          opacity="0.9"
          d="M165.783 111.772L165.852 283.112L139.286 283.856L139.217 112.515L165.783 111.772Z"
          fill="#F3E8FF"
        />
        <path
          d="M35.8113 281.782L38.473 682.609L-17.0938 682.631L-17.2549 282.038L35.8113 281.782Z"
          fill="#FFE2E5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.2769 386.008L57.5507 222.277L21.4962 219.63L21.5632 386.022L56.2769 386.008Z"
          fill="#FA5A7D"
        />
        <path
          d="M254.455 439.656L260.666 834.107L238.127 834.502L231.917 440.052L254.455 439.656Z"
          fill="#FFF4DE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M216.451 321.499L204.825 977.855L127.126 985.38L126.362 324.174L216.451 321.499Z"
          fill="#D0BCFD"
        />
        <path
          d="M183.1 282.394L182.408 58.9041"
          stroke="#F3E8FF"
          strokeWidth="1.49883"
        />
        <path
          d="M188.794 57.1491C188.856 60.356 186.313 62.9978 183.106 63.0595C179.899 63.1211 177.257 60.5791 177.196 57.3721C177.134 54.1652 179.676 51.5234 182.883 51.4617C186.089 51.3561 188.732 53.9421 188.794 57.1491Z"
          fill="#F3E8FF"
        />
        <path
          d="M82.874 217.634C82.9356 220.84 80.3935 223.482 77.1864 223.544C73.9792 223.606 71.3374 221.064 71.2757 217.857C71.214 214.65 73.7562 212.008 76.9633 211.946C80.1696 211.841 82.8123 214.427 82.874 217.634Z"
          fill="#FFE2E5"
        />
        <path
          d="M188.525 284.565C188.587 287.772 186.045 290.414 182.838 290.475C179.631 290.537 176.989 287.995 176.927 284.788C176.865 281.581 179.408 278.939 182.615 278.878C185.821 278.772 188.464 281.358 188.525 284.565Z"
          fill="#F3E8FF"
        />
        <path
          d="M77.4654 219.828L77.4653 612.521"
          stroke="#FFE2E5"
          strokeWidth="1.29899"
        />
        <path
          d="M106.311 307.124L106.311 373.165"
          stroke="#FFF4DE"
          strokeWidth="1.29899"
          strokeDasharray="5.2 5.2 5.2 5.2"
        />
        <path
          d="M106.137 299.016C103.253 299.016 100.891 296.654 100.891 293.77C100.891 290.832 103.248 288.524 106.137 288.524C109.02 288.524 111.383 290.887 111.383 293.77C111.383 296.654 109.02 299.016 106.137 299.016Z"
          stroke="#FFF4DE"
          strokeWidth="1.49883"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M211.813 615.788L213.053 513.598L190.426 512.599L190.419 615.807L211.813 615.788Z"
          fill="#BF83FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.2791 750.927L54.1514 434.766L95.1992 430.795L112.228 737.176L54.2791 750.927Z"
          fill="#FF947A"
        />
      </g>
    </svg>
  );
};

export const HeroBackgroundImageRight = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="434"
      height="608"
      viewBox="0 0 434 608"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_2398_3001"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="434"
        height="608"
      >
        <rect
          x="434"
          y="607.932"
          width="433.162"
          height="607.026"
          transform="rotate(180 434 607.932)"
          fill="#61A1FF"
        />
      </mask>
      <g mask="url(#mask0_2398_3001)">
        <path
          d="M233.315 869.875L247.591 249.884L291.266 248.204L299.06 872.134L233.315 869.875Z"
          fill="#DCFCE7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M483.866 155.36L400.316 1356.37L338.475 1355.35L327.867 172.164L483.866 155.36Z"
          fill="#0E9AFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M220.842 322.425L219.701 486.156L255.757 486.776L255.556 321.384L220.842 322.425Z"
          fill="#00E096"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M203.679 651.122L194.748 411.664L151.719 411.727L151.719 651.187L203.679 651.122Z"
          fill="#8FC4F9"
        />
        <path
          d="M220.012 514.434L224.134 792.405"
          stroke="#DCFCE7"
          strokeWidth="1.29899"
        />
        <path
          d="M225.532 511.376C225.514 514.583 222.907 517.161 219.7 517.143C216.492 517.125 213.914 514.519 213.932 511.311C213.95 508.104 216.557 505.526 219.764 505.544C222.972 505.517 225.55 508.168 225.532 511.376Z"
          fill="#DCFCE7"
        />
        <path
          d="M350.446 238.689L350.165 106.245"
          stroke="#DCFCE7"
          strokeWidth="1.29899"
          strokeDasharray="5.2 5.2 5.2 5.2"
        />
        <path
          d="M350.778 244.954C353.661 245.028 355.962 247.45 355.889 250.332C355.814 253.27 353.399 255.516 350.511 255.443C347.629 255.369 345.327 252.948 345.401 250.065C345.474 247.182 347.896 244.881 350.778 244.954Z"
          stroke="#DCFCE7"
          strokeWidth="1.49883"
        />
        <path
          d="M354.386 99.3516L346.672 89.1473"
          stroke="#DCFCE7"
          strokeWidth="1.49883"
        />
        <path
          d="M355.193 89.8758L345.859 98.6252"
          stroke="#DCFCE7"
          strokeWidth="1.49883"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M395.808 615.231L383.266 473.076L320.067 471.931L320.547 617.381L395.808 615.231Z"
          fill="#336DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M355.191 285.24L357.226 449.555L320.255 449.97L320.478 286.226L355.191 285.24Z"
          fill="#8FC4F9"
        />
      </g>
    </svg>
  );
};

export const ExpandSideNav = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.2822 14.9062V9.09375C21.2822 4.25 19.3447 2.3125 14.501 2.3125H8.68848C3.84473 2.3125 1.90723 4.25 1.90723 9.09375V14.9062C1.90723 19.75 3.84473 21.6875 8.68848 21.6875H14.501C19.3447 21.6875 21.2822 19.75 21.2822 14.9062Z"
        stroke="currentColor"
        strokeWidth="1.26562"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.71973 2.3125V21.6875"
        stroke="currentColor"
        strokeWidth="1.26562"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.021 14.48L14.501 12L12.021 9.51998"
        stroke="currentColor"
        strokeWidth="1.26562"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CollapseSideNav = ({ className }: { className?: string }) => {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.9306 13.2901C20.2601 12.9606 20.2601 12.4264 19.9306 12.0969C19.6011 11.7674 19.0669 11.7674 18.7374 12.0969L15.4307 15.4035C15.1012 15.733 15.1012 16.2673 15.4307 16.5968L18.7374 19.9034C19.0669 20.2329 19.6011 20.2329 19.9306 19.9034C20.2601 19.5739 20.2601 19.0397 19.9306 18.7102L17.2206 16.0001L19.9306 13.2901Z"
        fill={"currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.04531 4.58571C5.45158 3.17944 7.44683 2.4884 9.98765 2.29656C10.0823 2.25979 10.1853 2.23962 10.293 2.23962C10.3641 2.23962 10.4331 2.24842 10.4991 2.26498C10.8511 2.2479 11.213 2.23962 11.5846 2.23962H19.3346C22.647 2.23962 25.1852 2.89693 26.874 4.58571C28.5627 6.27449 29.2201 8.81266 29.2201 12.125V19.875C29.2201 23.1874 28.5627 25.7256 26.874 27.4144C25.1852 29.1031 22.647 29.7605 19.3346 29.7605H11.5846C11.213 29.7605 10.8511 29.7522 10.4991 29.7351C10.4331 29.7517 10.3641 29.7605 10.293 29.7605C10.1853 29.7605 10.0823 29.7403 9.98766 29.7035C7.44683 29.5117 5.45158 28.8206 4.04531 27.4144C2.35653 25.7256 1.69922 23.1874 1.69922 19.875V12.125C1.69922 8.81266 2.35653 6.27449 4.04531 4.58571ZM5.23855 5.77895C6.15356 4.86395 7.50078 4.27831 9.44922 4.0438V27.9563C7.50078 27.7218 6.15356 27.1361 5.23855 26.2211C4.02108 25.0037 3.38672 23.021 3.38672 19.875V12.125C3.38672 8.97909 4.02108 6.99643 5.23855 5.77895ZM11.5846 28.073C11.4326 28.073 11.2833 28.0715 11.1367 28.0685V3.93156C11.2833 3.92861 11.4326 3.92712 11.5846 3.92712H19.3346C22.4806 3.92712 24.4633 4.56148 25.6807 5.77895C26.8982 6.99643 27.5326 8.97909 27.5326 12.125V19.875C27.5326 23.021 26.8982 25.0037 25.6807 26.2211C24.4633 27.4386 22.4806 28.073 19.3346 28.073H11.5846Z"
        fill={"currentColor"}
      />
    </svg>
  );
};

export const CheckMarkIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.7 0.803299H9.3C12.3 0.803299 13.5 2.0033 13.5 5.0033V8.6033C13.5 11.6033 12.3 12.8033 9.3 12.8033H5.7C2.7 12.8033 1.5 11.6033 1.5 8.6033V5.0033C1.5 2.0033 2.7 0.803299 5.7 0.803299Z"
        stroke="currentColor"
        strokeWidth="1.05"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.355 5.408L6.855 8.908C6.808 8.9545 6.753 8.9915 6.692 9.0167C6.632 9.0419 6.56601 9.0549 6.50101 9.0549C6.43501 9.0549 6.37001 9.0419 6.30901 9.0167C6.24801 8.9915 6.193 8.9545 6.147 8.908L4.647 7.408C4.6 7.3615 4.56299 7.3063 4.53799 7.2456C4.51299 7.1848 4.5 7.1197 4.5 7.054C4.5 6.9882 4.51299 6.9231 4.53799 6.8624C4.56299 6.8017 4.6 6.7465 4.647 6.7C4.741 6.6061 4.86801 6.5533 5.00101 6.5533C5.06601 6.5533 5.131 6.5663 5.192 6.5915C5.253 6.6166 5.308 6.6535 5.355 6.7L6.50101 7.847L9.647 4.7C9.741 4.6061 9.86801 4.5533 10.001 4.5533C10.133 4.5533 10.261 4.6061 10.355 4.7C10.449 4.7939 10.501 4.9212 10.501 5.054C10.501 5.1868 10.449 5.3141 10.355 5.408Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SortUp = ({ className }: { className?: string }) => {
  return (
    <svg
      width="5"
      height="4"
      viewBox="0 0 5 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.50281 2.6549L3.6 1.75209L3.04875 1.19803C2.81531 0.96459 2.43562 0.96459 2.20218 1.19803L0.745309 2.6549C0.554059 2.84615 0.691871 3.1724 0.959059 3.1724H2.53687H4.28906C4.55906 3.1724 4.69406 2.84615 4.50281 2.6549Z"
        stroke="#96A5B8"
        strokeWidth="0.75"
      />
    </svg>
  );
};

export const SortDown = ({ className }: { className?: string }) => {
  return (
    <svg
      width="5"
      height="4"
      viewBox="0 0 5 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.28965 1.01025H2.53747H0.959655C0.689655 1.01025 0.554655 1.3365 0.745905 1.52775L2.20278 2.98463C2.43622 3.21807 2.8159 3.21807 3.04934 2.98463L3.6034 2.43057L4.50622 1.52775C4.69465 1.3365 4.55965 1.01025 4.28965 1.01025Z"
        stroke="#96A5B8"
        strokeWidth="0.75"
      />
    </svg>
  );
};

export const SortUpFilled = ({ className }: { className?: string }) => {
  return (
    <svg
      width="5"
      height="4"
      viewBox="0 0 5 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.29968 2.6549L3.39687 1.75209L2.84562 1.19803C2.61218 0.96459 2.2325 0.96459 1.99906 1.19803L0.542184 2.6549C0.350934 2.84615 0.488746 3.1724 0.755934 3.1724H2.33375H4.08593C4.35593 3.1724 4.49093 2.84615 4.29968 2.6549Z"
        fill="#96A5B8"
        stroke="#96A5B8"
        strokeWidth="0.75"
      />
    </svg>
  );
};

export const SortDownFilled = ({ className }: { className?: string }) => {
  return (
    <svg
      width="5"
      height="4"
      viewBox="0 0 5 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.28965 1.01025H2.53747H0.959655C0.689655 1.01025 0.554655 1.3365 0.745905 1.52775L2.20278 2.98463C2.43622 3.21807 2.8159 3.21807 3.04934 2.98463L3.6034 2.43057L4.50622 1.52775C4.69465 1.3365 4.55965 1.01025 4.28965 1.01025Z"
        fill="#96A5B8"
        stroke="#96A5B8"
        strokeWidth="0.75"
      />
    </svg>
  );
};

export const GridIcon = ({
  color,
  className,
}: {
  color: string;
  className?: string;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.75 17.5H12.25C16 17.5 17.5 16 17.5 12.25V7.75C17.5 4 16 2.5 12.25 2.5H7.75C4 2.5 2.5 4 2.5 7.75V12.25C2.5 16 4 17.5 7.75 17.5Z"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.52148 7.375H17.499"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.52148 12.625H17.499"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.38281 17.4925V2.50751"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6328 17.4925V2.50751"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ListIcon = ({
  color,
  className,
}: {
  color: string;
  className?: string;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.8">
        <path
          d="M18 13.7812C18 12.7457 17.1605 11.9062 16.125 11.9062H4.875C3.83947 11.9062 3 12.7457 3 13.7813V15.6563C3 16.6918 3.83947 17.5312 4.875 17.5312H16.125C17.1605 17.5312 18 16.6918 18 15.6562V13.7812Z"
          stroke={color}
          strokeWidth="1.21875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 5.34375C18 4.30822 17.1659 3.46875 16.1304 3.46875C13.265 3.46875 7.81143 3.46875 4.87328 3.46875C3.83775 3.46875 3 4.30822 3 5.34375V7.21875C3 8.25428 3.83665 9.09375 4.87218 9.09375C7.79806 9.09375 13.2019 9.09375 16.1278 9.09375C17.1634 9.09375 18 8.25428 18 7.21875V5.34375Z"
          stroke={color}
          strokeWidth="1.21875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const BlogSearchIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M24.3146 20.9862L19.2376 15.9092C20.2866 14.3282 20.9006 12.4351 20.9006 10.4001C20.9006 4.88607 16.4146 0.400024 10.9005 0.400024C5.38644 0.400024 0.900391 4.88607 0.900391 10.4001C0.900391 15.9142 5.38644 20.4002 10.9005 20.4002C12.9355 20.4002 14.8285 19.7862 16.4096 18.7372L21.4866 23.8143C22.2666 24.5953 23.5346 24.5953 24.3146 23.8143C25.0956 23.0333 25.0956 21.7672 24.3146 20.9862ZM3.90042 10.4001C3.90042 6.54009 7.04045 3.40006 10.9005 3.40006C14.7605 3.40006 17.9006 6.54009 17.9006 10.4001C17.9006 14.2602 14.7605 17.4002 10.9005 17.4002C7.04045 17.4002 3.90042 14.2602 3.90042 10.4001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AutomatedEmailIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V11.5"
        stroke="#336DFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
        stroke="#336DFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2091 14.7698L15.6691 18.3098C15.5291 18.4498 15.3991 18.7098 15.3691 18.8998L15.1791 20.2498C15.1091 20.7398 15.4491 21.0798 15.9391 21.0098L17.2891 20.8198C17.4791 20.7898 17.7491 20.6598 17.8791 20.5198L21.4191 16.9798C22.0291 16.3698 22.3191 15.6598 21.4191 14.7598C20.5291 13.8698 19.8191 14.1598 19.2091 14.7698Z"
        stroke="#336DFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6992 15.2798C18.9992 16.3598 19.8392 17.1998 20.9192 17.4998"
        stroke="#336DFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReportIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3871 1.35486C5.39872 1.35486 1.35484 5.39874 1.35484 10.3871V17.6129C1.35484 22.6013 5.39872 26.6452 10.3871 26.6452H17.6129C22.6013 26.6452 26.6452 22.6013 26.6452 17.6129V10.3871C26.6452 5.39874 22.6013 1.35486 17.6129 1.35486H10.3871ZM17.6129 7.22583C17.6129 6.47757 18.2195 5.87099 18.9677 5.87099C19.716 5.87099 20.3226 6.47757 20.3226 7.22583V19.871C20.3226 20.6192 19.716 21.2258 18.9677 21.2258C18.2195 21.2258 17.6129 20.6192 17.6129 19.871V7.22583ZM13.5484 8.58066C12.8001 8.58066 12.1935 9.18725 12.1935 9.9355V19.871C12.1935 20.6192 12.8001 21.2258 13.5484 21.2258C14.2966 21.2258 14.9032 20.6192 14.9032 19.871V9.9355C14.9032 9.18725 14.2966 8.58066 13.5484 8.58066ZM6.77419 12.6452C6.77419 11.8969 7.38078 11.2903 8.12903 11.2903C8.87729 11.2903 9.48387 11.8969 9.48387 12.6452V19.871C9.48387 20.6192 8.87729 21.2258 8.12903 21.2258C7.38078 21.2258 6.77419 20.6192 6.77419 19.871V12.6452Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ExportReportIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M24.4766 11.8883H21.1049C18.3399 11.8883 16.0882 9.63665 16.0882 6.87165V3.49998C16.0882 2.85831 15.5632 2.33331 14.9216 2.33331H9.9749C6.38156 2.33331 3.47656 4.66665 3.47656 8.83165V19.1683C3.47656 23.3333 6.38156 25.6666 9.9749 25.6666H19.1449C22.7382 25.6666 25.6432 23.3333 25.6432 19.1683V13.055C25.6432 12.4133 25.1182 11.8883 24.4766 11.8883Z"
        fill="currentColor"
      />
      <path
        d="M19.0137 2.56065C18.5354 2.08231 17.707 2.40898 17.707 3.07398V7.14564C17.707 8.84898 19.1537 10.2606 20.9154 10.2606C22.0237 10.2723 23.5637 10.2723 24.882 10.2723C25.547 10.2723 25.897 9.49064 25.4304 9.02398C23.7504 7.33231 20.7404 4.28731 19.0137 2.56065Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LeadEngineIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.4557 28.6565C22.5894 28.6565 28.3724 22.8735 28.3724 15.7399C28.3724 8.60619 22.5894 2.8232 15.4557 2.8232C8.32205 2.8232 2.53906 8.60619 2.53906 15.7399C2.53906 22.8735 8.32205 28.6565 15.4557 28.6565Z"
        stroke="currentColor"
        strokeWidth="1.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4941 21.5524C18.7043 21.5524 21.3066 18.95 21.3066 15.7399C21.3066 12.5297 18.7043 9.92737 15.4941 9.92737C12.284 9.92737 9.68164 12.5297 9.68164 15.7399C9.68164 18.95 12.284 21.5524 15.4941 21.5524Z"
        stroke="currentColor"
        strokeWidth="1.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.32324 6.6077L10.8957 11.1673"
        stroke="currentColor"
        strokeWidth="1.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.32324 24.872L10.8957 20.3124"
        stroke="currentColor"
        strokeWidth="1.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6008 24.872L20.0283 20.3124"
        stroke="currentColor"
        strokeWidth="1.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6008 6.6077L20.0283 11.1673"
        stroke="currentColor"
        strokeWidth="1.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeadEngineIconFilled = ({ className }: { className?: string }) => {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.26539 11.625C7.26539 10.9826 7.40868 10.3726 7.66333 9.82045C7.86048 9.39298 7.82655 8.87306 7.49368 8.5402L4.99715 6.04366C4.5999 5.64642 3.94491 5.66727 3.62427 6.12857C2.53884 7.69015 1.9082 9.58482 1.9082 11.625C1.9082 13.6636 2.53786 15.557 3.61589 17.1178C3.93558 17.5807 4.59158 17.6031 4.98987 17.2059L7.49221 14.7099C7.82583 14.3771 7.86013 13.8566 7.66289 13.4287C7.40851 12.8768 7.26539 12.2671 7.26539 11.625Z" fill="#05004E" />
      <path d="M11.6247 7.26566C12.2671 7.26566 12.8771 7.40894 13.4293 7.66359C13.8567 7.86074 14.3767 7.82681 14.7095 7.49395L17.1791 5.02439C17.5756 4.62791 17.5557 3.97438 17.0959 3.65358C15.5399 2.56816 13.644 1.93753 11.5956 1.93753C9.55719 1.93753 7.67095 2.56707 6.11229 3.64493C5.64959 3.9649 5.6272 4.6209 6.02448 5.0192L8.50551 7.50656C8.8406 7.84251 9.36563 7.87474 9.79536 7.67355C10.3512 7.41329 10.9695 7.26566 11.6247 7.26566Z" fill="#05004E" />
      <path d="M19.2697 5.72157C19.0976 5.49912 18.7707 5.48754 18.5716 5.68618L15.4534 8.79639C15.2854 8.96394 15.2661 9.22714 15.3862 9.43178C15.7643 10.0764 15.9855 10.8231 15.9855 11.625C15.9855 12.4272 15.7642 13.174 15.3859 13.8188C15.2659 14.0232 15.285 14.2861 15.4526 14.4537L18.5716 17.5726C18.7707 17.7717 19.0979 17.7603 19.27 17.5376C20.5345 15.9021 21.2846 13.8501 21.2846 11.625C21.2846 9.3998 20.5344 7.35592 19.2697 5.72157Z" fill="#05004E" />
      <path d="M11.6246 15.9844C10.8225 15.9844 10.0756 15.7631 9.43088 15.3847C9.22646 15.2648 8.96356 15.2839 8.79596 15.4515L5.64794 18.5995C5.44888 18.7986 5.46026 19.1258 5.68298 19.2979C7.31853 20.5624 9.37049 21.3125 11.5955 21.3125C13.8306 21.3125 15.8841 20.5617 17.5125 19.2886C17.7333 19.1159 17.7436 18.7903 17.5454 18.5921L14.4216 15.4682C14.2551 15.3018 13.9945 15.2817 13.7906 15.3993C13.1482 15.7699 12.4106 15.9844 11.6246 15.9844Z" fill="#05004E" />
    </svg>

  );
};

export const CopyIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.9652 12.3101V16.0901C14.9652 19.2401 13.7052 20.5001 10.5552 20.5001H6.77523C3.62523 20.5001 2.36523 19.2401 2.36523 16.0901V12.3101C2.36523 9.16005 3.62523 7.90005 6.77523 7.90005H10.5552C13.7052 7.90005 14.9652 9.16005 14.9652 12.3101Z"
        stroke="#444A6D"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3637 6.91006V10.6901C20.3637 13.8401 19.1037 15.1001 15.9537 15.1001H14.9637V12.3101C14.9637 9.16006 13.7037 7.90006 10.5537 7.90006H7.76367V6.91006C7.76367 3.76006 9.02367 2.50006 12.1737 2.50006H15.9537C19.1037 2.50006 20.3637 3.76006 20.3637 6.91006Z"
        stroke="#444A6D"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserProfileIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.8875 8.52499C13.5364 8.52499 11.625 10.3514 11.625 12.598C11.625 14.8018 13.4287 16.5853 15.7798 16.6625C15.8516 16.6539 15.9234 16.6539 15.9772 16.6625C15.9952 16.6625 16.0042 16.6625 16.0221 16.6625C16.0311 16.6625 16.0311 16.6625 16.0401 16.6625C18.3373 16.5853 20.141 14.8018 20.15 12.598C20.15 10.3514 18.2386 8.52499 15.8875 8.52499Z"
        fill="currentColor"
      />
      <path
        d="M20.867 19.6158C18.026 17.7447 13.3928 17.7447 10.5314 19.6158C9.23819 20.4708 8.52539 21.6277 8.52539 22.865C8.52539 24.1023 9.23819 25.2491 10.5212 26.0941C11.9468 27.0397 13.8205 27.5125 15.6941 27.5125C17.5678 27.5125 19.4414 27.0397 20.867 26.0941C22.1501 25.239 22.8629 24.0923 22.8629 22.8449C22.8527 21.6076 22.1501 20.4608 20.867 19.6158Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PremiumUpgradeButtonIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 6.12521V1.50637C1 0.865128 1.35932 0.710846 1.79798 1.16405L3.00662 2.41278C3.18861 2.60081 3.48727 2.60081 3.6646 2.41278L5.33523 0.681918C5.51722 0.493886 5.81588 0.493886 5.99321 0.681918L7.6685 2.41278C7.8505 2.60081 8.14916 2.60081 8.32648 2.41278L9.53512 1.16405C9.97378 0.710846 10.3331 0.865128 10.3331 1.50637V6.13003C10.3331 7.57643 9.39979 8.54069 7.99983 8.54069H3.33328C2.04531 8.53587 1 7.45589 1 6.12521Z"
        stroke="currentColor"
        strokeWidth="1.06664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadLeadsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.47982 19.0834H13.4798C17.6465 19.0834 19.3132 17.4167 19.3132 13.2501V8.25008C19.3132 4.08341 17.6465 2.41675 13.4798 2.41675H8.47982C4.31315 2.41675 2.64648 4.08341 2.64648 8.25008V13.2501C2.64648 17.4167 4.31315 19.0834 8.47982 19.0834Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.48047 10.3418L10.9805 12.8418L13.4805 10.3418"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9805 12.8417V6.17505"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.98047 14.5083C9.22214 15.5916 12.7388 15.5916 15.9805 14.5083"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadReportIconSVG = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.0863 0.333313H7.30958C3.06292 0.333313 0.53125 2.86498 0.53125 7.11165V16.8766C0.53125 21.135 3.06292 23.6666 7.30958 23.6666H17.0746C21.3212 23.6666 23.8529 21.135 23.8529 16.8883V7.11165C23.8646 2.86498 21.3329 0.333313 17.0863 0.333313ZM8.07958 10.81C8.41792 10.4716 8.97792 10.4716 9.31625 10.81L11.3229 12.8166V5.59498C11.3229 5.11665 11.7196 4.71998 12.1979 4.71998C12.6762 4.71998 13.0729 5.11665 13.0729 5.59498V12.8166L15.0796 10.81C15.4179 10.4716 15.9779 10.4716 16.3162 10.81C16.6546 11.1483 16.6546 11.7083 16.3162 12.0466L12.8162 15.5466C12.7346 15.6283 12.6412 15.6866 12.5362 15.7333C12.4312 15.78 12.3146 15.8033 12.1979 15.8033C12.0812 15.8033 11.9762 15.78 11.8596 15.7333C11.7546 15.6866 11.6613 15.6283 11.5796 15.5466L8.07958 12.0466C7.74125 11.7083 7.74125 11.16 8.07958 10.81ZM19.4779 18.09C17.1329 18.8716 14.6712 19.2683 12.1979 19.2683C9.72458 19.2683 7.26292 18.8716 4.91792 18.09C4.46292 17.9383 4.21792 17.4366 4.36958 16.9816C4.52125 16.5266 5.01125 16.27 5.47792 16.4333C9.81792 17.88 14.5896 17.88 18.9296 16.4333C19.3846 16.2816 19.8862 16.5266 20.0379 16.9816C20.1779 17.4483 19.9329 17.9383 19.4779 18.09Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SecondaryColorPickerIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="13.9803" cy="13.3313" r="12.9686" fill="white" />
      <path
        d="M2.63757 19.9742C3.1989 20.9428 3.88964 21.8446 4.70226 22.6574C7.15159 25.1066 10.4078 26.4554 13.8714 26.4554C17.3351 26.4554 20.5914 25.1066 23.0405 22.6574C23.8533 21.8446 24.5438 20.9428 25.1052 19.9742C26.2356 18.0239 26.8384 15.8027 26.8384 13.4883C26.8384 11.1739 26.2356 8.95273 25.1052 7.0024C24.5438 6.03387 23.8531 5.13182 23.0405 4.3192C20.5914 1.87006 17.3351 0.52124 13.8714 0.52124C10.4078 0.52124 7.15139 1.87006 4.70226 4.3192C3.88944 5.13182 3.1987 6.03387 2.63757 7.0024C1.50718 8.95273 0.904297 11.1741 0.904297 13.4883C0.904297 15.8025 1.50718 18.0239 2.63757 19.9742ZM10.5621 13.4883C10.5621 12.886 10.7246 12.3215 11.0069 11.8344C11.5799 10.8459 12.6488 10.1789 13.8714 10.1789C15.094 10.1789 16.1628 10.8459 16.736 11.8344C17.0182 12.3213 17.1808 12.886 17.1808 13.4883C17.1808 14.0906 17.0182 14.6551 16.736 15.142C16.163 16.1308 15.094 16.7976 13.8714 16.7976C12.6488 16.7976 11.5799 16.1308 11.0067 15.142C10.7246 14.6551 10.5621 14.0906 10.5621 13.4883Z"
        fill="#FF8398"
      />
      <path
        d="M13.8711 21.6265V26.4556C17.3349 26.4556 20.5911 25.1067 23.0402 22.6576C23.853 21.8448 24.5436 20.9429 25.1049 19.9744L20.9199 17.5581C19.5127 19.9902 16.8831 21.6265 13.8711 21.6265Z"
        fill="#54E360"
      />
      <path
        d="M22.0093 13.4884C22.0093 14.9709 21.6126 16.3609 20.9199 17.558L25.1049 19.9743C26.2353 18.0239 26.8382 15.8027 26.8382 13.4884C26.8382 11.174 26.2353 8.95277 25.1049 7.00244L20.9199 9.41853C21.6126 10.6158 22.0093 12.0058 22.0093 13.4884Z"
        fill="#008ADF"
      />
      <path
        d="M6.82169 17.5581L2.63672 19.9744C3.19805 20.9429 3.88879 21.8448 4.70141 22.6576C7.15074 25.1067 10.407 26.4556 13.8705 26.4556V21.6265C10.8585 21.6265 8.22889 19.9902 6.82169 17.5581Z"
        fill="#FFD400"
      />
      <path
        d="M20.9199 9.41849L25.1049 7.0024C24.5436 6.03387 23.8528 5.13182 23.0402 4.3192C20.5911 1.87006 17.3349 0.52124 13.8711 0.52124V5.35006C16.8831 5.35006 19.5127 6.98657 20.9199 9.41849Z"
        fill="#0065A3"
      />
      <path
        d="M2.63757 19.9743L6.82254 17.558C6.12983 16.3609 5.73331 14.9709 5.73331 13.4884C5.73331 12.0058 6.12983 10.6158 6.82254 9.41873L2.63757 7.00244C1.50718 8.95277 0.904297 11.1742 0.904297 13.4884C0.904297 15.8025 1.50718 18.0239 2.63757 19.9743Z"
        fill="#FF9100"
      />
      <path
        d="M13.8705 5.35006V0.52124C10.407 0.52124 7.15054 1.87006 4.70141 4.3192C3.88859 5.13182 3.19785 6.03387 2.63672 7.0024L6.82169 9.41869C8.22889 6.98657 10.8585 5.35006 13.8705 5.35006Z"
        fill="#FF4949"
      />
      <path
        d="M17.1811 13.4884C17.1811 14.0907 17.0185 14.6552 16.7363 15.1421L20.9205 17.558C21.6132 16.361 22.0099 14.971 22.0099 13.4884C22.0099 12.0056 21.6132 10.6158 20.9205 9.41858L16.7363 11.8345C17.0185 12.3214 17.1811 12.8861 17.1811 13.4884Z"
        fill="#008ADF"
      />
      <path
        d="M16.7357 11.8344L20.9199 9.41873C19.5127 6.98661 16.8831 5.3501 13.8711 5.3501V10.1789C15.0937 10.1789 16.1625 10.8459 16.7357 11.8344Z"
        fill="#0065A3"
      />
      <path
        d="M13.8711 16.7976V21.6265C16.8831 21.6265 19.5127 19.9901 20.9199 17.558L16.7357 15.1423C16.1627 16.1309 15.0937 16.7976 13.8711 16.7976Z"
        fill="#54E360"
      />
      <path
        d="M13.8711 21.6263V16.7975C12.6485 16.7975 11.5797 16.1307 11.0064 15.142L6.82227 17.5579C8.22946 19.99 10.859 21.6263 13.8711 21.6263Z"
        fill="#FFD400"
      />
      <path
        d="M10.5612 13.4884C10.5612 12.8862 10.7237 12.3217 11.006 11.8345L6.82165 9.41882C6.12894 10.6159 5.73242 12.0059 5.73242 13.4884C5.73242 14.971 6.12894 16.361 6.82165 17.5581L11.0058 15.1422C10.7237 14.6552 10.5612 14.0907 10.5612 13.4884Z"
        fill="#FF9100"
      />
      <path
        d="M13.8711 10.1789V5.3501C10.859 5.3501 8.22946 6.98661 6.82227 9.41873L11.0066 11.8344C11.5797 10.8459 12.6485 10.1789 13.8711 10.1789Z"
        fill="#FF4949"
      />
    </svg>
  );
};

export const ArrowRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.862183 11.7958C0.491251 11.4248 0.491251 10.8172 0.862183 10.4463L5.01127 6.29717C5.13034 6.17811 5.13034 5.98393 5.01127 5.86487L0.862183 1.71578C0.491251 1.34484 0.491251 0.737196 0.862183 0.366264C1.23311 -0.00466731 1.84076 -0.00466734 2.21169 0.366264L6.36079 4.51535C6.79061 4.94518 7.00967 5.51336 7.00967 6.08102C7.00967 6.64868 6.79061 7.21686 6.36079 7.64668L2.21169 11.7958C1.84076 12.1667 1.23312 12.1667 0.862183 11.7958Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowLeftIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73352 0.616578C7.10445 0.98751 7.10445 1.59516 6.73352 1.96609L2.58443 6.11518C2.46536 6.23425 2.46536 6.42842 2.58443 6.54749L6.73352 10.6966C7.10445 11.0675 7.10445 11.6752 6.73352 12.0461C6.36259 12.417 5.75494 12.417 5.38401 12.0461L1.23492 7.897C0.80509 7.46717 0.586038 6.89899 0.586038 6.33133C0.586038 5.76368 0.80509 5.1955 1.23492 4.76567L5.38401 0.616578C5.75494 0.245646 6.36259 0.245646 6.73352 0.616578Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CardTooltipIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10ZM3 3.79114C3 2.81769 3.89129 2.125 4.875 2.125C5.85871 2.125 6.75 2.81769 6.75 3.79114C6.75 4.52793 6.1999 4.90455 5.82492 5.12505C5.44629 5.35016 5.25 5.53316 5.25 5.8367V6C5.25 6.20711 5.08211 6.375 4.875 6.375C4.66789 6.375 4.5 6.20711 4.5 6V5.8367C4.5 5.08265 5.06255 4.70567 5.44249 4.47987L5.44404 4.47895L5.44404 4.47895C5.81002 4.26383 6 4.08048 6 3.79114C6 3.33348 5.55396 2.875 4.875 2.875C4.19604 2.875 3.75 3.33348 3.75 3.79114C3.75 3.99824 3.58211 4.16614 3.375 4.16614C3.16789 4.16614 3 3.99824 3 3.79114ZM4.37225 7.5C4.37225 7.22386 4.59611 7 4.87225 7H4.87674C5.15289 7 5.37674 7.22386 5.37674 7.5C5.37674 7.77614 5.15289 8 4.87674 8H4.87225C4.59611 8 4.37225 7.77614 4.37225 7.5Z"
        fill="#D8D8D8"
      />
    </svg>
  );
};

export const ButtonAlignLeftIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.82422 14.4375H12.6742C13.7992 14.4375 14.2492 13.9575 14.2492 12.765V11.985C14.2492 10.7925 13.7992 10.3125 12.6742 10.3125H3.82422"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.82422 3.9375H8.92422C10.0492 3.9375 10.4992 4.4175 10.4992 5.61V6.39C10.4992 7.5825 10.0492 8.0625 8.92422 8.0625H3.82422"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 1.49251V16.4925"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ButtonAlignCenterIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.05 14.4375H4.95C3.825 14.4375 3.375 13.9575 3.375 12.765V11.985C3.375 10.7925 3.825 10.3125 4.95 10.3125H13.05C14.175 10.3125 14.625 10.7925 14.625 11.985V12.765C14.625 13.9575 14.175 14.4375 13.05 14.4375Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.55 8.0625H6.45C5.325 8.0625 4.875 7.5825 4.875 6.39V5.61C4.875 4.4175 5.325 3.9375 6.45 3.9375H11.55C12.675 3.9375 13.125 4.4175 13.125 5.61V6.39C13.125 7.5825 12.675 8.0625 11.55 8.0625Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.5V14.7"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9.75V8.25"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 1.5V3.5175"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ButtonAlignRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.175 14.4375H5.325C4.2 14.4375 3.75 13.9575 3.75 12.765V11.985C3.75 10.7925 4.2 10.3125 5.325 10.3125H14.175"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.175 3.9375H9.075C7.95 3.9375 7.5 4.4175 7.5 5.61V6.39C7.5 7.5825 7.95 8.0625 9.075 8.0625H14.175"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 1.49251V16.4925"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextAlignLeftIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25 3.375H15.75"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 7.125H9.3525"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 10.875H15.75"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 14.625H9.3525"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextAlignCenterIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25 3.375H15.75"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44531 7.125H12.5553"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 10.875H15.75"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44531 14.625H12.5553"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextAlignRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25 3.375H15.75"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.64648 7.125H15.749"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 10.875H15.75"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.64648 14.625H15.749"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextBoldIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.87506 3.57552C5.5119 3.57552 8.99711 3.57552 8.99711 3.57552C10.5139 3.57552 11.7471 4.7748 11.7471 6.24998C11.7471 7.72516 10.5139 8.92444 8.99711 8.92444H4.875C4.875 7.14147 4.87484 5.35849 4.87506 3.57552Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.87524 8.92447H10.3752C11.8921 8.92447 13.1252 10.1576 13.1252 11.6745C13.1252 13.1913 11.8921 14.4245 10.3752 14.4245H4.875C4.87586 12.5911 4.87524 10.7578 4.87524 8.92447Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextItalicIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.79492 3.57535H12.9149"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.08398 14.4243L10.204 14.4243"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3569 3.57535L7.64453 14.4247"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextUnderlineIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.78125 14.4479H13.2193"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.78125 3.57552V7.55435C4.78125 9.75407 6.66776 11.5332 9.00029 11.5332C11.3328 11.5332 13.2193 9.75407 13.2193 7.55435V3.57552"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TextLinkIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.54375 9C3.05 8.40625 2.75 7.64375 2.75 6.8125C2.75 4.925 4.29375 3.375 6.1875 3.375H9.3125C11.2 3.375 12.75 4.925 12.75 6.8125C12.75 8.7 11.2062 10.25 9.3125 10.25H7.75"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4563 9C14.95 9.59375 15.25 10.3562 15.25 11.1875C15.25 13.075 13.7062 14.625 11.8125 14.625H8.6875C6.8 14.625 5.25 13.075 5.25 11.1875C5.25 9.3 6.79375 7.75 8.6875 7.75H10.25"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Cross = ({ className }: { className?: string }) => {
  // Wrapper centers the icon within its cell exactly like <Tick/> (which the
  // matched checkmarks use), so the X lines up with the ✓ column. The className
  // still sizes the inner <svg> — the squircle's viewBox scales with it — so
  // callers passing `size-*` (e.g. the billing feature list) resize the icon,
  // not just the wrapper. (The old nested box left the X's box unscaled, so it
  // rendered invisible; a bare <svg> rendered but sat off-centre.)
  return (
    <div className="flex items-center justify-center">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={cn("size-3 text-kd-secondary-3 xl:size-4", className)}
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Squircle background — theme-aware via currentColor (kd-secondary-3). */}
        <path
          d="M5.60586 0H10.4059C14.4059 0 16.0059 1.6 16.0059 5.6V10.4C16.0059 14.4 14.4059 16 10.4059 16H5.60586C1.60586 16 0.00585938 14.4 0.00585938 10.4V5.6C0.00585938 1.6 1.60586 0 5.60586 0Z"
          fill="currentColor"
        />
        {/* The X. */}
        <path
          d="M5.5 5.5L10.5 10.5"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M5.5 10.5L10.5 5.5"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export const LearnMoreIcon = ({ className = "" }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.99999 7.23503C4.51999 7.23503 4.07499 7.08003 3.70499 6.82003L1.73999 8.78503C2.61499 9.54503 3.75499 10 4.99999 10C6.24499 10 7.38499 9.54503 8.25999 8.79003L6.29499 6.82003C5.92499 7.08003 5.47999 7.23503 4.99999 7.23503Z"
        fill="#00E096"
      />
      <path
        d="M2.75 4.98503C2.75 4.50503 2.905 4.06003 3.165 3.69003L1.215 1.74003C0.455 2.61003 2.40195e-07 3.75003 2.94834e-07 5.00003C3.49255e-07 6.24503 0.455001 7.38003 1.21 8.25503L3.175 6.29503C2.91 5.92503 2.75 5.47503 2.75 4.98503Z"
        fill="#336DFF"
      />
      <path
        d="M1.74487 1.21006L3.68987 3.16006C4.05987 2.89506 4.50987 2.73506 4.99987 2.73506C5.48987 2.73506 5.93988 2.89506 6.30987 3.16006L8.25988 1.21006C7.38488 0.455063 6.24487 6.31829e-05 4.99987 6.32373e-05C3.75487 6.32918e-05 2.61987 0.455064 1.74487 1.21006Z"
        fill="#FA5A7D"
      />
      <path
        d="M7.24995 4.98504C7.24995 5.47504 7.08995 5.92504 6.82495 6.29504L8.78995 8.26004C9.54495 7.38504 9.99995 6.24504 9.99995 5.00004C9.99995 3.75004 9.54495 2.61004 8.78495 1.74004L6.83495 3.69004C7.09495 4.06004 7.24995 4.50504 7.24995 4.98504Z"
        fill="#FFD500"
      />
    </svg>
  );
};

export const DeliveryCardIcon = ({ className = "", color = "#00E096" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill={color} />
      <path
        d="M8.40845 13.4947C6.75245 13.4947 5.40845 14.8443 5.40845 16.5206C5.40845 18.1969 6.75245 19.5465 8.40845 19.5465C10.0644 19.5465 11.4084 18.1909 11.4084 16.5206C11.4084 14.8503 10.0704 13.4947 8.40845 13.4947ZM7.18445 15.286H8.40845C8.63645 15.286 8.81645 15.4736 8.81645 15.6976C8.81645 15.9215 8.63645 16.1091 8.40845 16.1091H7.18445C6.95645 16.1091 6.77645 15.9215 6.77645 15.6976C6.77645 15.4736 6.95645 15.286 7.18445 15.286ZM9.63245 17.7551H7.18445C6.95645 17.7551 6.77645 17.5675 6.77645 17.3436C6.77645 17.1197 6.96245 16.9321 7.18445 16.9321H9.63845C9.86645 16.9321 10.0464 17.1197 10.0464 17.3436C10.0464 17.5675 9.86045 17.7551 9.63245 17.7551Z"
        fill="white"
      />
      <path
        d="M15.0085 7.44302H9.00854C7.20854 7.44302 6.00854 8.35078 6.00854 10.4689V12.3691C6.00854 12.8109 6.45854 13.0893 6.86054 12.9138C7.52055 12.6233 8.27055 12.5144 9.05655 12.6415C10.6285 12.9017 11.9125 14.1544 12.2305 15.7278C12.3205 16.1878 12.3325 16.6356 12.2725 17.0653C12.2245 17.4223 12.5125 17.737 12.8665 17.737H15.0085C16.8085 17.737 18.0085 16.8292 18.0085 14.7111V10.4689C18.0085 8.35078 16.8085 7.44302 15.0085 7.44302ZM15.2905 10.8259L13.4125 12.3389C13.0165 12.6596 12.5125 12.817 12.0085 12.817C11.5045 12.817 10.9945 12.6596 10.6045 12.3389L8.72655 10.8259C8.53455 10.6686 8.50454 10.3781 8.65454 10.1845C8.81054 9.9908 9.09255 9.95449 9.28455 10.1118L11.1625 11.6248C11.6185 11.9939 12.3925 11.9939 12.8485 11.6248L14.7265 10.1118C14.9185 9.95449 15.2065 9.98475 15.3565 10.1845C15.5125 10.3781 15.4825 10.6686 15.2905 10.8259Z"
        fill="white"
      />
    </svg>
  );
};

export const ClickCardIcon = ({ className = "", color = "#0095FF" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill={color} />
      <path
        d="M8.3999 13.6959C10.0617 13.6959 11.3997 15.0512 11.3999 16.7213C11.3999 18.3915 10.0559 19.7476 8.3999 19.7476C6.7439 19.7476 5.3999 18.3976 5.3999 16.7213C5.40015 15.0451 6.74406 13.6959 8.3999 13.6959ZM9.64795 16.2535C9.86078 15.6045 9.51181 15.2502 8.86865 15.4664L7.43408 15.9468C6.46984 16.2722 6.46984 16.8028 7.43408 17.1265L7.85986 17.2691L8.00146 17.6988C8.32235 18.6717 8.84952 18.6717 9.17041 17.6988L9.64795 16.2535Z"
        fill="white"
      />
      <path
        d="M14.9999 7.64413H8.99988C7.19988 7.64413 5.99988 8.55189 5.99988 10.67V12.5702C5.99988 13.012 6.44988 13.2904 6.85188 13.1149C7.51188 12.8244 8.26188 12.7155 9.04788 12.8426C10.6199 13.1028 11.9039 14.3555 12.2219 15.9289C12.3119 16.3889 12.3239 16.8367 12.2639 17.2664C12.2159 17.6234 12.5039 17.9381 12.8579 17.9381H14.9999C16.7999 17.9381 17.9999 17.0304 17.9999 14.9123V10.67C17.9999 8.55189 16.7999 7.64413 14.9999 7.64413ZM15.2819 11.027L13.4039 12.54C13.0079 12.8607 12.5039 13.0181 11.9999 13.0181C11.4959 13.0181 10.9859 12.8607 10.5959 12.54L8.71788 11.027C8.52588 10.8697 8.49588 10.5792 8.64588 10.3856C8.80188 10.1919 9.08388 10.1556 9.27588 10.3129L11.1539 11.8259C11.6099 12.195 12.3839 12.195 12.8399 11.8259L14.7179 10.3129C14.9099 10.1556 15.1979 10.1859 15.3479 10.3856C15.5039 10.5792 15.4739 10.8697 15.2819 11.027Z"
        fill="white"
      />
    </svg>
  );
};

export const OpenCardIcon = ({
  className,
  color = "#BF83FF",
}: {
  className?: string;
  color?: string;
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill={color} />
      <path
        d="M8.3999 13.8423C10.0617 13.8423 11.3997 15.1976 11.3999 16.8676C11.3999 18.5379 10.0559 19.894 8.3999 19.894C6.7439 19.894 5.3999 18.544 5.3999 16.8676C5.40015 15.1915 6.74406 13.8423 8.3999 13.8423ZM8.3999 15.6577C7.7375 15.6577 7.19971 16.1981 7.19971 16.8686C7.19994 17.539 7.73764 18.0786 8.3999 18.0786C9.06216 18.0786 9.59987 17.5365 9.6001 16.8686C9.6001 16.2005 9.0647 15.6577 8.3999 15.6577Z"
        fill="white"
      />
      <path
        d="M12 5.10425C13.1945 5.10466 15.93 7.33069 16.9424 8.31909C17.6103 8.79604 17.9999 9.60965 18 10.8162V15.0583C18 17.1764 16.7999 18.0847 15 18.0847H12.8574C12.5037 18.0844 12.2157 17.7697 12.2637 17.4128C12.3237 16.9832 12.3117 16.5349 12.2217 16.075C11.9035 14.5017 10.6197 13.2492 9.04785 12.989C8.26187 12.8619 7.51155 12.971 6.85156 13.2615C6.44965 13.4367 6 13.1582 6 12.7166V10.8162C6.00005 9.60996 6.38904 8.79609 7.05664 8.31909C8.06899 7.33068 10.8056 5.10425 12 5.10425ZM9 9.24878C8.66877 9.24878 8.40062 9.51721 8.40039 9.84839C8.40039 10.1798 8.66863 10.449 9 10.449H15C15.3313 10.4489 15.5996 10.1797 15.5996 9.84839C15.5994 9.51724 15.3312 9.24883 15 9.24878H9Z"
        fill="white"
      />
    </svg>
  );
};

export const BounceCardIcon = ({
  className,
  color = "#FF947A",
}: {
  className?: string;
  color?: string;
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill={color} />
      <path
        d="M15.1541 7.44302H9.15405C7.35405 7.44302 6.15405 8.35078 6.15405 10.4689V12.3691C6.15405 12.8109 6.60405 13.0893 7.00605 12.9138C7.66605 12.6233 8.41605 12.5144 9.20205 12.6415C10.7741 12.9017 12.0581 14.1544 12.3761 15.7278C12.4661 16.1878 12.4781 16.6356 12.4181 17.0653C12.3701 17.4223 12.6581 17.737 13.0121 17.737H15.1541C16.9541 17.737 18.1541 16.8292 18.1541 14.7111V10.4689C18.1541 8.35078 16.9541 7.44302 15.1541 7.44302ZM15.4361 10.8259L13.5581 12.3389C13.1621 12.6596 12.6581 12.817 12.1541 12.817C11.6501 12.817 11.1401 12.6596 10.7501 12.3389L8.87205 10.8259C8.68005 10.6686 8.65005 10.3781 8.80005 10.1845C8.95605 9.9908 9.23805 9.95449 9.43005 10.1118L11.3081 11.6248C11.7641 11.9939 12.5381 11.9939 12.9941 11.6248L14.8721 10.1118C15.0641 9.95449 15.3521 9.98475 15.5021 10.1845C15.6581 10.3781 15.6281 10.6686 15.4361 10.8259Z"
        fill="white"
      />
      <path
        d="M10.7199 14.5008C10.1799 13.8805 9.37743 13.4947 8.49243 13.4947C6.83493 13.4947 5.49243 14.8488 5.49243 16.5206C5.49243 17.0879 5.64993 17.625 5.92743 18.0789C6.07743 18.3361 6.27243 18.5706 6.49743 18.7673C7.02243 19.2514 7.71993 19.5465 8.49243 19.5465C9.58743 19.5465 10.5399 18.9564 11.0574 18.0789C11.3349 17.625 11.4924 17.0879 11.4924 16.5206C11.4924 15.749 11.1999 15.0379 10.7199 14.5008ZM9.69243 17.7158C9.57993 17.8293 9.43743 17.8822 9.29493 17.8822C9.15243 17.8822 9.00993 17.8293 8.89743 17.7158L8.49993 17.3149L8.08743 17.7309C7.97493 17.8444 7.83243 17.8974 7.68993 17.8974C7.54743 17.8974 7.40493 17.8444 7.29243 17.7309C7.07493 17.5116 7.07493 17.1485 7.29243 16.9291L7.70493 16.513L7.30743 16.1121C7.08993 15.8927 7.08993 15.5296 7.30743 15.3103C7.52493 15.0909 7.88493 15.0909 8.10243 15.3103L8.49993 15.7112L8.87493 15.3329C9.09243 15.1136 9.45243 15.1136 9.66993 15.3329C9.88743 15.5523 9.88743 15.9154 9.66993 16.1348L9.29493 16.513L9.69243 16.914C9.90993 17.1333 9.90993 17.4889 9.69243 17.7158Z"
        fill="white"
      />
    </svg>
  );
};

export const IssueCardIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill="#96A5B8" />
      <path
        d="M18.7309 13.7153L14.3171 6.67301C13.724 5.72548 12.9033 5.20587 11.9998 5.20587C11.0963 5.20587 10.2757 5.72548 9.68255 6.67301L5.26872 13.7153C4.71009 14.6139 4.64802 15.4759 5.0963 16.1544C5.54458 16.833 6.42735 17.2059 7.58598 17.2059H16.4136C17.5723 17.2059 18.455 16.833 18.9033 16.1544C19.3516 15.4759 19.2895 14.6078 18.7309 13.7153ZM11.4826 9.48504C11.4826 9.2344 11.717 9.02655 11.9998 9.02655C12.2826 9.02655 12.517 9.2344 12.517 9.48504V12.5416C12.517 12.7922 12.2826 13.0001 11.9998 13.0001C11.717 13.0001 11.4826 12.7922 11.4826 12.5416V9.48504ZM12.4895 14.8095C12.455 14.834 12.4205 14.8584 12.386 14.8829C12.3446 14.9073 12.3033 14.9257 12.2619 14.9379C12.2205 14.9563 12.1791 14.9685 12.1308 14.9746C12.0895 14.9807 12.0412 14.9868 11.9998 14.9868C11.9584 14.9868 11.9101 14.9807 11.8619 14.9746C11.8205 14.9685 11.7791 14.9563 11.7377 14.9379C11.6964 14.9257 11.655 14.9073 11.6136 14.8829C11.5791 14.8584 11.5446 14.834 11.5101 14.8095C11.386 14.6934 11.3101 14.5345 11.3101 14.3755C11.3101 14.2166 11.386 14.0576 11.5101 13.9415C11.5446 13.917 11.5791 13.8926 11.6136 13.8681C11.655 13.8437 11.6964 13.8253 11.7377 13.8131C11.7791 13.7948 11.8205 13.7825 11.8619 13.7764C11.9515 13.7581 12.0481 13.7581 12.1308 13.7764C12.1791 13.7825 12.2205 13.7948 12.2619 13.8131C12.3033 13.8253 12.3446 13.8437 12.386 13.8681C12.4205 13.8926 12.455 13.917 12.4895 13.9415C12.6136 14.0576 12.6895 14.2166 12.6895 14.3755C12.6895 14.5345 12.6136 14.6934 12.4895 14.8095Z"
        fill="white"
      />
    </svg>
  );
};

export const OverviewCardIssueIcon = ({
  className,
  color = "#FA5A7D",
}: {
  className?: string;
  color?: string;
}) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="20" cy="20" r="20" fill={color} />
      <path
        d="M14 22.4914C16.77 22.4914 18.9999 24.7506 19 27.5343C19 30.3181 16.76 32.5773 14 32.5773C11.24 32.5773 9 30.3282 9 27.5343C9.00007 24.7405 11.24 22.4914 14 22.4914ZM14 28.55C13.4532 28.55 13.0098 28.9934 13.0098 29.5402C13.0098 30.0869 13.4533 30.5304 14 30.5304C14.5466 30.5303 14.9902 30.0868 14.9902 29.5402C14.9902 28.9935 14.5467 28.5501 14 28.55ZM14 23.9933C13.4528 23.9933 13.0088 24.4374 13.0088 24.9845V26.9279C13.009 27.4749 13.4529 27.9181 14 27.9181C14.5469 27.9179 14.9901 27.4748 14.9902 26.9279V24.9845C14.9902 24.4375 14.547 23.9936 14 23.9933Z"
        fill="white"
      />
      <path
        d="M25 12.4052H15C12 12.4052 10 13.9181 10 17.4483V20.6153C10 21.3516 10.75 21.8156 11.42 21.5231C12.52 21.039 13.77 20.8574 15.08 21.0692C17.7 21.5029 19.84 23.5908 20.37 26.2132C20.52 26.9797 20.54 27.7261 20.44 28.4422C20.36 29.0373 20.84 29.5618 21.43 29.5618H25C28 29.5618 30 28.0489 30 24.5187V17.4483C30 13.9181 28 12.4052 25 12.4052ZM25.47 18.0434L22.34 20.5649C21.68 21.0995 20.84 21.3617 20 21.3617C19.16 21.3617 18.31 21.0995 17.66 20.5649L14.53 18.0434C14.21 17.7811 14.16 17.297 14.41 16.9742C14.67 16.6515 15.14 16.5909 15.46 16.8532L18.59 19.3747C19.35 19.99 20.64 19.99 21.4 19.3747L24.53 16.8532C24.85 16.5909 25.33 16.6414 25.58 16.9742C25.84 17.297 25.79 17.7811 25.47 18.0434Z"
        fill="white"
      />
    </svg>
  );
};

export const BackToIndexIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.6425 0H4.3575C1.6275 0 0 1.6275 0 4.3575V10.635C0 13.3725 1.6275 15 4.3575 15H10.635C13.365 15 14.9925 13.3725 14.9925 10.6425V4.3575C15 1.6275 13.3725 0 10.6425 0ZM8.94 10.9725H5.25C4.9425 10.9725 4.6875 10.7175 4.6875 10.41C4.6875 10.1025 4.9425 9.8475 5.25 9.8475H8.94C9.9 9.8475 10.6875 9.0675 10.6875 8.1C10.6875 7.1325 9.9075 6.3525 8.94 6.3525H5.1375L5.3325 6.5475C5.55 6.765 5.55 7.125 5.3325 7.3425C5.22 7.455 5.0775 7.5075 4.935 7.5075C4.7925 7.5075 4.65 7.455 4.5375 7.3425L3.36 6.165C3.1425 5.9475 3.1425 5.5875 3.36 5.37L4.5375 4.1925C4.755 3.975 5.115 3.975 5.3325 4.1925C5.55 4.41 5.55 4.77 5.3325 4.9875L5.0775 5.235H8.94C10.5225 5.235 11.8125 6.525 11.8125 8.1075C11.8125 9.69 10.5225 10.9725 8.94 10.9725Z"
        fill="#336DFF"
      />
    </svg>
  );
};
